  /* ============================================
     QUESTIONNAIRE JS - INITIALISATION
     ============================================ */
  
  /**
   * Cache DOM pour éviter les requêtes répétées
   * Améliore les performances en stockant les éléments fréquemment utilisés
   */
  const DOMCache = {};
  
  /**
   * Initialise le cache DOM avec les éléments les plus utilisés
   */
  function initDOMCache() {
    DOMCache.progressBarFill = document.getElementById('progress-bar-fill');
    DOMCache.progressTitle = document.getElementById('progress-title');
    DOMCache.progressCounter = document.getElementById('progress-counter');
    DOMCache.weddingDateInput = document.getElementById('wedding-date');
    DOMCache.validateStep1 = document.getElementById('validate-step-1');
    DOMCache.validateStep2 = document.getElementById('validate-step-2');
    DOMCache.validateStep3 = document.getElementById('validate-step-3');
    DOMCache.validateStep4 = document.getElementById('validate-step-4');
    DOMCache.validateStep5 = document.getElementById('validate-step-5');
    DOMCache.validateStep6 = document.getElementById('validate-step-6');
    DOMCache.validateStep7 = document.getElementById('validate-step-7');
    DOMCache.validateStep9 = document.getElementById('validate-step-9');
    DOMCache.validateStep10 = document.getElementById('validate-step-10');
    DOMCache.validateStep11 = document.getElementById('validate-step-11');
    DOMCache.validateStep12 = document.getElementById('validate-step-12');
    DOMCache.validateStep13 = document.getElementById('validate-step-13');
    DOMCache.validateStep14 = document.getElementById('validate-step-14');
    DOMCache.validateStep15 = document.getElementById('validate-step-15');
  }
  
  document.addEventListener('DOMContentLoaded', function() {
    // Initialiser le cache DOM en premier
    initDOMCache();
    
    // Ajouter une classe au body pour cacher le header standard
    document.body.classList.add('has-questionnaire');

    /* Bloquer toute soumission native du formulaire compte (évite redirection Shopify) */
    document.addEventListener('submit', function(e) {
      const form = e.target;
      if (!form || form.id !== 'questionnaire-create-account-form') {
        return;
      }
      e.preventDefault();
      e.stopImmediatePropagation();
      if (typeof window.__questionnaireGoToSummary === 'function') {
        window.__questionnaireGoToSummary();
      }
    }, true);

    document.addEventListener('click', function(e) {
      const btn = e.target.closest('#create-account-btn');
      if (!btn) {
        return;
      }
      e.preventDefault();
      e.stopPropagation();
      if (btn.disabled) {
        return;
      }
      if (typeof window.__questionnaireGoToSummary === 'function') {
        window.__questionnaireGoToSummary();
      }
    }, true);

    /**
     * Si Liquid n'a pas généré les vignettes (data-image-count="0") mais que le JSON
     * univers-floral-data contient des URLs, injecter les images côté client.
     */
    function hydrateUniversImagesFromJson() {
      const dataEl = document.getElementById('univers-floral-data');
      if (!dataEl) return;
      let data;
      try {
        data = JSON.parse(dataEl.textContent);
      } catch (e) {
        console.error('univers-floral-data invalide:', e);
        return;
      }
      const items = (data && data.items) || {};
      document.querySelectorAll('.univers-item[data-univers-id]').forEach(function(universEl) {
        const id = universEl.getAttribute('data-univers-id');
        const item = items[id];
        if (!item || !item.thumb) return;
        const imageCount = parseInt(universEl.getAttribute('data-image-count'), 10) || 0;
        if (imageCount > 0) return;
        const placeholder = universEl.querySelector('.univers-item-placeholder');
        if (!placeholder) return;

        const title = universEl.getAttribute('data-univers-title') || item.title || '';
        const imagesList = Array.isArray(item.images) ? item.images : [];
        const imagesJoined = imagesList.join('|||');
        const lightboxSrc = imagesList.length ? imagesList[imagesList.length - 1] : item.thumb;

        universEl.setAttribute('data-univers-images', imagesJoined);
        universEl.setAttribute('data-image-count', String(item.imageCount || imagesList.length || 1));

        const imageWrap = document.createElement('div');
        imageWrap.className = 'univers-item-image';
        const safeTitle = title.replace(/"/g, '&quot;');
        imageWrap.innerHTML =
          '<img src="' + item.thumb + '" srcset="' + item.thumb + ' 400w" sizes="400px" alt="' + safeTitle + '" loading="eager" decoding="async" data-lightbox-src="' + lightboxSrc + '"/>' +
          '<div class="univers-item-overlay">' +
          '<svg class="svg-icon" width="30" height="30" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2">' +
          '<polyline points="20 6 9 17 4 12"></polyline></svg></div>' +
          '<button type="button" class="image-zoom-btn" data-lightbox-src="' + lightboxSrc + '" aria-label="Agrandir l\'image">' +
          '<svg class="svg-icon" width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round">' +
          '<circle cx="12" cy="12" r="10"></circle><path d="M9.09 9a3 3 0 0 1 5.83 1c0 2-3 3-3 3"></path>' +
          '<line x1="12" y1="17" x2="12.01" y2="17"></line></svg></button>';
        placeholder.replaceWith(imageWrap);
      });
    }

    hydrateUniversImagesFromJson();

    let questionnaireMediaCache = null;

    function getQuestionnaireMediaData() {
      if (questionnaireMediaCache) {
        return questionnaireMediaCache;
      }
      if (window.__QUESTIONNAIRE_MEDIA__) {
        questionnaireMediaCache = window.__QUESTIONNAIRE_MEDIA__;
        return questionnaireMediaCache;
      }
      const el = document.getElementById('questionnaire-media-data');
      if (!el) {
        return null;
      }
      try {
        questionnaireMediaCache = JSON.parse(el.textContent);
        window.__QUESTIONNAIRE_MEDIA__ = questionnaireMediaCache;
      } catch (e) {
        console.error('[Questionnaire] questionnaire-media-data invalide:', e);
        questionnaireMediaCache = null;
      }
      return questionnaireMediaCache;
    }

    function preloadQuestionnaireMediaFromJson() {
      const data = getQuestionnaireMediaData();
      if (!data) {
        return;
      }
      const seen = Object.create(null);
      function add(url) {
        if (!url || typeof url !== 'string') {
          return;
        }
        const u = url.trim();
        if (!u || u.indexOf('http') !== 0 || seen[u]) {
          return;
        }
        seen[u] = true;
        const img = new Image();
        img.decoding = 'async';
        img.src = u;
      }
      function addList(list) {
        if (!list || !list.length) {
          return;
        }
        list.forEach(add);
      }
      Object.keys(data.stepVisuals || {}).forEach(function(key) {
        add(data.stepVisuals[key]);
      });
      Object.keys(data.steps || {}).forEach(function(stepKey) {
        const step = data.steps[stepKey];
        if (!step) {
          return;
        }
        Object.keys(step).forEach(function(field) {
          add(step[field]);
        });
      });
      Object.keys(data.archeColors || {}).forEach(function(colorName) {
        const color = data.archeColors[colorName];
        if (!color) {
          return;
        }
        add(color.thumb);
        addList(color.images);
      });
      Object.keys(data.supportArche || {}).forEach(function(supportId) {
        const support = data.supportArche[supportId];
        if (!support) {
          return;
        }
        addList(support.images);
        addList(support.thumbs);
      });
    }

    window.preloadQuestionnaireMediaFromJson = preloadQuestionnaireMediaFromJson;

    function runWhenSwiperReady(callback, maxAttempts) {
      const limit = maxAttempts || 80;
      let attempts = 0;
      function tryRun() {
        attempts++;
        if (typeof Swiper !== 'undefined') {
          callback(true);
          return;
        }
        if (attempts < limit) {
          setTimeout(tryRun, 50);
        } else {
          callback(false);
        }
      }
      tryRun();
    }

    function forceLoadQuestionnaireImage(img, url, lightboxUrl) {
      if (!img || !url) {
        return;
      }
      img.loading = 'eager';
      img.classList.remove('lazyload', 'lazyloaded', 'lazyloading');
      img.removeAttribute('data-src');
      img.removeAttribute('data-srcset');
      img.setAttribute('data-fallback-src', lightboxUrl || url);
      img.removeAttribute('srcset');
      img.src = url;
      if (lightboxUrl) {
        img.setAttribute('data-lightbox-src', lightboxUrl);
        const zoomBtn = img.closest('.table-honneur-image, .swiper-slide') &&
          img.closest('.table-honneur-image, .swiper-slide').querySelector('.image-zoom-btn');
        if (zoomBtn) {
          zoomBtn.setAttribute('data-lightbox-src', lightboxUrl);
        }
      }
    }

    function isQuestionnaireSwiperImageWrap(wrap) {
      if (!wrap) {
        return false;
      }
      return (
        wrap.classList.contains('arche-color-image-swiper-container') ||
        wrap.classList.contains('support-image-swiper-container') ||
        wrap.classList.contains('step9-sub-swiper-container') ||
        !!wrap.closest('.arche-color-galleries, .support-arche-galleries')
      );
    }

    function getQuestionnaireZoomIconSvg(optionEl) {
      const optionId = optionEl && optionEl.id;
      const useSearchIcon =
        optionId === 'table-honneur-artificial' ||
        optionId === 'arche-artificial' ||
        optionId === 'step11-artificial-option';
      if (useSearchIcon) {
        return (
          '<svg class="svg-icon" width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round">' +
          '<circle cx="11" cy="11" r="7"></circle>' +
          '<line x1="16.65" y1="16.65" x2="21" y2="21"></line>' +
          '</svg>'
        );
      }
      return (
        '<svg class="svg-icon" width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round">' +
        '<circle cx="12" cy="12" r="10"></circle>' +
        '<path d="M9.09 9a3 3 0 0 1 5.83 1c0 2-3 3-3 3"></path>' +
        '<line x1="12" y1="17" x2="12.01" y2="17"></line>' +
        '</svg>'
      );
    }

    function ensureTableHonneurImage(optionEl, url, lightboxUrl) {
      if (!optionEl || !url) {
        return null;
      }
      if (optionEl.id === 'support-product-display') {
        return null;
      }
      let wrap = optionEl.querySelector(
        '.table-honneur-image:not(#support-static-preview):not(.support-image-swiper-container):not(.step9-sub-swiper-container):not(.arche-color-image-swiper-container)'
      );
      if (!wrap) {
        wrap = optionEl.querySelector('.table-honneur-image');
      }
      if (wrap && isQuestionnaireSwiperImageWrap(wrap)) {
        const swiperImg = wrap.querySelector('img');
        if (swiperImg) {
          forceLoadQuestionnaireImage(swiperImg, url, lightboxUrl || url);
        }
        const swiperZoomBtn = wrap.querySelector('.image-zoom-btn');
        if (swiperZoomBtn) {
          swiperZoomBtn.setAttribute('data-lightbox-src', lightboxUrl || url);
        }
        return swiperImg;
      }
      if (!wrap) {
        wrap = document.createElement('div');
        wrap.className = 'table-honneur-image';
        const insertBefore = optionEl.querySelector('.table-honneur-title') ||
          optionEl.querySelector('.table-honneur-difficulty') ||
          optionEl.querySelector('.table-honneur-color-selector');
        if (insertBefore) {
          optionEl.insertBefore(wrap, insertBefore);
        } else {
          optionEl.prepend(wrap);
        }
      }
      let img = wrap.querySelector('img');
      if (!img) {
        const zoomIcon = getQuestionnaireZoomIconSvg(optionEl);
        wrap.innerHTML =
          '<img alt="" loading="eager" decoding="async"/>' +
          '<div class="table-honneur-overlay">' +
          '<svg class="svg-icon" width="30" height="30" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2">' +
          '<polyline points="20 6 9 17 4 12"></polyline></svg></div>' +
          '<button type="button" class="image-zoom-btn" aria-label="Agrandir l\'image">' +
          zoomIcon +
          '</button>';
        img = wrap.querySelector('img');
      }
      let zoomBtn = wrap.querySelector('.image-zoom-btn');
      if (!zoomBtn) {
        zoomBtn = document.createElement('button');
        zoomBtn.type = 'button';
        zoomBtn.className = 'image-zoom-btn';
        zoomBtn.setAttribute('aria-label', 'Agrandir l\'image');
        zoomBtn.innerHTML = getQuestionnaireZoomIconSvg(optionEl);
        wrap.appendChild(zoomBtn);
      }
      zoomBtn.setAttribute('data-lightbox-src', lightboxUrl || url);
      forceLoadQuestionnaireImage(img, url, lightboxUrl || url);
      return img;
    }

    function primeImagesInRoot(root) {
      if (!root) {
        return;
      }
      root.querySelectorAll('.image-zoom-btn').forEach(function(btn) {
        if (btn.getAttribute('data-lightbox-src')) {
          return;
        }
        const host = btn.closest('.swiper-slide, .table-honneur-image, .univers-item-image, .decoration-item-image, .yes-no-image');
        const hostImg = host && host.querySelector('img');
        const hostSrc = hostImg && (
          hostImg.getAttribute('data-lightbox-src') ||
          hostImg.getAttribute('data-fallback-src') ||
          hostImg.getAttribute('src')
        );
        if (hostSrc) {
          btn.setAttribute('data-lightbox-src', hostSrc);
        }
      });
      root.querySelectorAll('img').forEach(function(img) {
        const src =
          img.getAttribute('data-fallback-src') ||
          img.getAttribute('src') ||
          img.getAttribute('data-lightbox-src');
        if (!src || src.indexOf('data:') === 0) {
          return;
        }
        forceLoadQuestionnaireImage(img, src, img.getAttribute('data-lightbox-src') || src);
      });
    }

    function reloadStepImages(stepEl) {
      if (!stepEl) {
        return;
      }
      stepEl.querySelectorAll('img').forEach(function(img) {
        const src =
          img.getAttribute('src') ||
          img.getAttribute('data-src') ||
          img.getAttribute('data-fallback-src') ||
          img.getAttribute('data-lightbox-src');
        if (!src || src.indexOf('data:') === 0) {
          return;
        }
        img.loading = 'eager';
        img.classList.remove('lazyload', 'lazyloaded', 'lazyloading');
        img.removeAttribute('data-src');
        if (img.complete && img.naturalWidth > 0) {
          return;
        }
        const current = img.getAttribute('src') || '';
        if (current === src) {
          const bust = (src.indexOf('?') === -1 ? '?' : '&') + '_qrb=' + Date.now();
          img.src = src + bust;
          return;
        }
        img.src = src;
      });
    }

    function hydrateArcheColorSlides(archeColors) {
      if (!archeColors) {
        return;
      }
      Object.keys(archeColors).forEach(function(colorName) {
        const colorData = archeColors[colorName];
        const images = (colorData && colorData.images) || [];
        const thumb = (colorData && colorData.thumb) || images[0];
        if (!thumb && !images.length) {
          return;
        }
        const slides = document.querySelectorAll(
          '.arche-color-slide[data-color-name="' + CSS.escape(colorName) + '"]'
        );
        slides.forEach(function(slide, index) {
          const img = slide.querySelector('img');
          const displayUrl = images[index] || thumb;
          const lightboxUrl = images[index] || images[images.length - 1] || thumb;
          if (img && displayUrl) {
            const display600 = displayUrl.indexOf('width=') !== -1
              ? displayUrl.replace(/width=\d+/, 'width=600')
              : displayUrl;
            forceLoadQuestionnaireImage(img, display600, lightboxUrl);
          }
        });
      });
    }

    function getColorImagesFromSelect(selectEl, colorName) {
      if (!selectEl || !colorName) {
        return [];
      }
      const option = Array.from(selectEl.options).find(function(opt) {
        return opt.value === colorName;
      });
      if (!option) {
        return [];
      }
      const raw = option.getAttribute('data-color-images') || '';
      return raw.split('|||').map(function(u) { return u.trim(); }).filter(Boolean);
    }

    function getAccessoryColorsFromSelect(card) {
      const colors = {};
      const select = card && card.querySelector('.accessories-color-select');
      if (!select) {
        return colors;
      }
      Array.from(select.options).forEach(function(opt) {
        if (!opt.value) {
          return;
        }
        const images = getColorImagesFromSelect(select, opt.value);
        colors[opt.value] = {
          price: parseFloat(opt.getAttribute('data-price')) || 0,
          images: images,
          imageCount: images.length
        };
      });
      return colors;
    }

    function fixBrokenImagesInStep(stepEl) {
      if (!stepEl) {
        return;
      }
      stepEl.querySelectorAll('img').forEach(function(img) {
        const fallback =
          img.getAttribute('data-fallback-src') ||
          img.getAttribute('data-lightbox-src') ||
          img.getAttribute('data-src');
        if (!fallback) {
          return;
        }
        const current = img.getAttribute('src') || '';
        if (!current || current.indexOf('data:') === 0) {
          forceLoadQuestionnaireImage(img, fallback, img.getAttribute('data-lightbox-src') || fallback);
          return;
        }
        if (img.complete && img.naturalWidth === 0) {
          forceLoadQuestionnaireImage(img, fallback, img.getAttribute('data-lightbox-src') || fallback);
        }
      });
    }

    function getAccessoryColorsForCard(accessoryId, card) {
      const fromSelect = getAccessoryColorsFromSelect(card);
      if (Object.keys(fromSelect).length > 0) {
        return fromSelect;
      }
      const media = getQuestionnaireMediaData();
      if (media && media.accessories && media.accessories[accessoryId]) {
        const colors = {};
        const acc = media.accessories[accessoryId];
        Object.keys(acc.colors || {}).forEach(function(colorName) {
          const colorEntry = acc.colors[colorName];
          const images = colorEntry.images || [];
          colors[colorName] = {
            price: parseFloat(colorEntry.price) || 0,
            images: images,
            imageCount: images.length
          };
        });
        if (Object.keys(colors).length > 0) {
          return colors;
        }
      }
      if (card) {
        return parseAccessoryColors(card.getAttribute('data-accessory-colors'));
      }
      return {};
    }

    function applyAccessoryCardImage(accessoryCard, imageUrls) {
      if (!accessoryCard || !imageUrls || !imageUrls.length) {
        return;
      }
      const thumb = resizeShopifyImageUrl(imageUrls[0], 400) || imageUrls[0];
      const lb = imageUrls[imageUrls.length - 1] || thumb;
      const wrap = accessoryCard.querySelector('.accessory-item-image, .container-item-image');
      const img = wrap && wrap.querySelector('img');
      if (!img) {
        ensureTableHonneurImage(accessoryCard, thumb, lb);
        return;
      }
      forceLoadQuestionnaireImage(img, thumb, lb);
      const zoom = accessoryCard.querySelector('.image-zoom-btn');
      if (zoom) {
        zoom.setAttribute('data-lightbox-src', lb);
      }
    }

    function hydrateStep12Accessories(accessories) {
      if (!accessories) {
        return;
      }
      document.querySelectorAll('.step12-accessories-option').forEach(function(card) {
        const accessoryId = card.getAttribute('data-accessory-id');
        const accData = accessories[accessoryId];
        if (!accData || !accData.colors) {
          return;
        }

        let firstColorName = card.getAttribute('data-accessory-first-color') || '';
        let firstImages = (card.getAttribute('data-accessory-first-images') || '')
          .split('|||')
          .filter(Boolean);
        let firstPrice = card.getAttribute('data-accessory-first-price') || '0';

        if (!firstImages.length) {
          Object.keys(accData.colors).some(function(colorName) {
            const colorEntry = accData.colors[colorName];
            if (colorEntry.images && colorEntry.images.length) {
              firstColorName = colorName;
              firstImages = colorEntry.images;
              firstPrice = colorEntry.price || '0';
              return true;
            }
            return false;
          });
        }

        if (firstImages.length) {
          card.setAttribute('data-accessory-first-color', firstColorName);
          card.setAttribute('data-accessory-first-images', firstImages.join('|||'));
          card.setAttribute('data-accessory-first-count', String(firstImages.length));
          card.setAttribute('data-accessory-first-price', firstPrice);
          const select = card.querySelector('.accessories-color-select');
          if (select && firstColorName) {
            select.value = firstColorName;
          }
          applyAccessoryCardImage(card, firstImages);
        }
      });
    }

    function primeFlowerImagesInRoot(root) {
      if (!root) {
        return;
      }
      root.querySelectorAll('img').forEach(function(img) {
        const src = img.getAttribute('src') || img.getAttribute('data-fallback-src');
        if (!src || src.indexOf('data:') === 0) {
          return;
        }
        img.loading = 'eager';
        img.decoding = 'async';
        if (!img.getAttribute('data-fallback-src')) {
          img.setAttribute('data-fallback-src', src);
        }
        forceLoadQuestionnaireImage(img, src, img.getAttribute('data-lightbox-src') || src);
      });
    }

    const STEP_VISUAL_SELECTORS = {
      9: {
        step9_fresh: '#table-honneur-fresh',
        step9_artificial: '#table-honneur-artificial',
        step9_fresh_sub_1: '#fresh-suboption-1',
        step9_fresh_sub_2: '#fresh-suboption-2',
        step9_fresh_sub_3: '#fresh-suboption-3',
        step9_fresh_sub_4: '#fresh-suboption-4'
      },
      10: {
        step10_arch_fresh: '#arche-fresh',
        step10_arch_artificial: '#arche-artificial'
      },
      11: {
        step11_fresh: '#step11-fresh-option',
        step11_artificial: '#step11-artificial-option'
      }
    };

    function hydrateStepVisualsByKey(stepEl, stepNumber) {
      if (!stepEl) {
        return;
      }

      stepEl.querySelectorAll('[data-q-thumb]').forEach(function(optionEl) {
        if (optionEl.hasAttribute('data-step9-images-full')) {
          return;
        }
        const thumbUrl = optionEl.getAttribute('data-q-thumb');
        const fullUrl = optionEl.getAttribute('data-q-full') || thumbUrl;
        if (thumbUrl) {
          ensureTableHonneurImage(optionEl, thumbUrl, fullUrl);
        }
      });

      const data = getQuestionnaireMediaData();
      if (!data) {
        return;
      }
      const visuals = data.stepVisuals;
      const selectors = STEP_VISUAL_SELECTORS[stepNumber];
      if (visuals && selectors) {
        Object.keys(selectors).forEach(function(visualKey) {
          const url = visuals[visualKey];
          if (!url) {
            return;
          }
          const optionEl = stepEl.querySelector(selectors[visualKey]);
          if (optionEl) {
            if (optionEl.hasAttribute('data-step9-images-full')) {
              return;
            }
            const thumbUrl = resizeShopifyImageUrl(url, 600) || url;
            ensureTableHonneurImage(optionEl, thumbUrl, url);
          }
        });
      }
      const stepUrls = (data.steps && data.steps[String(stepNumber)]) ? data.steps[String(stepNumber)] : null;
      if (!stepUrls) {
        return;
      }
      if (stepNumber === 9) {
        if (stepUrls.fresh) {
          ensureTableHonneurImage(stepEl.querySelector('#table-honneur-fresh'), stepUrls.fresh, stepUrls.fresh);
        }
        if (stepUrls.artificial) {
          ensureTableHonneurImage(stepEl.querySelector('#table-honneur-artificial'), stepUrls.artificial, stepUrls.artificial);
        }
        if (!stepUrls.artificial && !stepUrls.fresh) {
          const fallbackStep9Url = 'https://dev.flor-easy.com/cdn/shop/files/21_d68d2cf1-3699-4d76-ada9-92670901a041.jpg?v=1779093300&width=1200';
          ensureTableHonneurImage(
            stepEl.querySelector('#table-honneur-fresh'),
            fallbackStep9Url,
            fallbackStep9Url
          );
        }
      }
      if (stepNumber === 10) {
        if (stepUrls.archFresh) {
          const freshOpt = stepEl.querySelector('#arche-fresh') || stepEl.querySelector('.fresh-option');
          ensureTableHonneurImage(freshOpt, stepUrls.archFresh, stepUrls.archFresh);
        }
        if (stepUrls.archArtificial) {
          ensureTableHonneurImage(stepEl.querySelector('#arche-artificial'), stepUrls.archArtificial, stepUrls.archArtificial);
        }
      }
      if (stepNumber === 11) {
        if (stepUrls.fresh) {
          ensureTableHonneurImage(stepEl.querySelector('#step11-fresh-option'), stepUrls.fresh, stepUrls.fresh);
        }
        if (stepUrls.artificial) {
          ensureTableHonneurImage(
            stepEl.querySelector('#step11-artificial-option'),
            stepUrls.artificial,
            stepUrls.artificial
          );
        }
      }
      if (stepNumber === 9 && typeof initStep9SubSwipers === 'function') {
        initStep9SubSwipers(stepEl);
      }
    }

    function hydrateQuestionnaireStepMedia(stepNumber) {
      const stepEl = document.querySelector('[data-step="' + stepNumber + '"]');
      if (!stepEl) {
        return;
      }

      const data = getQuestionnaireMediaData();
      if (data) {
        if (stepNumber === 9 || stepNumber === 10 || stepNumber === 11) {
          hydrateStepVisualsByKey(stepEl, stepNumber);
        }

        if (stepNumber === 10 && data.archeColors) {
          hydrateArcheColorSlides(data.archeColors);
        }
        if (stepNumber === 12 && data.accessories) {
          hydrateStep12Accessories(data.accessories);
        }
      }

      reloadStepImages(stepEl);
      if (stepNumber === 12) {
        document.querySelectorAll('.step12-accessories-option').forEach(function(card) {
          const urls = (card.getAttribute('data-accessory-first-images') || '')
            .split('|||')
            .filter(Boolean);
          if (urls.length) {
            applyAccessoryCardImage(card, urls);
          }
        });
      }
      if (stepNumber === 16) {
        primeFlowerImagesInRoot(stepEl);
      }
    }

    function resizeShopifyImageUrl(url, width) {
      if (!url || typeof url !== 'string') {
        return '';
      }
      if (url.indexOf('width=') !== -1) {
        return url.replace(/width=\d+/, 'width=' + width);
      }
      return url;
    }

    function scheduleSwiperUpdates(stepEl) {
      function tick() {
        const root = stepEl || document;
        root.querySelectorAll('.swiper').forEach(function(el) {
          if (el.swiper && typeof el.swiper.update === 'function') {
            el.swiper.update();
          }
        });
      }
      requestAnimationFrame(function() {
        requestAnimationFrame(tick);
      });
      setTimeout(tick, 200);
      setTimeout(tick, 550);
    }

    function hydrateSupportOptionsFromJson() {
      const data = getQuestionnaireMediaData();
      if (!data || !data.supportArche) {
        return;
      }
      const select = document.getElementById('support-product-select');
      if (!select) {
        return;
      }
      select.querySelectorAll('option[data-support-id]').forEach(function(option) {
        const supportId = option.getAttribute('data-support-id');
        const entry = data.supportArche[supportId];
        if (!entry || !entry.images || !entry.images.length) {
          return;
        }
        if (!option.getAttribute('data-support-images')) {
          option.setAttribute('data-support-images', entry.images.join('|||'));
        }
        const thumbs = entry.thumbs && entry.thumbs.length ? entry.thumbs : entry.images;
        if (!option.getAttribute('data-support-images-thumb')) {
          option.setAttribute('data-support-images-thumb', thumbs.join('|||'));
        }
        if (!option.getAttribute('data-support-main-thumb')) {
          option.setAttribute('data-support-main-thumb', thumbs[0] || entry.images[0] || '');
        }
        if (!option.getAttribute('data-support-image-count')) {
          option.setAttribute('data-support-image-count', String(entry.images.length));
        }
      });
      if (typeof window.refreshSupportCustomSelectThumbs === 'function') {
        window.refreshSupportCustomSelectThumbs();
      }
    }

    const stepMediaInitStamps = {};
    const STEP_MEDIA_INIT_COOLDOWN_MS = 450;

    function initQuestionnaireMediaRobust(stepNumber) {
      const now = Date.now();
      const lastInit = stepMediaInitStamps[stepNumber] || 0;
      // Evite les doubles initialisations rapprochées (showStep + observer + retries)
      if (now - lastInit < STEP_MEDIA_INIT_COOLDOWN_MS) {
        return;
      }
      stepMediaInitStamps[stepNumber] = now;

      if (stepNumber === 13) {
        const step13El = document.querySelector('[data-step="13"]');
        if (step13El) {
          reloadStepImages(step13El);
          fixBrokenImagesInStep(step13El);
          bindStep13ProductZoomButtons(step13El);
        }
        return;
      }

      hydrateQuestionnaireStepMedia(stepNumber);
      hydrateSupportOptionsFromJson();

      const stepEl = document.querySelector('[data-step="' + stepNumber + '"]');
      if (!stepEl) {
        return;
      }

      primeImagesInRoot(stepEl);
      fixBrokenImagesInStep(stepEl);

      function runStepMediaSwipers(swiperReady) {
        try {
          primeImagesInRoot(stepEl);
          if (typeof window.__questionnaireMediaSimpleBoot === 'function') {
            window.__questionnaireMediaSimpleBoot();
          }
          if (stepNumber === 9 && typeof initStep9SubSwipers === 'function') {
            initStep9SubSwipers(stepEl);
          }
          if (stepNumber === 10) {
            const archeSelect = document.getElementById('arche-color');
            let colorName = archeSelect && archeSelect.value;
            if (typeof initArcheColorSwiper === 'function') {
              initArcheColorSwiper();
            } else if (colorName && typeof window.__rebuildArcheColorSwiper === 'function') {
              window.__rebuildArcheColorSwiper(colorName);
            } else if (colorName && typeof window.__setArcheColorStaticPreview === 'function') {
              window.__setArcheColorStaticPreview(colorName);
            } else if (!swiperReady) {
              showArcheArtificialMainImage();
            }
            if (typeof initSupportSwipers === 'function') {
              initSupportSwipers();
            }
          }
          if (stepNumber === 12 && typeof initStep12AccessorySwipers === 'function') {
            initStep12AccessorySwipers();
          }
        } catch (err) {
          console.error('[Questionnaire] runStepMediaSwipers:', err);
        }
        fixBrokenImagesInStep(stepEl);
        scheduleSwiperUpdates(stepEl);
      }

      runWhenSwiperReady(runStepMediaSwipers);
      setTimeout(function() {
        primeImagesInRoot(stepEl);
        fixBrokenImagesInStep(stepEl);
        scheduleSwiperUpdates(stepEl);
      }, 350);
    }

    window.primeImagesInRoot = primeImagesInRoot;
    window.hydrateQuestionnaireStepMedia = hydrateQuestionnaireStepMedia;
    window.initQuestionnaireMediaRobust = initQuestionnaireMediaRobust;
    window.getAccessoryColorsForCard = getAccessoryColorsForCard;
    window.resizeShopifyImageUrl = resizeShopifyImageUrl;

    // Initialiser la barre de progression à l'étape 1
    const progressBarFillInit = DOMCache.progressBarFill || getElement('progress-bar-fill');
    if (progressBarFillInit) {
      const progressStepsContainer = progressBarFillInit.parentElement;
      if (progressStepsContainer) {
        progressBarFillInit.style.width = '0px';
      } else {
        progressBarFillInit.style.width = '0%';
      }
    }

    /* ============================================
       LIGHTBOX POUR LES IMAGES
       ============================================ */
    // Lightbox pour les images
    const lightbox = getElement('questionnaire-image-lightbox');
    const lightboxImage = getElement('lightbox-image');
    const lightboxClose = getElement('lightbox-close');
    const lightboxOverlay = lightbox ? query('.lightbox-overlay', lightbox) : null;

    function getUncroppedImageUrl(rawUrl) {
      if (!rawUrl || typeof rawUrl !== 'string') return rawUrl;
      let url = rawUrl.trim().replace(/&amp;/g, '&');

      // Supprimer les suffixes de recadrage Shopify qui provoquent un effet "zoom".
      url = url.replace(/_\d+x\d+_crop_center(?=\.)/i, '');
      url = url.replace(/_crop_center(?=\.)/i, '');
      // Supprimer aussi les suffixes de taille Shopify (_1200x1200, _1200x, _x1200, etc.)
      // pour récupérer l'image source non recadrée.
      url = url.replace(/_\d+x\d+(?=\.)/i, '');
      url = url.replace(/_\d+x(?=\.)/i, '');
      url = url.replace(/_x\d+(?=\.)/i, '');

      // Nettoyer les paramètres de transformation si présents dans la query string.
      url = url.replace(/([?&])width=\d+(&|$)/i, '$1');
      url = url.replace(/([?&])height=\d+(&|$)/i, '$1');
      url = url.replace(/([?&])crop=[^&]*(&|$)/i, '$1');
      url = url.replace(/\?&/, '?').replace(/&&/g, '&').replace(/[?&]$/, '');

      return url;
    }

    function openLightbox(imageSrc) {
      if (lightbox && lightboxImage) {
        lightboxImage.src = getUncroppedImageUrl(imageSrc);
        lightbox.classList.add('active');
        document.body.style.overflow = 'hidden';
      }
    }

    function closeLightbox() {
      if (lightbox) {
        lightbox.classList.remove('active');
        document.body.style.overflow = '';
      }
    }

    // Fonction pour gérer le clic sur les boutons de zoom (utilisée pour délégation d'événements)
    function handleZoomButtonClick(e) {
      e.stopPropagation();
      // Pour les boutons zoom dans les univers (étape 2), ouvrir la modal galerie
      const universItem = this.closest('.univers-item');
      if (universItem) {
        // Ne pas ouvrir si l'univers n'est pas disponible
        if (!universItem.classList.contains('unavailable')) {
          // Ouvrir la modal galerie directement
          openUniversGallery(universItem);
        }
        return;
      }
      // Pour les boutons zoom dans les décorations (étape 7), ouvrir la modal galerie
      const decorationItem = this.closest('.decoration-item');
      if (decorationItem) {
        // Ouvrir la modal galerie directement
        openDecorationGallery(decorationItem);
        return;
      }
      // Pour le produit frais de l'étape 10, ouvrir la modal galerie (style mobile)
      const step10ArcheFresh = this.closest('#arche-fresh');
      if (step10ArcheFresh) {
        openStep10ArcheFreshGallery(step10ArcheFresh);
        return;
      }
      // Pour le produit artificiel de l'étape 10, ouvrir la modal galerie (style mobile)
      const step10ArcheArtificial = this.closest('#arche-artificial');
      if (step10ArcheArtificial) {
        openStep10ArcheArtificialGallery(step10ArcheArtificial);
        return;
      }
      // Pour le produit frais de l'étape 11, ouvrir la modal galerie (style mobile)
      const step11ChairFresh = this.closest('#step11-fresh-option');
      if (step11ChairFresh) {
        openStep11ChairFreshGallery(step11ChairFresh);
        return;
      }
      // Pour le produit artificiel de l'étape 11, ouvrir la modal galerie (style mobile)
      const step11ChairArtificial = this.closest('#step11-artificial-option');
      if (step11ChairArtificial) {
        openStep11ChairArtificialGallery(step11ChairArtificial);
        return;
      }
      // Pour les cartes produit étape 13 (contenants / sacs cadeaux), ouvrir la modal galerie
      const step13ContainerItem = this.closest('.container-item');
      if (step13ContainerItem) {
        openProductCardGallery(step13ContainerItem, '.container-item-label');
        return;
      }
      const step13GiftBagItem = this.closest('.gift-bag-item');
      if (step13GiftBagItem) {
        openProductCardGallery(step13GiftBagItem, '.gift-bag-item-label');
        return;
      }
      // Pour les boutons zoom dans les sous-options fraîches (étape 9), ouvrir la modal galerie
      const step9Suboption = this.closest('.table-honneur-suboption');
      if (step9Suboption) {
        openStep9SuboptionGallery(step9Suboption);
        return;
      }
      // Pour les autres boutons zoom, ouvrir la lightbox simple
      let imageSrc = this.getAttribute('data-lightbox-src');
      if (!imageSrc) {
        const host = this.closest('.swiper-slide, .table-honneur-image, .univers-item-image, .decoration-item-image, .yes-no-image');
        const hostImg = host && host.querySelector('img');
        imageSrc = hostImg && (
          hostImg.getAttribute('data-lightbox-src') ||
          hostImg.getAttribute('data-fallback-src') ||
          hostImg.getAttribute('src')
        );
        if (imageSrc) {
          this.setAttribute('data-lightbox-src', imageSrc);
        }
      }
      if (imageSrc) {
        openLightbox(imageSrc);
      }
    }

    let lastSwiperZoomTouchAt = 0;

    function bindStep9ZoomButtons(root) {
      const scope = root || document;
      scope.querySelectorAll('.step9-sub-swiper .image-zoom-btn').forEach(function(btn) {
        if (btn.dataset.step9ZoomBound === '1') return;
        btn.dataset.step9ZoomBound = '1';
        btn.classList.add('swiper-no-swiping');

        btn.addEventListener('touchstart', function(e) {
          e.stopPropagation();
        }, { passive: true });

        btn.addEventListener('touchend', function(e) {
          lastSwiperZoomTouchAt = Date.now();
          e.preventDefault();
          e.stopPropagation();
          handleZoomButtonClick.call(btn, e);
        }, { passive: false });
      });
    }

    function bindStep10ArcheZoomButtons(root) {
      const scope = root || document;
      scope.querySelectorAll('#arche-fresh .image-zoom-btn, #arche-artificial .image-zoom-btn').forEach(function(btn) {
        if (btn.dataset.step10ZoomBound === '1') return;
        btn.dataset.step10ZoomBound = '1';
        btn.classList.add('swiper-no-swiping');

        btn.addEventListener('touchstart', function(e) {
          e.stopPropagation();
        }, { passive: true });

        btn.addEventListener('touchend', function(e) {
          lastSwiperZoomTouchAt = Date.now();
          e.preventDefault();
          e.stopPropagation();
          handleZoomButtonClick.call(btn, e);
        }, { passive: false });
      });
    }

    function bindStep11ChairZoomButtons(root) {
      const scope = root || document;
      scope.querySelectorAll('#step11-fresh-option .image-zoom-btn, #step11-artificial-option .image-zoom-btn').forEach(function(btn) {
        if (btn.dataset.step11ZoomBound === '1') return;
        btn.dataset.step11ZoomBound = '1';
        btn.classList.add('swiper-no-swiping');

        btn.addEventListener('touchstart', function(e) {
          e.stopPropagation();
        }, { passive: true });

        btn.addEventListener('touchend', function(e) {
          lastSwiperZoomTouchAt = Date.now();
          e.preventDefault();
          e.stopPropagation();
          handleZoomButtonClick.call(btn, e);
        }, { passive: false });
      });
    }

    function bindStep13ProductZoomButtons(root) {
      const scope = root || document;
      scope.querySelectorAll('.container-item .image-zoom-btn, .gift-bag-item .image-zoom-btn').forEach(function(btn) {
        if (btn.dataset.step13ZoomBound === '1') return;
        btn.dataset.step13ZoomBound = '1';

        btn.addEventListener('touchstart', function(e) {
          e.stopPropagation();
        }, { passive: true });

        btn.addEventListener('touchend', function(e) {
          lastSwiperZoomTouchAt = Date.now();
          e.preventDefault();
          e.stopPropagation();
          handleZoomButtonClick.call(btn, e);
        }, { passive: false });
      });
    }

    function bindSupportZoomButtons(root) {
      const scope = root || document;
      scope.querySelectorAll('.support-image-swiper .image-zoom-btn, #support-product-display .image-zoom-btn').forEach(function(btn) {
        if (btn.dataset.supportZoomBound === '1') return;
        btn.dataset.supportZoomBound = '1';
        btn.classList.add('swiper-no-swiping');

        btn.addEventListener('touchstart', function(e) {
          e.stopPropagation();
        }, { passive: true });

        btn.addEventListener('pointerup', function(e) {
          lastSwiperZoomTouchAt = Date.now();
          e.preventDefault();
          e.stopPropagation();
          e.__zoomHandled = true;
          handleZoomButtonClick.call(btn, e);
        }, { passive: false });

        btn.addEventListener('click', function(e) {
          if (Date.now() - lastSwiperZoomTouchAt < 600) {
            e.preventDefault();
            e.stopPropagation();
            e.__zoomHandled = true;
            return;
          }
          e.preventDefault();
          e.stopPropagation();
          e.__zoomHandled = true;
          handleZoomButtonClick.call(btn, e);
        }, { passive: false });
      });
    }

    // Ouvrir la lightbox au clic sur les boutons de zoom (délégation d'événements pour les éléments créés dynamiquement)
    // Étape 9 : empêcher Swiper de capter le drag quand on vise le bouton zoom.
    document.addEventListener('pointerdown', function(e) {
      if (
        e.target.closest('.step9-sub-swiper .image-zoom-btn') ||
        e.target.closest('#arche-fresh .image-zoom-btn') ||
        e.target.closest('#arche-artificial .image-zoom-btn') ||
        e.target.closest('#step11-fresh-option .image-zoom-btn') ||
        e.target.closest('#step11-artificial-option .image-zoom-btn') ||
        e.target.closest('.container-item .image-zoom-btn') ||
        e.target.closest('.gift-bag-item .image-zoom-btn') ||
        e.target.closest('.support-image-swiper .image-zoom-btn')
      ) {
        e.stopPropagation();
      }
    }, true);

    document.addEventListener('click', function(e) {
      if (e.__zoomHandled) {
        return;
      }
      const zoomBtn = e.target.closest('.image-zoom-btn');
      if (zoomBtn) {
        if (
          (zoomBtn.closest('.step9-sub-swiper') ||
            zoomBtn.closest('#arche-fresh') ||
            zoomBtn.closest('#arche-artificial') ||
            zoomBtn.closest('#step11-fresh-option') ||
            zoomBtn.closest('#step11-artificial-option') ||
            zoomBtn.closest('.container-item') ||
            zoomBtn.closest('.gift-bag-item') ||
            zoomBtn.closest('.support-image-swiper') ||
            zoomBtn.closest('#support-product-display')) &&
          Date.now() - lastSwiperZoomTouchAt < 600
        ) {
          return;
        }
        handleZoomButtonClick.call(zoomBtn, e);
      }
    });

    bindStep9ZoomButtons(document);
    bindStep10ArcheZoomButtons(document);
    bindStep11ChairZoomButtons(document);
    bindStep13ProductZoomButtons(document);
    bindSupportZoomButtons(document);

    // Fermer la lightbox
    safeAddEventListener(lightboxClose, 'click', closeLightbox);
    safeAddEventListener(lightboxOverlay, 'click', closeLightbox);

    // Fermer avec la touche Escape
    document.addEventListener('keydown', function(e) {
      if (e.key === 'Escape' && lightbox && lightbox.classList.contains('active')) {
        closeLightbox();
      }
    });
    
    // ============================================
    // FONCTIONS UTILITAIRES RÉUTILISABLES
    // ============================================
    
    /**
     * Fonction debounce pour limiter les appels fréquents
     * @param {Function} func - La fonction à débouncer
     * @param {number} wait - Délai en millisecondes
     * @returns {Function} Fonction débouncée
     */
    function debounce(func, wait) {
      let timeout;
      return function executedFunction(...args) {
        const later = () => {
          clearTimeout(timeout);
          func.apply(this, args);
        };
        clearTimeout(timeout);
        timeout = setTimeout(later, wait);
      };
    }
    
    /**
     * Helper pour getElementById avec vérification de null et cache
     * @param {string} id - L'ID de l'élément
     * @param {boolean} useCache - Utiliser le cache si disponible (défaut: true)
     * @returns {HTMLElement|null} L'élément ou null
     */
    function getElement(id, useCache = true) {
      if (useCache && DOMCache[id]) {
        return DOMCache[id];
      }
      const element = document.getElementById(id);
      if (useCache && element) {
        DOMCache[id] = element;
      }
      return element;
    }
    
    /**
     * Helper pour querySelector avec vérification de null
     * @param {string} selector - Le sélecteur CSS
     * @param {HTMLElement} parent - L'élément parent (optionnel, défaut: document)
     * @returns {HTMLElement|null} L'élément ou null
     */
    function query(selector, parent = document) {
      return parent.querySelector(selector);
    }
    
    /**
     * Helper pour querySelectorAll
     * @param {string} selector - Le sélecteur CSS
     * @param {HTMLElement} parent - L'élément parent (optionnel, défaut: document)
     * @returns {NodeList} La liste des éléments
     */
    function queryAll(selector, parent = document) {
      return parent.querySelectorAll(selector);
    }
    
    /**
     * Helper pour jouer une vidéo avec gestion d'erreur
     * @param {HTMLVideoElement} video - L'élément vidéo
     * @returns {Promise} La promesse de play()
     */
    function safePlayVideo(video) {
      if (!video || typeof video.play !== 'function') {
        return Promise.resolve();
      }
      return video.play().catch(function(err) {
        console.debug('Video play error:', err);
      });
    }

    function isQuestionnaireSoundEnabled() {
      return window.__questionnaireSoundEnabled === true;
    }

    function syncVideoMuteIcons(video) {
      if (!video) {
        return;
      }
      const container = video.closest('.questionnaire-video-circular-container') ||
        video.closest('.questionnaire-video-wrapper');
      if (!container) {
        return;
      }
      const muteBtn = container.querySelector('.video-mute');
      if (!muteBtn) {
        return;
      }
      const muteIcon = muteBtn.querySelector('.mute-icon');
      const unmuteIcon = muteBtn.querySelector('.unmute-icon');
      if (video.muted) {
        if (muteIcon) muteIcon.style.display = 'none';
        if (unmuteIcon) unmuteIcon.style.display = 'block';
      } else {
        if (muteIcon) muteIcon.style.display = 'block';
        if (unmuteIcon) unmuteIcon.style.display = 'none';
      }
    }

    function pauseOtherQuestionnaireVideos(activeVideo) {
      document.querySelectorAll('.questionnaire-video').forEach(function(v) {
        if (v === activeVideo) {
          return;
        }
        v.pause();
        v.muted = true;
        v.setAttribute('data-sound-enabled', 'false');
        syncVideoMuteIcons(v);
      });
    }

    function enableQuestionnaireSound(targetVideo) {
      const video = targetVideo || getStepVideo(currentStep);
      if (!video) {
        return;
      }
      window.__questionnaireSoundEnabled = true;
      pauseOtherQuestionnaireVideos(video);
      video.muted = false;
      video.setAttribute('data-sound-enabled', 'true');
      syncVideoMuteIcons(video);
      safePlayVideo(video).catch(function() {
        video.muted = true;
        video.setAttribute('data-sound-enabled', 'false');
        syncVideoMuteIcons(video);
        safePlayVideo(video);
      });
    }

    const prefetchedQuestionnaireVideoUrls = new Set();

    function getStepVideo(stepNumber) {
      const stepEl = document.querySelector('.questionnaire-step[data-step="' + stepNumber + '"]');
      return stepEl ? stepEl.querySelector('.questionnaire-video') : null;
    }

    function getQuestionnaireVideoUrl(video) {
      if (!video) {
        return '';
      }
      const source = video.querySelector('source[src]');
      if (source && source.src) {
        return source.src;
      }
      return video.currentSrc || video.src || '';
    }

    function preloadQuestionnaireVideoUrl(url) {
      if (!url || prefetchedQuestionnaireVideoUrls.has(url)) {
        return;
      }
      prefetchedQuestionnaireVideoUrls.add(url);
    }

    function preloadQuestionnaireVideo(video) {
      if (!video) {
        return;
      }
      preloadQuestionnaireVideoUrl(getQuestionnaireVideoUrl(video));
      video.removeAttribute('data-lazy-load');
      video.preload = 'auto';
      if (video.readyState < 3) {
        video.load();
      }
    }

    function prefetchForwardStepVideos(fromStep, aheadCount) {
      for (let i = 0; i <= aheadCount; i++) {
        const n = fromStep + i;
        if (n >= 1 && n <= totalRealSteps) {
          preloadQuestionnaireVideo(getStepVideo(n));
        }
      }
    }

    function prefetchAdjacentStepVideos(stepNumber) {
      prefetchForwardStepVideos(stepNumber, 5);
      [-1, -2].forEach(function(offset) {
        const n = stepNumber + offset;
        if (n >= 1) {
          preloadQuestionnaireVideo(getStepVideo(n));
        }
      });
    }

    function warmUpcomingQuestionnaireVideos() {
      prefetchForwardStepVideos(2, 8);
    }

    function prepareStepVideoPlayback(video, stepNumber) {
      if (!video) {
        return;
      }
      preloadQuestionnaireVideo(video);
      const useSound = isQuestionnaireSoundEnabled();

      function applyMuteState() {
        if (useSound) {
          video.muted = false;
          video.setAttribute('data-sound-enabled', 'true');
        } else {
          video.muted = true;
          video.setAttribute('data-sound-enabled', 'false');
        }
        syncVideoMuteIcons(video);
      }

      function startPlayback() {
        pauseOtherQuestionnaireVideos(video);
        applyMuteState();
        safePlayVideo(video);
      }

      if (video.readyState >= 2) {
        startPlayback();
        return;
      }

      let started = false;
      function tryStartOnce() {
        if (started) {
          return;
        }
        started = true;
        startPlayback();
      }

      video.addEventListener('canplay', tryStartOnce, { once: true });
      video.addEventListener('loadeddata', tryStartOnce, { once: true });
      video.addEventListener('loadedmetadata', tryStartOnce, { once: true });
      setTimeout(function() {
        if (!started) {
          tryStartOnce();
        }
      }, 40);
    }
    
    /**
     * Helper pour ajouter un événement avec vérification de null
     * @param {HTMLElement|null} element - L'élément
     * @param {string} event - Le type d'événement
     * @param {Function} handler - Le gestionnaire d'événement
     * @param {Object} options - Options pour addEventListener (optionnel)
     */
    function safeAddEventListener(element, event, handler, options = null) {
      if (element && typeof handler === 'function') {
        if (options) {
          element.addEventListener(event, handler, options);
        } else {
          element.addEventListener(event, handler);
        }
      }
    }
    
    /**
     * Classe générique pour gérer les galeries modales d'images
     * Réutilisable pour les univers, décorations, etc.
     */
    class ImageGalleryModal {
      constructor(config) {
        this.modal = document.getElementById(config.modalId);
        this.modalImage = document.getElementById(config.imageId);
        this.modalCounter = document.getElementById(config.counterId);
        this.modalTitle = document.getElementById(config.titleId);
        this.modalPrev = document.getElementById(config.prevId);
        this.modalNext = document.getElementById(config.nextId);
        this.modalClose = document.getElementById(config.closeId);
        this.modalOverlay = this.modal ? this.modal.querySelector('.modal-overlay') : null;
        this.modalSelectBtn = document.getElementById(config.selectBtnId);
        this.onSelect = config.onSelect || null;
        
        this.images = [];
        this.currentIndex = 0;
        this.currentTitle = '';
        this.currentElement = null;
        
        this.minSwipeDistance = 50;
        this.touchStartX = 0;
        this.touchEndX = 0;
        this.touchStartY = 0;
        this.touchEndY = 0;
        
        this.init();
      }
      
      init() {
        // Navigation avec les flèches
        if (this.modalPrev) {
          this.modalPrev.addEventListener('click', () => this.goToPrevious());
        }
        if (this.modalNext) {
          this.modalNext.addEventListener('click', () => this.goToNext());
        }
        
        // Fermer la modal
        if (this.modalClose) {
          this.modalClose.addEventListener('click', () => this.close());
        }
        if (this.modalOverlay) {
          this.modalOverlay.addEventListener('click', () => this.close());
        }
        
        // Bouton de sélection
        if (this.modalSelectBtn) {
          this.modalSelectBtn.addEventListener('click', () => this.handleSelect());
        }
        
        // Double-clic pour sélectionner
        if (this.modalImage) {
          this.modalImage.addEventListener('dblclick', () => this.handleSelect());
          
          // Navigation par swipe sur mobile
          this.modalImage.addEventListener('touchstart', (e) => {
            this.touchStartX = e.changedTouches[0].screenX;
            this.touchStartY = e.changedTouches[0].screenY;
          }, { passive: true });
          
          this.modalImage.addEventListener('touchend', (e) => {
            this.touchEndX = e.changedTouches[0].screenX;
            this.touchEndY = e.changedTouches[0].screenY;
            
            const deltaX = this.touchEndX - this.touchStartX;
            const deltaY = this.touchEndY - this.touchStartY;
            const absDeltaX = Math.abs(deltaX);
            const absDeltaY = Math.abs(deltaY);
            
            if (absDeltaX > this.minSwipeDistance && absDeltaX > absDeltaY) {
              if (deltaX > 0) {
                this.goToPrevious();
              } else {
                this.goToNext();
              }
            }
          }, { passive: true });
        }
        
        // Fermer avec Escape
        document.addEventListener('keydown', (e) => {
          if (e.key === 'Escape' && this.modal && this.modal.classList.contains('active')) {
            this.close();
          }
        });
      }
      
      open(item, imagesData, title, imageCount) {
        if (!imagesData || imagesData === '' || imageCount === 0) {
          return false;
        }
        
        this.images = imagesData.split('|||');
        this.currentIndex = 0;
        this.currentTitle = title;
        this.currentElement = item;
        
        this.loadImage(this.images[0], 1, this.images.length);
        
        if (this.modal) {
          this.modal.classList.add('active');
          document.body.style.overflow = 'hidden';
        }
        
        return true;
      }
      
      loadImage(imageUrl, index, total) {
        if (this.modalImage) this.modalImage.src = getUncroppedImageUrl(imageUrl);
        if (this.modalCounter) this.modalCounter.textContent = `${index} / ${total}`;
        if (this.modalTitle) this.modalTitle.textContent = this.currentTitle;
        
        if (this.modalPrev) {
          this.modalPrev.disabled = (index === 1);
        }
        if (this.modalNext) {
          this.modalNext.disabled = (index === total);
        }
      }
      
      goToPrevious() {
        if (this.currentIndex > 0) {
          this.currentIndex--;
          this.loadImage(this.images[this.currentIndex], this.currentIndex + 1, this.images.length);
        }
      }
      
      goToNext() {
        if (this.currentIndex < this.images.length - 1) {
          this.currentIndex++;
          this.loadImage(this.images[this.currentIndex], this.currentIndex + 1, this.images.length);
        }
      }
      
      close() {
        if (this.modal) {
          this.modal.classList.remove('active');
          document.body.style.overflow = '';
        }
      }
      
      handleSelect() {
        if (this.currentElement && this.onSelect) {
          this.onSelect(this.currentElement);
          this.close();
        }
      }
    }
    
    /**
     * Fonction utilitaire pour valider et limiter un champ numérique
     * @param {HTMLInputElement} input - Le champ input à valider
     * @param {HTMLElement} errorElement - L'élément pour afficher les erreurs
     * @param {number} maxLength - Longueur maximale (défaut: 3)
     * @param {Function} onValidationChange - Callback appelé après validation (optionnel)
     */
    function setupNumericInputValidation(input, errorElement, maxLength = 3, onValidationChange = null) {
      if (!input) return;
      
      const errorMessage = 'Le nombre ne peut pas dépasser ' + maxLength + ' chiffres.';
      
      function showError() {
        if (errorElement) {
          errorElement.style.display = 'block';
          errorElement.textContent = errorMessage;
        }
      }
      
      function hideError() {
        if (errorElement) {
          errorElement.style.display = 'none';
        }
      }
      
      function processValue(value) {
        const numbers = value.replace(/[^0-9]/g, '');
        if (numbers.length > maxLength) {
          showError();
          return numbers.slice(0, maxLength);
        } else {
          hideError();
          return numbers;
        }
      }
      
      // Événement input
      input.addEventListener('input', function(e) {
        this.value = processValue(this.value);
        if (onValidationChange) onValidationChange();
      });
      
      // Événement blur
      input.addEventListener('blur', function() {
        this.value = processValue(this.value);
        if (onValidationChange) onValidationChange();
      });
      
      // Événement paste
      input.addEventListener('paste', function(e) {
        e.preventDefault();
        const paste = (e.clipboardData || window.clipboardData).getData('text');
        this.value = processValue(paste);
        if (onValidationChange) onValidationChange();
      });
    }
    
    /**
     * Fonction utilitaire pour gérer les boutons "Je ne veux pas"
     * @param {HTMLElement} noButton - Le bouton "Je ne veux pas"
     * @param {string|Array} itemsToDeselect - Sélecteur CSS ou tableau d'éléments à désélectionner
     * @param {Function} onToggle - Callback appelé lors du toggle (optionnel)
     * @param {Function} onValidation - Callback pour la validation (optionnel)
     */
    function setupNoOptionButton(noButton, itemsToDeselect, onToggle = null, onValidation = null) {
      if (!noButton) return;
      
      noButton.addEventListener('click', function() {
        this.classList.toggle('selected');
        
        if (this.classList.contains('selected')) {
          // Désélectionner les items
          if (typeof itemsToDeselect === 'string') {
            // Si c'est un sélecteur CSS
            document.querySelectorAll(itemsToDeselect).forEach(item => {
              item.classList.remove('selected');
            });
          } else if (Array.isArray(itemsToDeselect)) {
            // Si c'est un tableau d'éléments
            itemsToDeselect.forEach(item => {
              if (item) {
                item.classList.remove('selected');
              }
            });
          }
        }
        
        // Callbacks
        if (onToggle) onToggle(this.classList.contains('selected'));
        if (onValidation) onValidation();
      });
    }
    
    /**
     * Fonction utilitaire pour gérer les sélections multiples d'items
     * @param {string} itemSelector - Sélecteur CSS pour les items
     * @param {string} idAttribute - Attribut data pour l'ID de l'item
     * @param {Array} selectedArray - Array pour stocker les IDs sélectionnés
     * @param {HTMLElement} noButton - Bouton "Je ne veux pas" (optionnel)
     * @param {Function} onItemClick - Callback appelé lors du clic sur un item (optionnel)
     * @param {Function} onValidation - Callback pour la validation (optionnel)
     */
    function setupMultipleItemSelection(itemSelector, idAttribute, selectedArray, noButton = null, onItemClick = null, onValidation = null) {
      document.querySelectorAll(itemSelector).forEach(item => {
        item.addEventListener('click', function() {
          // Si "Je ne veux pas" est sélectionné, le désélectionner
          if (noButton && noButton.classList.contains('selected')) {
            noButton.classList.remove('selected');
          }
          
          // Toggle la sélection de cet item
          this.classList.toggle('selected');
          
          // Mettre à jour la liste des items sélectionnés
          const itemId = this.getAttribute(idAttribute);
          if (this.classList.contains('selected')) {
            if (!selectedArray.includes(itemId)) {
              selectedArray.push(itemId);
            }
          } else {
            const index = selectedArray.indexOf(itemId);
            if (index > -1) {
              selectedArray.splice(index, 1);
            }
          }
          
          // Callbacks
          if (onItemClick) onItemClick(this, itemId);
          if (onValidation) onValidation();
        });
      });
    }
    
    /**
     * Helper pour activer/désactiver un bouton de validation
     * @param {HTMLElement} button - Le bouton à activer/désactiver
     * @param {boolean} disabled - true pour désactiver, false pour activer
     */
    function setValidationButtonState(button, disabled) {
      if (button) {
        button.disabled = disabled;
      }
    }
    
    /* ============================================
       SYSTÈME DE NAVIGATION ENTRE LES ÉTAPES
       ============================================ */
    let currentStep = 1;
    const totalRealSteps = 18; // 18 étapes réelles
    
    // Fonction pour convertir une étape réelle en étape visuelle (fleur)
    // Les fleurs s'activent progressivement : la fleur suivante s'active quand la ligne précédente est complète
    // Ligne 1 (étapes 1-4) : Fleur 1 active dès étape 1, Fleur 2 active à l'étape 4 (ligne complète)
    // Ligne 2 (étapes 5-8) : Fleur 2 active, Fleur 3 active à l'étape 8 (ligne complète)
    // Ligne 3 (étapes 9-12) : Fleur 3 active, Fleur 4 active à l'étape 12 (ligne complète)
      // Ligne 4 (étapes 13-18) : Fleur 4 active, Fleur 5 active à l'étape 18 (ligne complète)
    function getVisualStep(realStep) {
      if (realStep <= 0) return 1;
      if (realStep < 4) return 1;   // Étape 1-3 : Fleur 1 seulement
      if (realStep === 4) return 2;   // Étape 4 : Ligne 1 complète → Fleur 2 active
      if (realStep < 8) return 2;   // Étape 5-7 : Fleur 1 et 2 actives
      if (realStep === 8) return 3;   // Étape 8 : Ligne 2 complète → Fleur 3 active
      if (realStep < 12) return 3;   // Étape 9-11 : Fleur 1, 2 et 3 actives
      if (realStep === 12) return 4;   // Étape 12 : Ligne 3 complète → Fleur 4 active
      if (realStep < 18) return 4;   // Étape 13-17 : Fleur 1, 2, 3 et 4 actives
      if (realStep === 18) return 5;   // Étape 18 : Ligne 4 complète → Fleur 5 active
      return 5; // Au-delà de l'étape 18, toutes les fleurs sont actives
    }
    
    // Fonction pour convertir une étape visuelle en première étape réelle correspondante
    function getRealStepFromVisual(visualStep) {
      // Fleur 1 → étape 1, Fleur 2 → étape 4, Fleur 3 → étape 8, Fleur 4 → étape 12, Fleur 5 → étape 18
      if (visualStep <= 1) return 1;
      if (visualStep <= 2) return 4;
      if (visualStep <= 3) return 8;
      if (visualStep <= 4) return 12;
      return 18; // Fleur 5
    }
    
    // Fonction pour obtenir le titre selon l'étape réelle
    function getStepTitle(realStep) {
      if (realStep >= 1 && realStep <= 3) {
        return 'INTRODUCTION';
      } else if (realStep === 8) {
        return 'RÉCEPTION';
      } else if (realStep >= 4 && realStep <= 5) {
        return 'BOUQUETS';
      } else if ((realStep >= 6 && realStep <= 7) || realStep === 9) {
        return 'RÉCEPTION';
      } else if (realStep >= 10 && realStep <= 11) {
        return 'CEREMONIE';
      } else if (realStep >= 12 && realStep <= 16) {
        return 'SUPPLÉMENTS';
      } else if (realStep === 17) {
        return 'VOS INFORMATIONS';
      } else if (realStep === 18) {
        return 'RÉSUMÉ';
      }
      return 'ÉTAPE ' + realStep;
    }

    function showStep(stepNumber) {
      try {
        // Vérifier que l'étape est valide
        if (stepNumber < 1 || stepNumber > totalRealSteps) {
          return;
        }

        prefetchAdjacentStepVideos(stepNumber);
        
        // Cacher toutes les étapes et arrêter leurs vidéos
        document.querySelectorAll('.questionnaire-step').forEach(step => {
          const stepNum = parseInt(step.getAttribute('data-step'));
          step.style.display = 'none';
          const stepVideo = step.querySelector('.questionnaire-video');
          if (stepVideo && stepNum !== stepNumber) {
            stepVideo.pause();
            stepVideo.muted = true;
            stepVideo.setAttribute('data-sound-enabled', 'false');
            syncVideoMuteIcons(stepVideo);
          }
        });

        // Afficher l'étape actuelle
        const currentStepElement = document.querySelector('.questionnaire-step[data-step="' + stepNumber + '"]');
        if (currentStepElement) {
          currentStepElement.style.display = 'block';

          if (stepNumber === 2) {
            hydrateUniversImagesFromJson();
            currentStepElement.querySelectorAll('img[loading="lazy"]').forEach(function(img) {
              const src = img.getAttribute('src');
              if (src) {
                img.loading = 'eager';
                img.src = src;
              }
            });
          }

          if (stepNumber >= 9 && stepNumber <= 13) {
            initQuestionnaireMediaRobust(stepNumber);
          }

          if (stepNumber === 10) {
            const galleries = document.getElementById('arche-color-galleries');
            const hasShopifyImg =
              galleries &&
              galleries.querySelector('img[src*="cdn.shopify"], img[src*="shopify.com"]');
            if (galleries && !hasShopifyImg && typeof setArcheColorStaticPreview === 'function') {
              const archeSelect = document.getElementById('arche-color');
              if (archeSelect && archeSelect.value) {
                setArcheColorStaticPreview(archeSelect.value);
              }
            }
          }
          
          // Pour l'étape 16 (bottes) : réinitialiser la vue des catégories et mettre à jour la disponibilité
          if (stepNumber === 16) {
            const categoriesView = document.getElementById('flowers-categories-view');
            const subcategoriesView = document.getElementById('flowers-subcategories-view');
            const varietiesView = document.getElementById('flowers-varieties-view');
            if (categoriesView) categoriesView.style.display = 'block';
            if (subcategoriesView) subcategoriesView.style.display = 'none';
            if (varietiesView) varietiesView.style.display = 'none';
            updateSubcategoriesAvailability();
            const step16El = document.querySelector('[data-step="16"]');
            if (step16El) {
              reloadStepImages(step16El);
              fixBrokenImagesInStep(step16El);
            }
          }
          
          // Pour l'étape 17 (compte) : pré-remplir la date de mariage avec la valeur de l'étape 1
          if (stepNumber === 17) {
            hydrateLoggedInCustomerFields();
            const weddingDateInput = DOMCache.weddingDateInput || document.getElementById('wedding-date');
            const registerWeddingDateInput = document.getElementById('RegisterForm-WeddingDate');
            const minWeddingDate = getMinimumWeddingDate();
            applyWeddingDateMinimum(registerWeddingDateInput, minWeddingDate);
            
            if (weddingDateInput && registerWeddingDateInput && weddingDateInput.value) {
              // Copier la valeur de l'étape 1 vers le formulaire compte
              registerWeddingDateInput.value = weddingDateInput.value;
              // Rendre le champ en lecture seule et grisé
              registerWeddingDateInput.readOnly = true;
              registerWeddingDateInput.classList.add('readonly-field');
            }
            enforceWeddingDateMinimum(registerWeddingDateInput, minWeddingDate);
            validateCreateAccountForm();
          }
          
          const currentStepVideo = currentStepElement.querySelector('.questionnaire-video');
          if (currentStepVideo) {
            prepareStepVideoPlayback(currentStepVideo, stepNumber);
          }
        } else {
          return;
        }

        // Calculer l'étape visuelle correspondante
        const visualStep = getVisualStep(stepNumber);

        // Mettre à jour l'indicateur de progression visuel
        const progressSteps = document.querySelectorAll('.progress-step');
        progressSteps.forEach((step, index) => {
          step.classList.toggle('active', (index + 1) <= visualStep);
        });

        // Mettre à jour le titre selon l'étape réelle (utiliser le cache)
        if (DOMCache.progressTitle) {
          DOMCache.progressTitle.textContent = getStepTitle(stepNumber);
        }

        // Mettre à jour le compteur de progression (utiliser le cache)
        if (DOMCache.progressCounter) {
          DOMCache.progressCounter.textContent = `Étape ${stepNumber} sur ${totalRealSteps}`;
        }

        // Mettre à jour la barre de progression animée (utiliser le cache)
        const progressBarFill = DOMCache.progressBarFill;
        if (progressBarFill) {
          // Logique : 4 lignes de progression, chaque ligne se remplit sur 4 étapes
          // Ligne 1 : étapes 1-4 (0% à 25% de la barre totale)
          // Ligne 2 : étapes 5-8 (25% à 50% de la barre totale)
          // Ligne 3 : étapes 9-12 (50% à 75% de la barre totale)
          // Ligne 4 : étapes 13-16 (75% à 100% de la barre totale)
          const stepsPerSegment = 4; // 4 étapes par segment/ligne
          const segmentIndex = Math.floor((stepNumber - 1) / stepsPerSegment); // 0, 1, 2, ou 3
          const stepInSegment = ((stepNumber - 1) % stepsPerSegment) + 1; // 1, 2, 3, ou 4
          const segmentProgress = stepInSegment / stepsPerSegment; // 0.25, 0.5, 0.75, ou 1.0
          const segmentSize = 25; // 25% par segment
          const baseProgress = segmentIndex * segmentSize; // 0%, 25%, 50%, ou 75%
          const progressPercentage = Math.min(100, Math.max(0, baseProgress + (segmentProgress * segmentSize)));
          
          // Calculer la largeur réelle en pixels (90% de la largeur du conteneur)
          const progressStepsContainer = progressBarFill.parentElement;
          if (progressStepsContainer) {
            const fillWidth = (progressStepsContainer.offsetWidth * 0.9 * progressPercentage) / 100;
            progressBarFill.style.width = fillWidth + 'px';
          } else {
            progressBarFill.style.width = progressPercentage + '%';
          }
        }

        currentStep = stepNumber;
        
        // Mettre à jour la disponibilité saisonnière des univers si on arrive à l'étape 2
        if (stepNumber === 2) {
          updateUniversSeasonalAvailability();
        }

        // Mettre à jour la recommandation auto des matériels
        if (stepNumber === 15 && typeof applyAutoMaterialsRecommendation === 'function') {
          applyAutoMaterialsRecommendation();
        }

        // Sauvegarder le snapshot avant que la page ne recharge (création de compte étape 17)
        if (stepNumber === 17 && typeof saveSummarySnapshot === 'function') {
          saveSummarySnapshot();
        }

        // Construire le récapitulatif final à l'arrivée sur l'étape 18
        if (stepNumber === 18 && typeof populateSummary === 'function') {
          populateSummary();
        }
        
        // Faire défiler la page vers le haut
        window.scrollTo({ top: 0, behavior: 'smooth' });
      } catch (e) {
        // Erreur silencieuse pour ne pas polluer la console
      }
    }
    
    // Exposer showStep globalement pour pouvoir l'utiliser après le chargement
    window.showStep = showStep;
    
    // Vérifier si on vient de créer un compte (via URL) - après que showStep soit défini
    const urlParams = new URLSearchParams(window.location.search);
    if (urlParams.get('account_created') === 'true') {
      // Nettoyer l'URL
      const newUrl = window.location.pathname;
      window.history.replaceState({}, document.title, newUrl);
      // Afficher l'étape résumé après un court délai pour s'assurer que tout est chargé
      setTimeout(function() {
        showStep(18);
        window.scrollTo({ top: 0, behavior: 'smooth' });
      }, 300);
    }

    document.addEventListener('mousedown', function(e) {
      const nextBtn = e.target.closest('[data-next-step]');
      if (!nextBtn) {
        return;
      }
      const nextStep = parseInt(nextBtn.getAttribute('data-next-step'), 10);
      if (nextStep) {
        preloadQuestionnaireVideo(getStepVideo(nextStep));
        prefetchForwardStepVideos(nextStep, 2);
      }
    }, true);

    // Boutons de navigation - Event delegation pour meilleure performance
    document.addEventListener('click', function(e) {
      const nextBtn = e.target.closest('[data-next-step]');
      const prevBtn = e.target.closest('[data-prev-step]');
      if (nextBtn) {
        e.preventDefault();
        e.stopPropagation();
        const nextStep = parseInt(nextBtn.getAttribute('data-next-step'));
        if (nextStep) {
          preloadQuestionnaireVideo(getStepVideo(nextStep));
        }
        
        // Vérifier les couleurs avant de valider les étapes 12, 13 et 14
        if (nextStep === 13) {
          // Étape 12 : Vérifier que toutes les options sélectionnées ont une couleur
          if (!checkStep12ColorSelection()) {
            return;
          }
        } else if (nextStep === 14) {
          // Depuis contenants → atelier : vérifications couleurs héritées
          if (!checkStep13ColorSelection()) {
            return;
          }
        } else if (nextStep === 16) {
          // Depuis matériels → bottes : couleurs matériels si besoin
          if (!checkStep13ColorSelection()) {
            return;
          }
        }
        
        if (nextStep && nextStep <= totalRealSteps) {
          showStep(nextStep);
        }
        return;
      }

      if (prevBtn) {
        const prevStep = parseInt(prevBtn.getAttribute('data-prev-step'));
        if (prevStep >= 1) {
          preloadQuestionnaireVideo(getStepVideo(prevStep));
          showStep(prevStep);
          window.scrollTo({ top: 0, behavior: 'smooth' });
        }
      }
    });

    // Initialiser l'étape 1 au chargement
    showStep(1);

    preloadQuestionnaireMediaFromJson();

    [9, 10, 11, 12].forEach(function(n) {
      const el = document.querySelector('.questionnaire-step[data-step="' + n + '"]');
      if (el) {
        primeImagesInRoot(el);
      }
    });

    window.addEventListener('pageshow', function() {
      [9, 10, 11, 12].forEach(function(n) {
        const el = document.querySelector('.questionnaire-step[data-step="' + n + '"]');
        if (el && el.style.display !== 'none') {
          primeImagesInRoot(el);
          reloadStepImages(el);
          fixBrokenImagesInStep(el);
          initQuestionnaireMediaRobust(n);
        }
      });
    });
    
    // Rendre les fleurs d'étapes cliquables uniquement pour revenir en arrière
    document.querySelectorAll('.progress-step').forEach(step => {
      step.style.cursor = 'pointer';
      step.addEventListener('click', function() {
        const visualStepNum = parseInt(this.getAttribute('data-step-number'));
        if (visualStepNum) {
          const realStep = getRealStepFromVisual(visualStepNum);
          // Autoriser seulement le retour arrière, pas l'avance via le header
          if (realStep >= 1 && realStep < currentStep && realStep <= totalRealSteps) {
            showStep(realStep);
          }
        }
      });
    });
    
    // Contrôles vidéo circulaire (pour toutes les étapes)
    function initCircularVideoControls() {
      const videoContainers = document.querySelectorAll('.questionnaire-video-circular-container');
      if (!videoContainers || videoContainers.length === 0) {
        return;
      }
      
      videoContainers.forEach(function(videoContainer) {
        const videoWrapper = videoContainer.querySelector('.questionnaire-video-circular');
        if (!videoWrapper) {
          return; // Continue avec le prochain container
        }
      
      const video = videoWrapper.querySelector('.questionnaire-video');
      if (!video) return;
      
      // S'assurer que la vidéo est en muted pour permettre l'autoplay (uniquement au chargement initial)
      // Ne pas forcer muted si la vidéo est déjà en train de jouer avec le son (après showStep)
      if (!video.hasAttribute('data-sound-enabled')) {
        video.muted = true;
        video.setAttribute('data-sound-enabled', 'false');
      }

      // Bouton play/pause
      const playPauseBtn = videoContainer.querySelector('.video-play-pause');
      if (playPauseBtn) {
        const playIcon = playPauseBtn.querySelector('.play-icon');
        const pauseIcon = playPauseBtn.querySelector('.pause-icon');
        function updatePlayPauseIcon() {
          if (video.paused) {
            if (playIcon) playIcon.style.display = 'block';
            if (pauseIcon) pauseIcon.style.display = 'none';
          } else {
            if (playIcon) playIcon.style.display = 'none';
            if (pauseIcon) pauseIcon.style.display = 'block';
          }
        }
        updatePlayPauseIcon();
        playPauseBtn.addEventListener('click', function(e) {
          e.stopPropagation();
          if (video.paused) {
            pauseOtherQuestionnaireVideos(video);
            video.muted = false;
            window.__questionnaireSoundEnabled = true;
            video.setAttribute('data-sound-enabled', 'true');
            syncVideoMuteIcons(video);
            safePlayVideo(video);
          } else {
            video.pause();
          }
          updatePlayPauseIcon();
        });
        video.addEventListener('play', updatePlayPauseIcon);
        video.addEventListener('pause', updatePlayPauseIcon);
      }
      
      // Bouton mute/unmute
      const muteBtn = videoContainer.querySelector('.video-mute');
      if (muteBtn) {
        const muteIcon = muteBtn.querySelector('.mute-icon');
        const unmuteIcon = muteBtn.querySelector('.unmute-icon');
        function updateMuteIcon() {
          if (video.muted) {
            if (muteIcon) muteIcon.style.display = 'none';
            if (unmuteIcon) unmuteIcon.style.display = 'block';
          } else {
            if (muteIcon) muteIcon.style.display = 'block';
            if (unmuteIcon) unmuteIcon.style.display = 'none';
          }
        }
        updateMuteIcon();
        muteBtn.addEventListener('click', function(e) {
          e.stopPropagation();
          if (video.muted) {
            pauseOtherQuestionnaireVideos(video);
            video.muted = false;
            window.__questionnaireSoundEnabled = true;
            video.setAttribute('data-sound-enabled', 'true');
            safePlayVideo(video);
          } else {
            video.muted = true;
            window.__questionnaireSoundEnabled = false;
            video.setAttribute('data-sound-enabled', 'false');
          }
          updateMuteIcon();
        });
      }
      
      // Bouton agrandir dans la page (pas plein écran)
      const expandBtn = videoContainer.querySelector('.video-expand');
      if (expandBtn) {
        expandBtn.addEventListener('click', function() {
          const isExpanded = videoContainer.classList.contains('is-expanded');
          const expandIcon = expandBtn.querySelector('.expand-icon');
          const closeIcon = expandBtn.querySelector('.close-icon');
          
          if (isExpanded) {
            // Réduire
            videoContainer.classList.remove('is-expanded');
            if (expandIcon) expandIcon.style.display = 'block';
            if (closeIcon) closeIcon.style.display = 'none';
            expandBtn.setAttribute('aria-label', 'Agrandir');
          } else {
            // Agrandir
            videoContainer.classList.add('is-expanded');
            if (expandIcon) expandIcon.style.display = 'none';
            if (closeIcon) closeIcon.style.display = 'block';
            expandBtn.setAttribute('aria-label', 'Réduire');
            // Faire défiler vers la vidéo agrandie
            videoContainer.scrollIntoView({ behavior: 'smooth', block: 'center' });
          }
        });
      }
      }); // Fin du forEach
    }
    
    // Initialiser les contrôles vidéo
    initCircularVideoControls();
    
    const step1Video = getStepVideo(1);
    if (step1Video) {
      preloadQuestionnaireVideo(step1Video);
      prefetchAdjacentStepVideos(1);
    }
    setTimeout(warmUpcomingQuestionnaireVideos, 400);
    if (typeof requestIdleCallback === 'function') {
      requestIdleCallback(warmUpcomingQuestionnaireVideos, { timeout: 2500 });
    }
    
    // Validation du champ nombre d'invités (étape 3) - Utiliser le cache DOM
    const invitesInput = getElement('nombre-invites');
    const invitesError = getElement('invites-error');
    const validateStep3 = DOMCache.validateStep3;
    
    // Fonction pour valider et activer/désactiver le bouton
    function validateInvitesInput() {
      const value = invitesInput.value.trim();
      const isValid = value.length > 0 && value.length <= 3 && /^[0-9]+$/.test(value);
      
      // Activer/désactiver le bouton VALIDER
      if (validateStep3) {
        validateStep3.disabled = !isValid;
      }
    }
    
    // Utiliser la fonction utilitaire pour la validation du champ
    if (invitesInput) {
      setupNumericInputValidation(invitesInput, invitesError, 3, validateInvitesInput);
      // Validation initiale (au cas où le champ aurait déjà une valeur)
      validateInvitesInput();
    }
    
    /* ============================================
       GESTION DES ÉTAPES DU QUESTIONNAIRE
       ============================================ */
    
    // Étape 1 - Validation du champ date (utiliser le cache DOM)
    const validateStep1 = DOMCache.validateStep1;
    const weddingDateInput = DOMCache.weddingDateInput;

    function formatDateToISO(date) {
      const year = date.getFullYear();
      const month = String(date.getMonth() + 1).padStart(2, '0');
      const day = String(date.getDate()).padStart(2, '0');
      return `${year}-${month}-${day}`;
    }

    function getMinimumWeddingDate() {
      const today = new Date();
      const minDate = new Date(today.getFullYear(), today.getMonth() + 1, today.getDate());
      return formatDateToISO(minDate);
    }

    function formatISOToFrench(isoDate) {
      if (!isoDate || !/^\d{4}-\d{2}-\d{2}$/.test(isoDate)) return isoDate || '';
      const parts = isoDate.split('-');
      return `${parts[2]}/${parts[1]}/${parts[0]}`;
    }

    function applyWeddingDateMinimum(input, minDate) {
      if (!input || !minDate) return;
      input.setAttribute('min', minDate);
      input.setAttribute('lang', 'fr-FR');
      input.setAttribute('data-locale', 'fr-FR');
      input.setAttribute('placeholder', 'jj/mm/aaaa');
      input.setAttribute(
        'title',
        'Format : jj/mm/aaaa. Première date disponible : ' + formatISOToFrench(minDate)
      );
    }

    function enforceWeddingDateMinimum(input, minDate) {
      if (!input || !minDate || !input.value) return true;
      const isAllowedDate = isWeddingDateWithinAllowedRange(input.value, minDate);
      if (!isAllowedDate) {
        // Sur mobile, on force visuellement la première date autorisée.
        input.value = minDate;
        input.setCustomValidity('');
        return false;
      }
      return true;
    }

    function isWeddingDateWithinAllowedRange(value, minDate) {
      if (!value || !minDate) return false;
      return value >= minDate;
    }
    
    function updateStep1Validation() {
      if (validateStep1 && weddingDateInput) {
        const minDate = weddingDateInput.getAttribute('min') || getMinimumWeddingDate();
        const isValidDate = isWeddingDateWithinAllowedRange(weddingDateInput.value, minDate);
        validateStep1.disabled = !isValidDate;
      }
    }
    
    // Fonction pour normaliser le format de date sur iOS Safari
    function normalizeDateInput(input) {
      if (!input) return;
      
      // Détecter iOS Safari
      const isIOSSafari = /iPad|iPhone|iPod/.test(navigator.userAgent) && !window.MSStream;
      
      if (isIOSSafari && input.value) {
        // Le format de date est toujours YYYY-MM-DD en interne
        // On s'assure juste que l'affichage est cohérent
        const dateValue = input.value;
        if (dateValue && dateValue.match(/^\d{4}-\d{2}-\d{2}$/)) {
          // Le format est correct, on force juste le réaffichage
          input.setAttribute('value', dateValue);
        }
      }
    }
    
    // Fonction pour gérer l'affichage du placeholder personnalisé
    function updateDatePlaceholder(input) {
      const placeholder = document.getElementById('date-placeholder');
      if (!placeholder) return;
      
      // Détecter iOS Safari
      const isIOSSafari = /iPad|iPhone|iPod/.test(navigator.userAgent) && !window.MSStream;
      
      if (isIOSSafari) {
        // Sur iOS Safari, afficher le placeholder si le champ est vide
        if (!input.value || input.value === '') {
          placeholder.classList.add('show');
          placeholder.classList.remove('hide');
        } else {
          placeholder.classList.add('hide');
          placeholder.classList.remove('show');
        }
      } else {
        // Sur les autres navigateurs, cacher le placeholder (l'icône native gère ça)
        placeholder.classList.add('hide');
        placeholder.classList.remove('show');
      }
    }
    
    if (weddingDateInput) {
      const minWeddingDate = getMinimumWeddingDate();
      applyWeddingDateMinimum(weddingDateInput, minWeddingDate);
      const registerWeddingDateInput = document.getElementById('RegisterForm-WeddingDate');
      if (registerWeddingDateInput) {
        applyWeddingDateMinimum(registerWeddingDateInput, minWeddingDate);
        registerWeddingDateInput.addEventListener('change', function() {
          const minDate = this.getAttribute('min') || minWeddingDate;
          enforceWeddingDateMinimum(this, minDate);
          this.setCustomValidity(
            isWeddingDateWithinAllowedRange(this.value, minDate)
              ? ''
              : 'La date du mariage doit être au moins dans un mois.'
          );
          validateCreateAccountForm();
        });
        registerWeddingDateInput.addEventListener('blur', function() {
          const minDate = this.getAttribute('min') || minWeddingDate;
          enforceWeddingDateMinimum(this, minDate);
          this.setCustomValidity(
            isWeddingDateWithinAllowedRange(this.value, minDate)
              ? ''
              : 'La date du mariage doit être au moins dans un mois.'
          );
        });
      }
      const dateInputWrapper = weddingDateInput.closest('.date-input-wrapper');

      // Initialiser le placeholder au chargement
      updateDatePlaceholder(weddingDateInput);

      function openWeddingDatePicker() {
        weddingDateInput.focus();
        weddingDateInput.showPicker ? weddingDateInput.showPicker() : weddingDateInput.click();
      }
      
      // Utiliser debounce pour les événements input (optimisation performance)
      const debouncedUpdate = debounce(function() {
        const minDate = this.getAttribute('min') || minWeddingDate;
        const isAllowedDate = isWeddingDateWithinAllowedRange(this.value, minDate);
        this.setCustomValidity(isAllowedDate ? '' : 'La date du mariage doit être au moins dans un mois.');
        normalizeDateInput(this);
        updateDatePlaceholder(this);
        updateStep1Validation();
      }, 150);
      
      weddingDateInput.addEventListener('change', function() {
        const minDate = this.getAttribute('min') || minWeddingDate;
        const isAllowedDate = isWeddingDateWithinAllowedRange(this.value, minDate);
        this.setCustomValidity(isAllowedDate ? '' : 'La date du mariage doit être au moins dans un mois.');

        enforceWeddingDateMinimum(this, minDate);

        normalizeDateInput(this);
        updateDatePlaceholder(this);
        updateStep1Validation();
        // Mettre à jour la disponibilité des univers si on est déjà à l'étape 2
        if (currentStep === 2) {
          updateUniversSeasonalAvailability();
        }
      });
      weddingDateInput.addEventListener('input', debouncedUpdate);
      weddingDateInput.addEventListener('blur', function() {
        const minDate = this.getAttribute('min') || minWeddingDate;
        const isAllowedDate = isWeddingDateWithinAllowedRange(this.value, minDate);
        this.setCustomValidity(isAllowedDate ? '' : 'La date du mariage doit être au moins dans un mois.');

        enforceWeddingDateMinimum(this, minDate);

        normalizeDateInput(this);
        updateDatePlaceholder(this);
        updateStep1Validation(); // Validation immédiate au blur
      });
      weddingDateInput.addEventListener('focus', function() {
        updateDatePlaceholder(this);
      });

      // Sur desktop : toute la zone du champ ouvre le calendrier (pas seule l'icône)
      function isDesktopDatePickerZone() {
        return window.matchMedia('(min-width: 769px) and (pointer: fine)').matches;
      }

      if (dateInputWrapper) {
        dateInputWrapper.addEventListener('click', function() {
          if (!isDesktopDatePickerZone()) return;
          openWeddingDatePicker();
        });
      }
      
      // Gérer le clic sur l'icône calendrier personnalisée (fallback pour iOS)
      const calendarIcon = document.querySelector('.date-calendar-icon');
      if (calendarIcon) {
        calendarIcon.addEventListener('click', function(e) {
          e.preventDefault();
          e.stopPropagation();
          openWeddingDatePicker();
        });
        // Permettre les clics sur l'icône
        calendarIcon.style.pointerEvents = 'auto';
        calendarIcon.style.cursor = 'pointer';
      }
      
      // Vérifier l'état initial
      updateStep1Validation();
    }

    /* ============================================
       ÉTAPE 2 - SÉLECTION UNIVERS FLORAL
       ============================================ */
    
    /**
     * Fonction pour vérifier la disponibilité saisonnière des univers
     * et griser ceux qui ne sont pas disponibles selon le mois du mariage
     */
    function updateUniversSeasonalAvailability() {
      const weddingDateInput = DOMCache.weddingDateInput;
      if (!weddingDateInput || !weddingDateInput.value) {
        // Si pas de date, réinitialiser tous les univers
        document.querySelectorAll('.univers-item').forEach(item => {
          item.classList.remove('unavailable');
        });
        return;
      }
      
      // Extraire le mois de la date (format YYYY-MM-DD)
      const dateValue = weddingDateInput.value;
      const dateParts = dateValue.split('-');
      if (dateParts.length < 2) return;
      
      const month = parseInt(dateParts[1], 10); // 1-12
      if (isNaN(month) || month < 1 || month > 12) return;
      
      // Récupérer tous les univers
      const universItems = document.querySelectorAll('.univers-item');
      
      universItems.forEach(item => {
        const universName = (item.getAttribute('data-univers-name') || '').toLowerCase().trim();
        const universTitle = (item.getAttribute('data-univers-title') || '').toLowerCase().trim();
        const fullName = universName || universTitle;
        
        // Réinitialiser l'état
        item.classList.remove('unavailable');
        
        // Règles de disponibilité :
        
        // 1. Pivoine élégante et Pivoine romantique : disponibles avril-juin (4-6)
        // Grisées si : juillet-décembre (7-12) ou janvier-mars (1-3)
        if (fullName.includes('pivoine') && (fullName.includes('élégante') || fullName.includes('elegante') || fullName.includes('romantique'))) {
          if (month < 4 || month > 6) {
            item.classList.add('unavailable');
          }
        }
        
        // 2. Tulipe sophistiquée : disponible janvier-avril (1-4)
        // Grisée si : mai-décembre (5-12)
        if (fullName.includes('tulipe') && (fullName.includes('sophistiquée') || fullName.includes('sophistiquee'))) {
          if (month > 4) {
            item.classList.add('unavailable');
          }
        }
        
        // 3. Romance Pure (renoncule blanche), Douceur d'Agrume (renoncule jaune/pêche), Rayon de Soleil (renoncule jaune)
        // Disponibles : janvier-mars (1-3)
        // Grisées si : avril-décembre (4-12)
        if (fullName.includes('romance pure') || 
            (fullName.includes('douceur') && fullName.includes('agrume')) ||
            (fullName.includes('rayon') && fullName.includes('soleil')) ||
            (fullName.includes('renoncule') && (fullName.includes('blanche') || fullName.includes('jaune') || fullName.includes('pêche') || fullName.includes('peche')))) {
          if (month > 3) {
            item.classList.add('unavailable');
          }
        }
      });
    }
    
    // Galerie modale pour les univers floraux - Utilisation de la classe générique
    function syncValidateStep2Button() {
      const validateBtn = document.getElementById('validate-step-2');
      if (validateBtn) {
        validateBtn.disabled = !document.querySelector('.univers-item.selected');
      }
    }

    function selectUnivers(item) {
      if (!item) return;
      
      // Ne pas permettre la sélection si l'univers n'est pas disponible
      if (item.classList.contains('unavailable')) {
        return;
      }
      
      // Désélectionner tous les autres univers
      document.querySelectorAll('.univers-item').forEach(i => {
        if (i !== item) {
          i.classList.remove('selected');
        }
      });
      
      // Sélectionner celui-ci
      item.classList.add('selected');
      
      syncValidateStep2Button();
    }
    
    // Initialiser la galerie modale pour les univers
    const universGallery = new ImageGalleryModal({
      modalId: 'univers-gallery-modal',
      imageId: 'modal-image',
      counterId: 'modal-counter',
      titleId: 'modal-title',
      prevId: 'modal-prev',
      nextId: 'modal-next',
      closeId: 'modal-close',
      selectBtnId: 'modal-select-btn',
      onSelect: selectUnivers
    });

    // Fonction pour ouvrir la modal galerie d'un univers
    function openUniversGallery(universItem) {
      const imagesData = universItem.getAttribute('data-univers-images');
      const universTitle = universItem.getAttribute('data-univers-title');
      const imageCount = parseInt(universItem.getAttribute('data-image-count')) || 0;
      
      if (!universGallery.open(universItem, imagesData, universTitle, imageCount)) {
        // Si pas d'images, sélectionner l'univers directement
        selectUnivers(universItem);
      }
    }

    // Ouvrir la galerie au clic sur un univers (Event delegation - plus performant)
    document.addEventListener('click', function(e) {
      const universItem = e.target.closest('.univers-item');
      if (!universItem) return;
      
      // Ne pas permettre l'interaction si l'univers n'est pas disponible
      if (universItem.classList.contains('unavailable')) {
        return;
      }
      
      // Ne pas ouvrir la modal si on clique directement sur le bouton zoom (géré séparément)
      if (e.target.closest('.image-zoom-btn')) {
        return;
      }
      
      // Clic sur l'univers déjà sélectionné : désélectionner
      if (universItem.classList.contains('selected')) {
        universItem.classList.remove('selected');
        syncValidateStep2Button();
        return;
      }
      
      // Sélectionner l'univers directement au clic
      selectUnivers(universItem);
      
      // Ouvrir la galerie seulement si l'univers a des images
      const imagesData = universItem.getAttribute('data-univers-images');
      if (imagesData && imagesData.trim() !== '') {
        openUniversGallery(universItem);
      }
    });


    // Toggle "VOIR PLUS" pour afficher/masquer les univers floraux supplémentaires
    const seeMoreLink = document.getElementById('see-more-link');
    if (seeMoreLink) {
      seeMoreLink.addEventListener('click', function(e) {
        e.preventDefault();
        const universGrid = document.querySelector('.questionnaire-univers-grid');
        if (universGrid) {
          const isExpanded = universGrid.classList.contains('show-all');
          if (isExpanded) {
            universGrid.classList.remove('show-all');
            this.textContent = 'VOIR PLUS';
          } else {
            universGrid.classList.add('show-all');
            this.textContent = 'VOIR MOINS';
          }
        }
      });
    }

    /* ============================================
       ÉTAPE 4 - SÉLECTION MULTIPLE DE BOUQUETS
       ============================================ */
    // Sélection multiple de bouquets (étape 4) - Utilisation des fonctions utilitaires
    const noBouquetBtn = document.getElementById('no-bouquet-btn');
    let selectedBouquets = [];
    const validateStep4 = document.getElementById('validate-step-4');
    
    // Fonction de validation pour l'étape 4
    function updateStep4Validation() {
      setValidationButtonState(validateStep4, 
        selectedBouquets.length === 0 && (!noBouquetBtn || !noBouquetBtn.classList.contains('selected'))
      );
    }
    
    // Setup des sélections multiples avec la fonction utilitaire
    setupMultipleItemSelection(
      '.bouquet-item',
      'data-bouquet-id',
      selectedBouquets,
      noBouquetBtn,
      null,
      updateStep4Validation
    );
    
    // Setup du bouton "Je ne veux pas" avec la fonction utilitaire
    setupNoOptionButton(
      noBouquetBtn,
      '.bouquet-item',
      function(isActive) {
        // Callback onToggle - vider le tableau si le bouton est activé
        if (isActive) {
          selectedBouquets.length = 0; // Vider le tableau
        }
      },
      function() {
        // Callback onValidation - toujours activer le bouton si "Je ne veux pas" est sélectionné
        setValidationButtonState(validateStep4, false);
      }
    );

    // Étape 5 - Bouquets de demoiselles d'honneur
    const yesOption = document.getElementById('yes-option');
    const noOption = document.getElementById('no-option');
    const quantityInput = document.getElementById('demoiselles-quantity');
    const quantityMinus = document.getElementById('quantity-minus');
    const quantityPlus = document.getElementById('quantity-plus');
    const validateStep5 = document.getElementById('validate-step-5');
    let demoisellesChoice = null; // 'yes' ou 'no'
    let demoisellesQuantity = 0;

    if (yesOption && noOption && quantityInput && quantityMinus && quantityPlus && validateStep5) {
      // Désactiver le sélecteur de quantité par défaut
      quantityInput.readOnly = true;
      quantityInput.disabled = true;
      quantityMinus.disabled = true;
      // Le bouton plus reste actif pour permettre la sélection automatique
      quantityPlus.disabled = false;

      // Fonction pour activer l'option OUI
      function activateYesOption() {
        demoisellesChoice = 'yes';
        yesOption.classList.add('selected');
        noOption.classList.remove('selected');
        // Activer le sélecteur de quantité
        quantityInput.readOnly = false;
        quantityInput.disabled = false;
        quantityMinus.disabled = false;
        quantityPlus.disabled = false;
        // Activer le bouton VALIDER
        validateStep5.disabled = false;
      }

      // Sélection OUI
      yesOption.addEventListener('click', function() {
        activateYesOption();
        // Mettre la quantité automatiquement à 1 si elle est à 0
        if (demoisellesQuantity === 0) {
          quantityInput.value = 1;
          demoisellesQuantity = 1;
        }
      });

      // Sélection NON
      noOption.addEventListener('click', function() {
        demoisellesChoice = 'no';
        noOption.classList.add('selected');
        yesOption.classList.remove('selected');
        // Réinitialiser la quantité
        quantityInput.value = 0;
        demoisellesQuantity = 0;
        quantityInput.readOnly = true;
        quantityInput.disabled = true;
        quantityMinus.disabled = true;
        // Le bouton plus reste actif
        quantityPlus.disabled = false;
        // Activer le bouton VALIDER
        validateStep5.disabled = false;
      });

      // Bouton moins
      quantityMinus.addEventListener('click', function(e) {
        e.preventDefault();
        e.stopPropagation();
        let currentValue = parseInt(quantityInput.value) || 0;
        if (currentValue > 0) {
          currentValue--;
          quantityInput.value = currentValue;
          demoisellesQuantity = currentValue;
        }
      });

      // Bouton plus - Sélectionne automatiquement l'option OUI si nécessaire
      quantityPlus.addEventListener('click', function(e) {
        e.preventDefault();
        e.stopPropagation();
        // Si l'option OUI n'est pas sélectionnée, la sélectionner automatiquement
        if (demoisellesChoice !== 'yes') {
          activateYesOption();
          // Mettre la quantité à 1
          quantityInput.value = 1;
          demoisellesQuantity = 1;
        } else {
          // Sinon, juste incrémenter la valeur
          let currentValue = parseInt(quantityInput.value) || 0;
          currentValue++;
          quantityInput.value = currentValue;
          demoisellesQuantity = currentValue;
        }
      });

      // Validation directe de l'input (si l'utilisateur tape)
      quantityInput.addEventListener('input', function() {
        let value = parseInt(this.value) || 0;
        if (value < 0) value = 0;
        this.value = value;
        demoisellesQuantity = value;
      });

      // Empêcher la propagation des clics sur la section de quantité
      const quantitySection = document.querySelector('.yes-no-quantity-section');
      if (quantitySection) {
        quantitySection.addEventListener('click', function(e) {
          e.stopPropagation();
        });
      }

      // Empêcher la propagation des clics sur le sélecteur de quantité
      const quantitySelector = document.querySelector('.quantity-selector');
      if (quantitySelector) {
        quantitySelector.addEventListener('click', function(e) {
          e.stopPropagation();
        });
      }
    }

    // Étape 6 - Éléments du vin d'honneur (utiliser le cache DOM)
    const validateStep6 = DOMCache.validateStep6 || getElement('validate-step-6');
    const step6NoOption = getElement('step6-no-option');
    let selectedElements = [];

    function updateStep6Validation() {
      if (validateStep6) {
        const noOptionSelected = step6NoOption && step6NoOption.classList.contains('selected');
        validateStep6.disabled = (selectedElements.length === 0 && !noOptionSelected);
      }
    }

    // Gestion des éléments normaux (Event delegation - plus performant)
    document.addEventListener('click', function(e) {
      const elementItem = e.target.closest('.element-item');
      if (!elementItem) return;
      
      const elementId = elementItem.getAttribute('data-element-id');
      const wasSelected = elementItem.classList.contains('selected');
      
      // Si le bouton "NON" est sélectionné, le désélectionner
      if (step6NoOption && step6NoOption.classList.contains('selected')) {
        step6NoOption.classList.remove('selected');
      }
      
      // Toggle la sélection de cet élément
      if (wasSelected) {
        elementItem.classList.remove('selected');
        selectedElements = selectedElements.filter(id => id !== elementId);
      } else {
        elementItem.classList.add('selected');
        if (!selectedElements.includes(elementId)) {
          selectedElements.push(elementId);
        }
      }
      
      // Mettre à jour la validation
      updateStep6Validation();
    });

    // Gestion du bouton "JE NE SOUHAITE PAS FLEURIR MON VIN D'HONNEUR"
    if (step6NoOption) {
      step6NoOption.addEventListener('click', function() {
        // Désélectionner tous les éléments
        document.querySelectorAll('.element-item').forEach(item => {
          item.classList.remove('selected');
        });
        selectedElements = [];
        
        // Toggle le bouton "NON"
        this.classList.toggle('selected');
        
        // Mettre à jour la validation
        updateStep6Validation();
      });
    }

    // Étape 7 - Centres de table
    const validateStep7 = document.getElementById('validate-step-7');
    const noDecorationBtn = document.getElementById('step7-no-option');
    const tablesInput = document.getElementById('tables-quantity');
    const tablesError = document.getElementById('tables-error');
    const tablesHelpLink = document.getElementById('tables-help-link');
    const tablesHelpModal = document.getElementById('tables-help-modal');
    const tablesHelpClose = document.getElementById('tables-help-close');
    let selectedDecoration = null;
    let tablesQuantity = 0;
    const step7El = document.querySelector('[data-step="7"]');

    // Validation du champ nombre de tables
    if (tablesInput) {
      // Fonction callback pour mettre à jour la quantité et la validation
      function updateTablesQuantity() {
        tablesQuantity = parseInt(tablesInput.value) || 0;
        updateStep7Validation();
      }
      
      // Utiliser la fonction utilitaire pour la validation du champ
      setupNumericInputValidation(tablesInput, tablesError, 3, updateTablesQuantity);
    }

    // Galerie modale pour l'étape 7 - Utilisation de la classe générique
    // Fonction pour sélectionner une décoration
    function selectDecoration(item) {
      if (!item) return;
      
      if (noDecorationBtn && noDecorationBtn.classList.contains('selected')) {
        noDecorationBtn.classList.remove('selected');
        if (step7El) step7El.classList.remove('step7-no-decoration-active');
        // Réactiver le champ nombre de tables quand on sélectionne une décoration
        if (tablesInput) {
          tablesInput.disabled = false;
          tablesInput.style.opacity = '1';
          tablesInput.style.cursor = 'text';
        }
      }
      
      // Désélectionner tous les autres items de décoration
      document.querySelectorAll('.decoration-item').forEach(i => {
        if (i !== item) {
          i.classList.remove('selected');
        }
      });
      
      // Sélectionner celui-ci
      item.classList.add('selected');
      selectedDecoration = item.getAttribute('data-decoration-id');
      updateStep7Validation();
    }

    // Initialiser la galerie modale pour les décorations
    const decorationGallery = new ImageGalleryModal({
      modalId: 'decoration-gallery-modal',
      imageId: 'decoration-modal-image',
      counterId: 'decoration-modal-counter',
      titleId: 'decoration-modal-title',
      prevId: 'decoration-modal-prev',
      nextId: 'decoration-modal-next',
      closeId: 'decoration-modal-close',
      selectBtnId: 'decoration-modal-select-btn',
      onSelect: selectDecoration
    });
    
    // Fonction pour ouvrir la modal galerie d'une décoration
    function openDecorationGallery(decorationItem) {
      const imagesData = decorationItem.getAttribute('data-decoration-images');
      const decorationTitle = decorationItem.getAttribute('data-decoration-title');
      const imageCount = parseInt(decorationItem.getAttribute('data-image-count')) || 0;
      
      if (!decorationGallery.open(decorationItem, imagesData, decorationTitle, imageCount)) {
        // Si pas d'images, sélectionner la décoration directement
        selectDecoration(decorationItem);
      }
    }

    // Sélection des styles de décoration
    document.querySelectorAll('.decoration-item').forEach(item => {
      item.addEventListener('click', function(e) {
        // Ne pas ouvrir la modal si on clique directement sur le bouton zoom (géré séparément)
        if (e.target.closest('.image-zoom-btn')) {
          return;
        }

        // Carte entière cliquable (image + texte + zone vide) : on sélectionne puis on ouvre la galerie.
        selectDecoration(this);

        // Ouvrir la galerie seulement si la décoration a des images.
        const imagesData = this.getAttribute('data-decoration-images');
        if (imagesData && imagesData.trim() !== '') {
          openDecorationGallery(this);
        }
      });
    });

    // Bouton "Je ne veux pas" - Utilisation de la fonction utilitaire avec callbacks personnalisés
    setupNoOptionButton(
      noDecorationBtn,
      '.decoration-item',
      function(isActive) {
        // Callback onToggle - logique spécifique pour l'étape 7
        if (isActive) {
          if (step7El) step7El.classList.add('step7-no-decoration-active');
          selectedDecoration = null;
          if (tablesInput) {
            tablesInput.value = '';
            tablesQuantity = 0;
            // Désactiver et griser le champ nombre de tables
            tablesInput.disabled = true;
            tablesInput.style.opacity = '0.25';
            tablesInput.style.cursor = 'not-allowed';
            // Masquer l'erreur si elle était affichée
            if (tablesError) {
              tablesError.style.display = 'none';
            }
          }
        } else {
          if (step7El) step7El.classList.remove('step7-no-decoration-active');
          // Réactiver le champ si on désélectionne "Je ne veux pas"
          if (tablesInput) {
            tablesInput.disabled = false;
            tablesInput.style.opacity = '1';
            tablesInput.style.cursor = 'text';
          }
        }
      },
      updateStep7Validation
    );

    function updateStep7Validation() {
      if (validateStep7) {
        const noDecorationSelected = noDecorationBtn && noDecorationBtn.classList.contains('selected');
        const decorationSelected = selectedDecoration !== null;
        
        // Si "Je ne veux pas" est sélectionné, on peut valider
        if (noDecorationSelected) {
          validateStep7.disabled = false;
        } 
        // Si une décoration est sélectionnée, il faut aussi un nombre de tables
        else if (decorationSelected) {
          validateStep7.disabled = tablesQuantity <= 0;
        } 
        // Sinon, on ne peut pas valider
        else {
          validateStep7.disabled = true;
        }
      }
    }

    // Étape 9 - Table d'honneur
    const validateStep9 = document.getElementById('validate-step-9');
    const freshOption = document.getElementById('table-honneur-fresh');
    const artificialOption = document.getElementById('table-honneur-artificial');
    const noTableHonneurBtn = document.getElementById('no-table-honneur-btn');
    const colorSelect = document.getElementById('table-honneur-color');
    const tableHonneurPriceEl = artificialOption ? artificialOption.querySelector('.table-honneur-price') : null;
    // Prix de base rendu côté template (sans couleur). Servira de fallback quand aucune couleur n'est sélectionnée.
    const tableHonneurBasePrice = tableHonneurPriceEl
      ? (parsePriceFromText(tableHonneurPriceEl.textContent) || 0)
      : 0;
    const freshSuboptionsWrapper = document.getElementById('table-honneur-fresh-suboptions-wrapper');
    const freshSuboptionsContainer = document.getElementById('table-honneur-fresh-suboptions');
    const freshSuboptions = document.querySelectorAll('.table-honneur-suboption');
    let tableHonneurChoice = null; // 'fresh', 'artificial', ou 'no'
    let tableHonneurFlowers = 0; // +25 si fresh, 0 si no
    let tableHonneurPrice = 0; // Prix si artificial
    let tableHonneurFreshSuboption = null; // Sous-option sélectionnée pour fresh
    const step9SubGallery = new ImageGalleryModal({
      modalId: 'step9-sub-gallery-modal',
      imageId: 'step9-sub-modal-image',
      counterId: 'step9-sub-modal-counter',
      titleId: 'step9-sub-modal-title',
      prevId: 'step9-sub-modal-prev',
      nextId: 'step9-sub-modal-next',
      closeId: 'step9-sub-modal-close'
    });
    const step10ArcheGallery = new ImageGalleryModal({
      modalId: 'step10-arche-gallery-modal',
      imageId: 'step10-arche-modal-image',
      counterId: 'step10-arche-modal-counter',
      titleId: 'step10-arche-modal-title',
      prevId: 'step10-arche-modal-prev',
      nextId: 'step10-arche-modal-next',
      closeId: 'step10-arche-modal-close'
    });

    function collectStep9SuboptionImages(suboptionItem) {
      if (!suboptionItem) return [];
      const seen = Object.create(null);
      const images = [];

      function pushIfNew(url) {
        if (!url || typeof url !== 'string') return;
        const clean = getUncroppedImageUrl(url.trim());
        if (!clean || seen[clean]) return;
        seen[clean] = true;
        images.push(clean);
      }

      const fullRaw = suboptionItem.getAttribute('data-step9-images-full') || '';
      if (fullRaw) {
        fullRaw.split('|||').forEach(pushIfNew);
      }

      if (images.length === 0) {
        pushIfNew(suboptionItem.getAttribute('data-q-full'));
        pushIfNew(suboptionItem.getAttribute('data-q-thumb'));
        suboptionItem.querySelectorAll('.step9-sub-swiper .swiper-slide img, .table-honneur-image img').forEach(function(img) {
          pushIfNew(img.getAttribute('data-lightbox-src'));
          pushIfNew(img.getAttribute('data-fallback-src'));
          pushIfNew(img.getAttribute('src'));
        });
      }

      return images;
    }

    function openStep9SuboptionGallery(suboptionItem) {
      if (!suboptionItem) return;
      const images = collectStep9SuboptionImages(suboptionItem);
      const titleEl = suboptionItem.querySelector('.table-honneur-title');
      const title = titleEl ? titleEl.textContent.trim() : '';

      if (images.length > 0) {
        step9SubGallery.open(suboptionItem, images.join('|||'), title, images.length);
        return;
      }

      const fallbackBtn = suboptionItem.querySelector('.image-zoom-btn');
      const fallbackSrc = fallbackBtn && fallbackBtn.getAttribute('data-lightbox-src');
      if (fallbackSrc) {
        openLightbox(fallbackSrc);
      }
    }

    function collectStep10ArcheFreshImages(archeItem) {
      if (!archeItem) return [];
      const seen = Object.create(null);
      const images = [];

      function pushIfNew(url) {
        if (!url || typeof url !== 'string') return;
        const clean = getUncroppedImageUrl(url.trim());
        if (!clean || seen[clean]) return;
        seen[clean] = true;
        images.push(clean);
      }

      const fullRaw = archeItem.getAttribute('data-step10-images-full') || '';
      if (fullRaw) {
        fullRaw.split('|||').forEach(pushIfNew);
      }

      if (images.length === 0) {
        pushIfNew(archeItem.getAttribute('data-q-full'));
        pushIfNew(archeItem.getAttribute('data-q-thumb'));
        archeItem.querySelectorAll('.table-honneur-image img').forEach(function(img) {
          pushIfNew(img.getAttribute('data-lightbox-src'));
          pushIfNew(img.getAttribute('data-fallback-src'));
          pushIfNew(img.getAttribute('src'));
        });
      }

      return images;
    }

    function openStep10ArcheFreshGallery(archeItem) {
      if (!archeItem) return;
      const images = collectStep10ArcheFreshImages(archeItem);
      const titleEl = archeItem.querySelector('.table-honneur-title');
      const title = titleEl ? titleEl.textContent.trim() : '';

      if (images.length > 0) {
        step10ArcheGallery.open(archeItem, images.join('|||'), title, images.length);
        return;
      }

      const fallbackBtn = archeItem.querySelector('.image-zoom-btn');
      const fallbackSrc = fallbackBtn && fallbackBtn.getAttribute('data-lightbox-src');
      if (fallbackSrc) {
        openLightbox(fallbackSrc);
      }
    }

    function collectStep10ArcheArtificialImages(archeItem) {
      if (!archeItem) return [];
      const seen = Object.create(null);
      const images = [];

      function pushIfNew(url) {
        if (!url || typeof url !== 'string') return;
        const clean = getUncroppedImageUrl(url.trim());
        if (!clean || seen[clean]) return;
        seen[clean] = true;
        images.push(clean);
      }

      const selectedColorName = archeColorSelect && archeColorSelect.value;
      if (selectedColorName) {
        getColorImagesFromSelect(archeColorSelect, selectedColorName).forEach(pushIfNew);
      }

      if (images.length === 0) {
        const activeGallery = document.querySelector('#arche-color-galleries .arche-color-gallery.is-active');
        const activeColorName = activeGallery && activeGallery.getAttribute('data-color-name');
        if (activeColorName && archeColorSelect) {
          getColorImagesFromSelect(archeColorSelect, activeColorName).forEach(pushIfNew);
        }
      }

      if (images.length === 0) {
        const activeGallery = document.querySelector('#arche-color-galleries .arche-color-gallery.is-active');
        if (activeGallery) {
          activeGallery.querySelectorAll('.arche-color-image-swiper .swiper-slide img, .arche-color-image-swiper-container img').forEach(function(img) {
            pushIfNew(img.getAttribute('data-lightbox-src'));
            pushIfNew(img.getAttribute('data-fallback-src'));
            pushIfNew(img.getAttribute('src'));
          });
        }
      }

      if (images.length === 0) {
        pushIfNew(archeItem.getAttribute('data-q-full'));
        pushIfNew(archeItem.getAttribute('data-q-thumb'));
      }

      return images;
    }

    function openStep10ArcheArtificialGallery(archeItem) {
      if (!archeItem) return;
      const images = collectStep10ArcheArtificialImages(archeItem);
      const titleEl = archeItem.querySelector('.table-honneur-title');
      const title = titleEl ? titleEl.textContent.trim() : '';

      if (images.length > 0) {
        step10ArcheGallery.open(archeItem, images.join('|||'), title, images.length);
        return;
      }

      const fallbackBtn = archeItem.querySelector('.image-zoom-btn');
      const fallbackSrc = fallbackBtn && fallbackBtn.getAttribute('data-lightbox-src');
      if (fallbackSrc) {
        openLightbox(fallbackSrc);
      }
    }

    function collectStep11ChairFreshImages(chairItem) {
      if (!chairItem) return [];
      const seen = Object.create(null);
      const images = [];

      function pushIfNew(url) {
        if (!url || typeof url !== 'string') return;
        const clean = getUncroppedImageUrl(url.trim());
        if (!clean || seen[clean]) return;
        seen[clean] = true;
        images.push(clean);
      }

      const fullRaw = chairItem.getAttribute('data-step11-images-full') || '';
      if (fullRaw) {
        fullRaw.split('|||').forEach(pushIfNew);
      }

      if (images.length === 0) {
        pushIfNew(chairItem.getAttribute('data-q-full'));
        pushIfNew(chairItem.getAttribute('data-q-thumb'));
        chairItem.querySelectorAll('.table-honneur-image img').forEach(function(img) {
          pushIfNew(img.getAttribute('data-lightbox-src'));
          pushIfNew(img.getAttribute('data-fallback-src'));
          pushIfNew(img.getAttribute('src'));
        });
      }

      return images;
    }

    function openStep11ChairFreshGallery(chairItem) {
      if (!chairItem) return;
      const images = collectStep11ChairFreshImages(chairItem);
      const titleEl = chairItem.querySelector('.table-honneur-title');
      const title = titleEl ? titleEl.textContent.trim() : '';

      if (images.length > 0) {
        step10ArcheGallery.open(chairItem, images.join('|||'), title, images.length);
        return;
      }

      const fallbackBtn = chairItem.querySelector('.image-zoom-btn');
      const fallbackSrc = fallbackBtn && fallbackBtn.getAttribute('data-lightbox-src');
      if (fallbackSrc) {
        openLightbox(fallbackSrc);
      }
    }

    function collectProductCardImages(cardEl) {
      if (!cardEl) return [];
      const seen = Object.create(null);
      const images = [];

      function pushIfNew(url) {
        if (!url || typeof url !== 'string') return;
        const clean = getUncroppedImageUrl(url.trim());
        if (!clean || seen[clean]) return;
        seen[clean] = true;
        images.push(clean);
      }

      const fullRaw = cardEl.getAttribute('data-product-images-full') || '';
      if (fullRaw) {
        fullRaw.split('|||').forEach(pushIfNew);
      }

      if (images.length === 0) {
        cardEl.querySelectorAll('.container-item-image img, .gift-bag-item-image img, .table-honneur-image img').forEach(function(img) {
          pushIfNew(img.getAttribute('data-lightbox-src'));
          pushIfNew(img.getAttribute('data-fallback-src'));
          pushIfNew(img.getAttribute('src'));
        });
      }

      return images;
    }

    function openProductCardGallery(cardEl, titleSelector) {
      if (!cardEl) return;
      const images = collectProductCardImages(cardEl);
      const titleEl = cardEl.querySelector(titleSelector || '.container-item-label, .gift-bag-item-label');
      const title = titleEl ? titleEl.textContent.trim() : '';

      if (images.length > 0) {
        step10ArcheGallery.open(cardEl, images.join('|||'), title, images.length);
        return;
      }

      const fallbackBtn = cardEl.querySelector('.image-zoom-btn');
      const fallbackSrc = fallbackBtn && fallbackBtn.getAttribute('data-lightbox-src');
      if (fallbackSrc) {
        openLightbox(fallbackSrc);
      }
    }

    function collectStep11ChairArtificialImages(chairItem) {
      if (!chairItem) return [];
      const seen = Object.create(null);
      const images = [];

      function pushIfNew(url) {
        if (!url || typeof url !== 'string') return;
        const clean = getUncroppedImageUrl(url.trim());
        if (!clean || seen[clean]) return;
        seen[clean] = true;
        images.push(clean);
      }

      const selectedColorName = chairColorSelect && chairColorSelect.value;
      if (selectedColorName) {
        getColorImagesFromSelect(chairColorSelect, selectedColorName).forEach(pushIfNew);
      }

      if (images.length === 0) {
        const activeImg = chairItem.querySelector('.table-honneur-image img');
        if (activeImg) {
          pushIfNew(activeImg.getAttribute('data-lightbox-src'));
          pushIfNew(activeImg.getAttribute('data-fallback-src'));
          pushIfNew(activeImg.getAttribute('src'));
        }
      }

      if (images.length === 0) {
        pushIfNew(chairItem.getAttribute('data-q-full'));
        pushIfNew(chairItem.getAttribute('data-q-thumb'));
      }

      return images;
    }

    function openStep11ChairArtificialGallery(chairItem) {
      if (!chairItem) return;
      const images = collectStep11ChairArtificialImages(chairItem);
      const title = '';

      if (images.length > 0) {
        step10ArcheGallery.open(chairItem, images.join('|||'), title, images.length);
        return;
      }

      const fallbackBtn = chairItem.querySelector('.image-zoom-btn');
      const fallbackSrc = fallbackBtn && fallbackBtn.getAttribute('data-lightbox-src');
      if (fallbackSrc) {
        openLightbox(fallbackSrc);
      }
    }

    function updateStep9Validation() {
      if (validateStep9) {
        // Si une option est sélectionnée, on peut valider
        // Pour fresh, il faut aussi une sous-option sélectionnée
        // Pour artificial, il faut aussi une couleur sélectionnée
        if (tableHonneurChoice === 'fresh') {
          validateStep9.disabled = !tableHonneurFreshSuboption;
        } else if (tableHonneurChoice === 'no') {
          validateStep9.disabled = false;
        } else if (tableHonneurChoice === 'artificial') {
          validateStep9.disabled = !colorSelect || colorSelect.value === '';
        } else {
          validateStep9.disabled = true;
        }
      }
    }

    function applyStep9ArtificialColorSelection(selectedOption) {
      const hasColor = !!(selectedOption && selectedOption.value);
      const colorPrice = hasColor
        ? (parseFloat(selectedOption.getAttribute('data-price')) || 0)
        : 0;
      const colorImages = hasColor
        ? ((selectedOption.getAttribute('data-color-images') || '').split('|||').map(function(u) { return u.trim(); }).filter(Boolean))
        : [];
      let colorThumb = hasColor
        ? (colorImages[0] || selectedOption.getAttribute('data-image-thumb') || selectedOption.getAttribute('data-image') || '')
        : '';
      let colorFull = hasColor
        ? (colorImages[colorImages.length - 1] || selectedOption.getAttribute('data-image-full') || colorThumb)
        : '';

      if (!colorThumb && artificialOption) {
        const currentImg = artificialOption.querySelector('.table-honneur-image img');
        if (currentImg) {
          colorThumb = currentImg.getAttribute('data-fallback-src') || currentImg.getAttribute('src') || '';
          colorFull = currentImg.getAttribute('data-lightbox-src') || colorFull || colorThumb;
        }
      }

      // Quand aucune couleur n'est choisie (placeholder value=""), on affiche le prix de base
      // uniquement si l'option artificial est réellement sélectionnée.
      const priceToApply = hasColor
        ? colorPrice
        : (tableHonneurChoice === 'artificial' ? tableHonneurBasePrice : 0);

      tableHonneurPrice = priceToApply;

      if (tableHonneurPriceEl) {
        tableHonneurPriceEl.textContent = (priceToApply > 0 ? priceToApply : 0) + ' €';
      }

      if (colorThumb && artificialOption) {
        ensureTableHonneurImage(artificialOption, colorThumb, colorFull || colorThumb);
      }
    }

    const step9SubSwipers = {};

    function initQuestionnairePresetSwiper(swiperEl) {
      if (!swiperEl || typeof Swiper === 'undefined') {
        return null;
      }
      const count = swiperEl.querySelectorAll('.swiper-slide').length;
      if (count === 0) {
        return null;
      }
      const showNav = count > 1;
      const nextBtn = swiperEl.querySelector('.swiper-button-next');
      const prevBtn = swiperEl.querySelector('.swiper-button-prev');
      const pagination = swiperEl.querySelector('.swiper-pagination');
      if (nextBtn) nextBtn.style.display = showNav ? '' : 'none';
      if (prevBtn) prevBtn.style.display = showNav ? '' : 'none';
      if (pagination) pagination.style.display = showNav ? '' : 'none';
      if (swiperEl.swiper) {
        swiperEl.swiper.destroy(true, true);
      }
      const inst = new Swiper(swiperEl, {
        slidesPerView: 1,
        spaceBetween: 0,
        loop: false,
        observer: true,
        observeParents: true,
        watchOverflow: true,
        navigation: showNav ? { nextEl: nextBtn, prevEl: prevBtn } : false,
        pagination: showNav ? { el: pagination, clickable: true, type: 'bullets' } : false
      });
      const stepRoot = swiperEl.closest('[data-step]');
      if (stepRoot) {
        reloadStepImages(stepRoot);
        scheduleSwiperUpdates(stepRoot);
      }
      requestAnimationFrame(function() {
        if (inst && typeof inst.update === 'function') {
          inst.update();
        }
      });
      return inst;
    }
    const arrayImageSubOptionsStep9 = [
      'https://dev.flor-easy.com/cdn/shop/files/22_d01ef8b0-6975-429f-9c1b-13a9f5d56a85.jpg?v=1779093701&width=1200',
      'https://dev.flor-easy.com/cdn/shop/files/28_6a0a93e3-9a8d-464a-b060-c3ddb628ea14.jpg?v=1779095953&width=1200',
      'https://dev.flor-easy.com/cdn/shop/files/25_7e44f1ff-4c80-4dae-870c-786815937b94.jpg?v=1779096005&width=1200',
      'https://dev.flor-easy.com/cdn/shop/files/31_ada45e4d-1282-498b-a0ae-4f9964fd03e5.jpg?v=1779096048&width=1200'
    ]

    function initStep9SubSwipers(rootEl) {
      const scope = rootEl || document.querySelector('[data-step="9"]');
      if (!scope) {
        return;
      }
      bindStep9ZoomButtons(scope);
      scope.querySelectorAll('.step9-sub-swiper').forEach(function(swiperEl, index) {
        const card = swiperEl.closest('.table-honneur-suboption');
        const cardId = card ? card.id || '' : '';
        if (typeof Swiper === 'undefined') {
          if (card) {
            const firstSlideImage = swiperEl.querySelector('.swiper-slide img');
            const thumbUrl = firstSlideImage && (firstSlideImage.getAttribute('src') || firstSlideImage.getAttribute('data-fallback-src'));
            const fullUrl = firstSlideImage && (firstSlideImage.getAttribute('data-lightbox-src') || thumbUrl);
            if (thumbUrl) {
              ensureTableHonneurImage(card, thumbUrl, fullUrl || thumbUrl);
              return;
            }
          }
        }
        if (!swiperEl.querySelector('.swiper-slide')) {
          if (card) {
            const fullRaw = card.getAttribute('data-step9-images-full') || '';
            const thumbRaw = card.getAttribute('data-step9-images-thumb') || fullRaw;
            const fullArr = fullRaw.split('|||').filter(Boolean);
            const thumbArr = thumbRaw.split('|||').filter(Boolean);
            const fallbackByIndex = arrayImageSubOptionsStep9[index] || arrayImageSubOptionsStep9[0] || '';
            const thumb = thumbArr[0] || fullArr[0] || fallbackByIndex;
            const full = fullArr[0] || thumbArr[0] || fallbackByIndex;
            if (thumb) {
              ensureTableHonneurImage(card, thumb, full || thumb);
            }
          }
          return;
        }
        const container = card && card.querySelector('.step9-sub-swiper-container');
        if (container) {
          container.style.display = 'block';
        }
        if (step9SubSwipers[cardId]) {
          step9SubSwipers[cardId].destroy(true, true);
          step9SubSwipers[cardId] = null;
        }
        step9SubSwipers[cardId] = initQuestionnairePresetSwiper(swiperEl);
        if (!step9SubSwipers[cardId] && card) {
          const firstSlideImage = swiperEl.querySelector('.swiper-slide img');
          const fallbackByIndex = arrayImageSubOptionsStep9[index] || arrayImageSubOptionsStep9[0] || '';
          const thumb =
            (firstSlideImage && (firstSlideImage.getAttribute('src') || firstSlideImage.getAttribute('data-fallback-src'))) ||
            fallbackByIndex;
          const full =
            (firstSlideImage && (firstSlideImage.getAttribute('data-lightbox-src') || thumb)) ||
            fallbackByIndex ||
            thumb;
          if (thumb) {
            ensureTableHonneurImage(card, thumb, full || thumb);
          }
        }
      });

      // Fallback robuste : si aucun swiper n'est rendu pour une sous-option,
      // injecter quand même une image via les data-attributes déjà présentes.
      scope.querySelectorAll('.table-honneur-suboption').forEach(function(card, index) {
        if (card.querySelector('.step9-sub-swiper')) {
          return;
        }
        if (card.querySelector('.table-honneur-image img')) {
          return;
        }
        const fullRaw = card.getAttribute('data-step9-images-full') || '';
        const thumbRaw = card.getAttribute('data-step9-images-thumb') || fullRaw;
        const fullArr = fullRaw.split('|||').filter(Boolean);
        const thumbArr = thumbRaw.split('|||').filter(Boolean);
        const fallbackByIndex = arrayImageSubOptionsStep9[index] || arrayImageSubOptionsStep9[0] || '';
        const thumb = thumbArr[0] || fullArr[0] || fallbackByIndex;
        const full = fullArr[0] || thumbArr[0] || fallbackByIndex;
        if (thumb) {
          ensureTableHonneurImage(card, thumb, full || thumb);
        }
      });
    }

    // Fonction pour afficher/masquer les sous-options
    function toggleFreshSuboptions(show) {
      if (freshSuboptionsWrapper) {
        freshSuboptionsWrapper.style.display = show ? 'block' : 'none';
      }
      if (freshSuboptionsContainer) {
        freshSuboptionsContainer.style.display = show ? 'grid' : 'none';
      }
      if (!show) {
        // Désélectionner toutes les sous-options si on masque
        freshSuboptions.forEach(suboption => {
          suboption.classList.remove('selected');
        });
        tableHonneurFreshSuboption = null;
      } else {
        setTimeout(function() {
          if (freshSuboptionsWrapper) {
            primeImagesInRoot(freshSuboptionsWrapper);
          }
          initStep9SubSwipers();
          fixBrokenImagesInStep(document.querySelector('[data-step="9"]'));
        }, 50);
      }
    }

    // Option fleurs fraîches (reclic = désélection)
    if (freshOption) {
      freshOption.addEventListener('click', function(e) {
        if (e.target.closest('.image-zoom-btn')) return;

        if (this.classList.contains('selected')) {
          this.classList.remove('selected');
          tableHonneurChoice = null;
          tableHonneurFlowers = 0;
          tableHonneurPrice = 0;
          toggleFreshSuboptions(false);
          updateStep9Validation();
          return;
        }

        if (artificialOption) artificialOption.classList.remove('selected');
        if (noTableHonneurBtn) noTableHonneurBtn.classList.remove('selected');

        this.classList.add('selected');
        tableHonneurChoice = 'fresh';
        tableHonneurFlowers = 25; // +25 fleurs
        tableHonneurPrice = 0;

        toggleFreshSuboptions(true);

        updateStep9Validation();
      });
    }

    // Option fleurs artificielles (reclic = désélection)
    if (artificialOption) {
      artificialOption.addEventListener('click', function(e) {
        if (e.target.closest('.image-zoom-btn') || e.target.closest('.table-honneur-color-selector')) return;

        if (this.classList.contains('selected')) {
          this.classList.remove('selected');
          tableHonneurChoice = null;
          tableHonneurFlowers = 0;
          tableHonneurPrice = 0;
          if (colorSelect) {
            colorSelect.value = '';
            colorSelect.dispatchEvent(new Event('change', { bubbles: true }));
          } else {
            updateStep9Validation();
          }
          return;
        }

        if (freshOption) freshOption.classList.remove('selected');
        if (noTableHonneurBtn) noTableHonneurBtn.classList.remove('selected');

        this.classList.add('selected');
        tableHonneurChoice = 'artificial';
        tableHonneurFlowers = 0;

        toggleFreshSuboptions(false);

        if (colorSelect) {
          const selectedOption = colorSelect.options[colorSelect.selectedIndex];
          applyStep9ArtificialColorSelection(selectedOption);
        }

        updateStep9Validation();
      });
    }

    // Sous-options fleurs fraîches (reclic = désélection)
    freshSuboptions.forEach(suboption => {
      suboption.addEventListener('click', function(e) {
        if (e.target.closest('.image-zoom-btn')) return;
        if (e.target.closest('.swiper-button-next') || e.target.closest('.swiper-button-prev') || e.target.closest('.swiper-pagination')) return;

        if (this.classList.contains('selected')) {
          this.classList.remove('selected');
          tableHonneurFreshSuboption = null;
          updateStep9Validation();
          return;
        }

        freshSuboptions.forEach(opt => opt.classList.remove('selected'));

        this.classList.add('selected');
        tableHonneurFreshSuboption = this.getAttribute('data-suboption');

        updateStep9Validation();
      });
    });

    // Sélecteur de couleur pour artificial
    if (colorSelect) {
      colorSelect.addEventListener('change', function() {
        const selectedOption = this.options[this.selectedIndex];
        if (selectedOption && selectedOption.value) {
          if (freshOption) freshOption.classList.remove('selected');
          if (noTableHonneurBtn) noTableHonneurBtn.classList.remove('selected');
          if (artificialOption) artificialOption.classList.add('selected');
          tableHonneurChoice = 'artificial';
          tableHonneurFlowers = 0;
          toggleFreshSuboptions(false);
        }
        applyStep9ArtificialColorSelection(selectedOption);
        updateStep9Validation();
      });

      // Synchronisation initiale (retour d'étape / valeur restaurée navigateur).
      const initialOption = colorSelect.options[colorSelect.selectedIndex];
      if (initialOption && initialOption.value) {
        applyStep9ArtificialColorSelection(initialOption);
      }
    }

    // Option NON - Utilisation de la fonction utilitaire
    setupNoOptionButton(
      noTableHonneurBtn,
      [freshOption, artificialOption],
      function(isActive) {
        // Callback onToggle
        if (isActive) {
          tableHonneurChoice = 'no';
          tableHonneurFlowers = 0;
          tableHonneurPrice = 0;
          // Masquer les sous-options
          toggleFreshSuboptions(false);
        } else {
          tableHonneurChoice = null;
        }
      },
      updateStep9Validation
    );

    // Étape 10 - Arche fleurie
    const validateStep10 = document.getElementById('validate-step-10');
    const archeFresh = document.getElementById('arche-fresh');
    const archeArtificial = document.getElementById('arche-artificial');
    const archeArtificialPriceEl = document.getElementById('arche-artificial-price');
    const noArcheBtn = document.getElementById('no-arche-btn');
    const archeColorSelect = document.getElementById('arche-color');
    const noSupportBtn = document.getElementById('no-support-btn');
    
    let archeChoice = null; // 'fresh', 'artificial', ou 'no'
    let archeFlowers = 0; // +25 si fresh, 0 si no
    const archeBasePrice = archeArtificialPriceEl
      ? (parsePriceFromText(archeArtificialPriceEl.textContent) || 0)
      : (parseFloat(window.questionnaireConfig && window.questionnaireConfig.step10ArtificialPrice) || 0);
    let archePrice = archeBasePrice; // Prix si artificial
    let archeColorBeforeNo = null; // Sauvegarder la couleur sélectionnée avant de cliquer sur "NON"
    let supportChoice = null; // ID du support sélectionné ou 'no'
    let supportPrice = 0; // Prix du support
    let supportForm = null; // Index de la forme sélectionnée (0 pour image principale, 1-5 pour image_1 à image_5)

    function updateArcheArtificialPriceDisplay() {
      if (!archeArtificialPriceEl) return;
      const displayedPrice = (archeChoice === 'artificial')
        ? (archePrice > 0 ? archePrice : archeBasePrice)
        : archeBasePrice;
      archeArtificialPriceEl.textContent = ((displayedPrice > 0 ? displayedPrice : 0) + ' €');
      archeArtificialPriceEl.style.display = 'block';
    }

    function updateStep10Validation() {
      updateArcheArtificialPriceDisplay();
      if (validateStep10) {
        // L'arche doit être sélectionnée
        if (!archeChoice) {
          validateStep10.disabled = true;
          return;
        }
        
        // Si artificial, il faut une couleur
        if (archeChoice === 'artificial' && (!archeColorSelect || archeColorSelect.value === '')) {
          validateStep10.disabled = true;
          return;
        }
        
        // Le support : choix dans la liste déroulante suffit (pas de 2e clic « forme » requis)
        
        validateStep10.disabled = false;
      }
    }

    function setSelectedArcheColorSlide(targetSlide) {
      if (!targetSlide) return;
      document.querySelectorAll('.arche-color-slide.selected').forEach(function(slide) {
        slide.classList.remove('selected');
      });
      targetSlide.classList.add('selected');
    }

    // Option fleurs fraîches pour l'arche
    if (archeFresh) {
      archeFresh.addEventListener('click', function(e) {
        if (e.target.closest('.image-zoom-btn') || e.target.closest('.table-honneur-color-selector')) {
          return;
        }

        if (this.classList.contains('selected')) {
          this.classList.remove('selected');
          archeChoice = null;
          archeFlowers = 0;
          archePrice = 0;
          updateStep10Validation();
          return;
        }

        if (archeArtificial) archeArtificial.classList.remove('selected');
        if (noArcheBtn) noArcheBtn.classList.remove('selected');
        
        this.classList.add('selected');
        archeChoice = 'fresh';
        archeFlowers = 25; // +25 fleurs
        archePrice = 0;
        
        // Le swiper reste visible mais on ne change pas d'image
        // (le swiper fait partie de l'image principale maintenant)
        
        updateStep10Validation();
      });
    }

    // Option fleurs artificielles pour l'arche
    if (archeArtificial) {
      archeArtificial.addEventListener('click', function(e) {
        if (e.target.closest('.image-zoom-btn') || e.target.closest('.table-honneur-color-selector')) {
          return;
        }

        if (this.classList.contains('selected')) {
          this.classList.remove('selected');
          archeChoice = null;
          archeFlowers = 0;
          archePrice = 0;
          hideArcheColorSwiper();
          showArcheArtificialMainImage();
          updateStep10Validation();
          return;
        }

        if (archeFresh) archeFresh.classList.remove('selected');
        if (noArcheBtn) noArcheBtn.classList.remove('selected');
        
        this.classList.add('selected');
        archeChoice = 'artificial';
        archeFlowers = 0;
        
        // Si une couleur est déjà sélectionnée, afficher ses images
        if (archeColorSelect && archeColorSelect.value) {
          const selectedOption = archeColorSelect.options[archeColorSelect.selectedIndex];
          archePrice = (selectedOption && parseFloat(selectedOption.getAttribute('data-price'))) || 0;
          changeArcheColorImage(archeColorSelect.value);
        } else {
          archePrice = archeBasePrice;
          hideArcheColorSwiper();
          showArcheArtificialMainImage();
        }
        
        updateStep10Validation();
      });
    }

    // Gestion du swiper d'images pour les couleurs de l'arche (galeries pré-rendues en Liquid)
    let archeColorSwiper = null;
    const archeColorGalleriesRoot = document.getElementById('arche-color-galleries');

    function hideArcheColorStaticPreview() {
      const staticPreview = document.getElementById('arche-color-static-preview');
      if (!staticPreview) {
        return;
      }
      staticPreview.style.display = 'none';
      staticPreview.hidden = true;
      staticPreview.setAttribute('aria-hidden', 'true');
    }

    function showArcheArtificialMainImage() {
      const mainImage = document.getElementById('arche-artificial-main-image');
      if (mainImage) {
        mainImage.style.display = '';
      }
    }

    function hideArcheArtificialMainImage() {
      const mainImage = document.getElementById('arche-artificial-main-image');
      if (mainImage) {
        mainImage.style.display = 'none';
      }
    }

    function hideArcheColorSwiper() {
      if (archeColorSwiper) {
        archeColorSwiper.destroy(true, true);
        archeColorSwiper = null;
      }
      if (!archeColorGalleriesRoot) {
        return;
      }
      archeColorGalleriesRoot.style.display = 'none';
      archeColorGalleriesRoot.setAttribute('aria-hidden', 'true');
      archeColorGalleriesRoot.querySelectorAll('.arche-color-gallery').forEach(function(gallery) {
        gallery.classList.remove('is-active');
        gallery.classList.add('is-inactive');
        gallery.setAttribute('aria-hidden', 'true');
        const swiperEl = gallery.querySelector('.arche-color-image-swiper');
        if (swiperEl && swiperEl.swiper) {
          swiperEl.swiper.destroy(true, true);
        }
      });
    }

    function setArcheColorStaticPreview(colorName) {
      const optionEl = document.getElementById('arche-artificial');
      const selectEl = document.getElementById('arche-color');
      if (!optionEl || !selectEl) {
        return false;
      }
      const selectedColor = colorName || selectEl.value;
      const images = getColorImagesFromSelect(selectEl, selectedColor);
      if (!images.length) {
        return false;
      }
      const thumb = resizeShopifyImageUrl(images[0], 600) || images[0];
      const full = images[images.length - 1] || images[0];
      ensureTableHonneurImage(optionEl, thumb, full);
      showArcheArtificialMainImage();
      return true;
    }

    window.__setArcheColorStaticPreview = setArcheColorStaticPreview;

    function showArcheColorGallery(colorName) {
      // Étape 10 (arche artificielle) sans swiper:
      // on affiche seulement l'image principale de la couleur choisie.
      if (!colorName) {
        return false;
      }
      hideArcheColorSwiper();
      const hasStatic = setArcheColorStaticPreview(colorName);
      if (!hasStatic) {
        showArcheArtificialMainImage();
      }
      return hasStatic;
    }

    window.__rebuildArcheColorSwiper = showArcheColorGallery;

    function initArcheColorSwiper() {
      if (!archeColorGalleriesRoot) {
        return;
      }
      let colorName = archeColorSelect && archeColorSelect.value;
      if (colorName) {
        showArcheColorGallery(colorName);
      } else {
        hideArcheColorSwiper();
        showArcheArtificialMainImage();
      }
    }

    function changeArcheColorImage(colorName) {
      if (!colorName) {
        return;
      }
      showArcheColorGallery(colorName);
    }

    // Fonction pour configurer la sélection des slides de couleur par clic
    function setupArcheColorSlideSelection() {
      if (archeColorGalleriesRoot) {
        archeColorGalleriesRoot.removeEventListener('click', handleArcheColorSlideClick);
        archeColorGalleriesRoot.addEventListener('click', handleArcheColorSlideClick);
      }
    }

    // Handler pour les clics sur les slides de couleur
    function handleArcheColorSlideClick(e) {
      const slide = e.target.closest('.arche-color-slide');
      if (!slide) return;
      
      // Ne pas déclencher si on clique sur le bouton zoom
      if (e.target.closest('.image-zoom-btn')) {
        return;
      }
      
      // Ne pas déclencher si on clique sur les boutons de navigation du swiper
      if (e.target.closest('.swiper-button-next') || e.target.closest('.swiper-button-prev') || e.target.closest('.swiper-pagination')) {
        return;
      }
      
      // Récupérer le nom de la couleur de cette slide
      const slideColorName = slide.getAttribute('data-color-name');
      if (!slideColorName) return;
      
      // Aligner le comportement visuel sur l'étape 9 : une seule slide sélectionnée (fond rose + coche)
      setSelectedArcheColorSlide(slide);
    }

    // Sélecteur de couleur pour l'arche artificielle
    if (archeColorSelect) {
      archeColorSelect.addEventListener('change', function() {
        const selectedOption = this.options[this.selectedIndex];
        if (selectedOption && selectedOption.value) {
          if (archeFresh) archeFresh.classList.remove('selected');
          if (noArcheBtn) noArcheBtn.classList.remove('selected');
          if (archeArtificial) archeArtificial.classList.add('selected');
          archeChoice = 'artificial';
          archeFlowers = 0;

          archePrice = parseFloat(selectedOption.getAttribute('data-price')) || 0;
          // Utiliser le nom de la couleur (value du select) au lieu de l'ID
          changeArcheColorImage(selectedOption.value);
        } else {
          archePrice = (archeChoice === 'artificial') ? archeBasePrice : 0;
          hideArcheColorSwiper();
          showArcheArtificialMainImage();
        }
        updateStep10Validation();
      });
    }

    // Option NON pour l'arche - Utilisation de la fonction utilitaire
    setupNoOptionButton(
      noArcheBtn,
      [archeFresh, archeArtificial],
      function(isActive) {
        // Callback onToggle
        if (isActive) {
          archeChoice = 'no';
          archeFlowers = 0;
          archePrice = 0;
          
          // Réinitialiser le select de couleur à "Sélectionner une couleur"
          if (archeColorSelect) {
            archeColorSelect.value = '';
            // Déclencher le changement pour masquer les slides
            const changeEvent = new Event('change', { bubbles: true });
            archeColorSelect.dispatchEvent(changeEvent);
          }
          
          hideArcheColorSwiper();
        } else {
          archeChoice = null;
        }
      },
      updateStep10Validation
    );

    // Gestion de la sélection de forme dans le swiper
    function selectSupportForm(formSlide) {
      const supportId = formSlide.getAttribute('data-support-id');
      const formIndex = formSlide.getAttribute('data-form-index');
      
      // Désélectionner toutes les autres formes du même support
      const allFormSlides = document.querySelectorAll('.support-form-slide[data-support-id="' + supportId + '"]');
      allFormSlides.forEach(function(slide) {
        slide.classList.remove('selected');
      });
      
      // Sélectionner cette forme
      formSlide.classList.add('selected');
      
      // S'assurer que le select a la bonne valeur
      if (supportProductSelect && supportProductSelect.value !== supportId) {
        supportProductSelect.value = supportId;
        // Mettre à jour l'affichage si nécessaire
        updateSupportProductDisplay(supportId);
      }
      
      // S'assurer que le support est sélectionné dans les variables globales
      if (supportChoice !== supportId) {
        const selectedOption = supportProductSelect ? supportProductSelect.querySelector('option[value="' + supportId + '"]') : null;
        if (selectedOption) {
          supportChoice = supportId;
          supportPrice = parseFloat(selectedOption.getAttribute('data-support-price')) || 0;
        }
      }
      
      // Désélectionner le bouton "NON"
      if (noSupportBtn) {
        noSupportBtn.classList.remove('selected');
      }
      
      // S'assurer que la carte a la classe selected
      const supportDisplay = document.getElementById('support-product-display');
      if (supportDisplay) {
        supportDisplay.classList.add('selected');
      }
      
      // Stocker la forme sélectionnée
      supportForm = formIndex;
      
      updateStep10Validation();
    }
    
    // Gestion du select pour choisir le produit de support
    const supportProductSelect = document.getElementById('support-product-select');
    const supportProductDisplay = document.getElementById('support-product-display');
    const supportCustomSelect = document.querySelector('[data-support-custom-select]');
    const supportCustomTrigger = supportCustomSelect ? supportCustomSelect.querySelector('[data-support-custom-trigger]') : null;
    const supportCustomLabel = supportCustomSelect ? supportCustomSelect.querySelector('[data-support-custom-label]') : null;
    const supportCustomThumb = supportCustomSelect ? supportCustomSelect.querySelector('[data-support-custom-thumb]') : null;
    const supportCustomMenu = supportCustomSelect ? supportCustomSelect.querySelector('.support-product-custom-select__menu') : null;
    let supportSwiper = null; // Variable globale pour le swiper du support

    function getSupportDisplayLabel(optionEl) {
      if (!optionEl) {
        return '';
      }
      const displayLabel = optionEl.getAttribute('data-support-display-label');
      if (displayLabel) {
        return displayLabel.trim();
      }
      const title = (optionEl.getAttribute('data-support-title') || optionEl.textContent || '').trim();
      const price = parseFloat(optionEl.getAttribute('data-support-price')) || 0;
      if (price > 0) {
        const v = Math.round(price * 100) / 100;
        const s = (v % 1 === 0) ? String(v) : v.toFixed(2).replace('.', ',');
        return title + ' - ' + s + ' € TTC';
      }
      return title;
    }

    function getSupportMainThumb(optionEl) {
      if (!optionEl) {
        return '';
      }
      const directThumb = optionEl.getAttribute('data-support-main-thumb') || '';
      if (directThumb) {
        return directThumb;
      }
      const rawThumbs = optionEl.getAttribute('data-support-images-thumb') || '';
      const rawImages = optionEl.getAttribute('data-support-images') || '';
      const thumbCandidate = rawThumbs.split('|||').filter(Boolean)[0] || rawImages.split('|||').filter(Boolean)[0] || '';
      if (thumbCandidate) {
        optionEl.setAttribute('data-support-main-thumb', thumbCandidate);
      }
      return thumbCandidate;
    }

    function setSupportCustomTrigger(label, thumbUrl) {
      if (supportCustomLabel) {
        supportCustomLabel.textContent = label || 'Sélectionner un produit';
      }
      if (!supportCustomThumb) {
        return;
      }
      if (thumbUrl) {
        supportCustomThumb.src = thumbUrl;
        supportCustomThumb.alt = label ? ('Image de ' + label) : 'Image du support';
        supportCustomThumb.hidden = false;
      } else {
        supportCustomThumb.src = '';
        supportCustomThumb.alt = '';
        supportCustomThumb.hidden = true;
      }
    }

    function updateSupportCustomSelectState(value) {
      if (!supportCustomSelect) {
        return;
      }
      const normalizedValue = typeof value === 'string' ? value : '';
      const nativeOption = supportProductSelect
        ? supportProductSelect.querySelector('option[value="' + normalizedValue + '"]')
        : null;
      const selectedLabel = nativeOption ? getSupportDisplayLabel(nativeOption) : 'Sélectionner un produit';
      const selectedThumb = nativeOption ? getSupportMainThumb(nativeOption) : '';
      setSupportCustomTrigger(selectedLabel.trim(), selectedThumb);

      supportCustomSelect.querySelectorAll('[data-support-custom-option]').forEach(function(customOption) {
        const isSelected = customOption.getAttribute('data-value') === normalizedValue;
        customOption.classList.toggle('is-selected', isSelected);
        customOption.setAttribute('aria-selected', isSelected ? 'true' : 'false');
      });
    }

    function refreshSupportCustomSelectThumbs() {
      if (!supportCustomSelect || !supportProductSelect) {
        return;
      }
      supportCustomSelect.querySelectorAll('[data-support-custom-option]').forEach(function(customOption) {
        const optionValue = customOption.getAttribute('data-value');
        if (!optionValue) {
          return;
        }
        const nativeOption = supportProductSelect.querySelector('option[value="' + optionValue + '"]');
        if (!nativeOption) {
          return;
        }
        const thumbUrl = getSupportMainThumb(nativeOption);
        const optionLabel = getSupportDisplayLabel(nativeOption);
        customOption.setAttribute('data-label', optionLabel);
        const optionLabelEl = customOption.querySelector('.support-product-custom-select__option-label');
        if (optionLabelEl) {
          optionLabelEl.textContent = optionLabel;
        }
        if (!thumbUrl) {
          return;
        }
        customOption.setAttribute('data-thumb', thumbUrl);
        let optionThumb = customOption.querySelector('.support-product-custom-select__option-thumb');
        if (!optionThumb) {
          optionThumb = document.createElement('img');
          optionThumb.className = 'support-product-custom-select__option-thumb';
          optionThumb.width = 44;
          optionThumb.height = 44;
          optionThumb.loading = 'lazy';
          optionThumb.decoding = 'async';
          const optionLabelNode = customOption.querySelector('.support-product-custom-select__option-label');
          if (optionLabelNode) {
            customOption.insertBefore(optionThumb, optionLabelNode);
          } else {
            customOption.appendChild(optionThumb);
          }
        }
        optionThumb.src = thumbUrl;
        optionThumb.alt = nativeOption.getAttribute('data-support-title') || optionLabel || 'Image du support';
      });
      updateSupportCustomSelectState(supportProductSelect.value || '');
    }

    function closeSupportCustomSelect() {
      if (!supportCustomSelect || !supportCustomTrigger) {
        return;
      }
      supportCustomSelect.classList.remove('is-open');
      supportCustomSelect.classList.remove('opens-up');
      supportCustomTrigger.setAttribute('aria-expanded', 'false');
    }

    function positionSupportCustomSelectMenu() {
      if (!supportCustomSelect || !supportCustomTrigger || !supportCustomMenu) {
        return;
      }

      const triggerRect = supportCustomTrigger.getBoundingClientRect();
      const viewportHeight = window.innerHeight || document.documentElement.clientHeight || 0;
      const navigation = document.querySelector('.questionnaire-navigation');
      let navTop = viewportHeight;

      if (navigation) {
        const navRect = navigation.getBoundingClientRect();
        const navVisible = navRect.height > 0 && navRect.top < viewportHeight && getComputedStyle(navigation).display !== 'none';
        if (navVisible) {
          navTop = navRect.top;
        }
      }

      const availableBelow = Math.max(0, navTop - triggerRect.bottom - 8);
      const availableAbove = Math.max(0, triggerRect.top - 12);
      const preferredMenuHeight = 320;
      const shouldOpenUp = availableAbove > availableBelow;
      const usableSpace = shouldOpenUp ? availableAbove : availableBelow;
      const maxHeight = Math.min(preferredMenuHeight, Math.max(0, usableSpace));

      supportCustomSelect.classList.toggle('opens-up', shouldOpenUp);
      supportCustomMenu.style.maxHeight = (maxHeight > 0 ? String(maxHeight) + 'px' : '0px');
    }

    function toggleSupportCustomSelect() {
      if (!supportCustomSelect || !supportCustomTrigger) {
        return;
      }
      const willOpen = !supportCustomSelect.classList.contains('is-open');
      supportCustomSelect.classList.toggle('is-open', willOpen);
      if (willOpen) {
        positionSupportCustomSelectMenu();
      } else {
        supportCustomSelect.classList.remove('opens-up');
      }
      supportCustomTrigger.setAttribute('aria-expanded', willOpen ? 'true' : 'false');
    }

    function initSupportCustomSelect() {
      if (!supportCustomSelect || !supportProductSelect || !supportCustomTrigger) {
        return;
      }
      const selectorRoot = supportProductSelect.closest('.support-product-selector');
      if (selectorRoot) {
        selectorRoot.classList.add('is-enhanced');
      }
      supportCustomSelect.hidden = false;

      refreshSupportCustomSelectThumbs();
      updateSupportCustomSelectState(supportProductSelect.value || '');

      supportCustomTrigger.addEventListener('click', function(e) {
        e.preventDefault();
        e.stopPropagation();
        toggleSupportCustomSelect();
      });

      supportCustomSelect.querySelectorAll('[data-support-custom-option]').forEach(function(customOption) {
        customOption.addEventListener('click', function(e) {
          e.preventDefault();
          e.stopPropagation();
          const nextValue = this.getAttribute('data-value') || '';
          if (supportProductSelect.value !== nextValue) {
            supportProductSelect.value = nextValue;
            supportProductSelect.dispatchEvent(new Event('change', { bubbles: true }));
          } else {
            updateSupportCustomSelectState(nextValue);
          }
          closeSupportCustomSelect();
        });
      });

      document.addEventListener('click', function(e) {
        if (!supportCustomSelect.classList.contains('is-open')) {
          return;
        }
        if (!e.target.closest('[data-support-custom-select]')) {
          closeSupportCustomSelect();
        }
      });

      document.addEventListener('keydown', function(e) {
        if (e.key === 'Escape') {
          closeSupportCustomSelect();
        }
      });

      window.addEventListener('resize', function() {
        if (supportCustomSelect.classList.contains('is-open')) {
          positionSupportCustomSelectMenu();
        }
      });

      window.addEventListener(
        'scroll',
        function() {
          if (supportCustomSelect.classList.contains('is-open')) {
            positionSupportCustomSelectMenu();
          }
        },
        true
      );
    }

    window.refreshSupportCustomSelectThumbs = refreshSupportCustomSelectThumbs;
    
    // Fonction pour mettre à jour l'affichage du produit sélectionné
    function updateSupportProductDisplay(blockId) {
      if (!supportProductSelect || !supportProductDisplay) return;
      
      const selectedOption = supportProductSelect.querySelector('option[value="' + blockId + '"]');
      if (!selectedOption) {
        supportProductDisplay.style.display = 'none';
        supportChoice = null;
        supportPrice = 0;
        supportForm = null;
        updateSupportCustomSelectState('');
        updateStep10Validation();
        return;
      }
      
      // Afficher la zone d'affichage
      supportProductDisplay.style.display = 'block';
      updateSupportCustomSelectState(blockId);
      
      // Récupérer les données depuis les data-attributes de l'option
      const supportId = selectedOption.getAttribute('data-support-id');
      const supportTitle = selectedOption.getAttribute('data-support-title') || 'SUPPORT ARCHE';
      const supportPriceValue = parseFloat(selectedOption.getAttribute('data-support-price')) || 0;
      const supportImages = selectedOption.getAttribute('data-support-images') || '';
      const supportImagesThumb = selectedOption.getAttribute('data-support-images-thumb') || '';
      const supportImageCount = parseInt(selectedOption.getAttribute('data-support-image-count')) || 0;
      const supportMaterial = selectedOption.getAttribute('data-support-material') || '';
      const supportFinish = selectedOption.getAttribute('data-support-finish') || '';
      const supportComposition = selectedOption.getAttribute('data-support-composition') || '';
      const supportDimensions = selectedOption.getAttribute('data-support-dimensions') || '';
      const supportWeight = selectedOption.getAttribute('data-support-weight') || '';
      
      // Mettre à jour le titre
      const titleEl = document.getElementById('support-product-title');
      if (titleEl) {
        titleEl.textContent = supportTitle;
      }
      
      // Mettre à jour le prix
      const priceEl = document.getElementById('support-product-price');
      if (priceEl) {
        if (supportPriceValue > 0) {
          priceEl.textContent = supportPriceValue + ' €';
          priceEl.style.display = 'block';
        } else {
          priceEl.style.display = 'none';
        }
      }

      // Enregistrer le choix avant les images (updateSupportImages lit supportChoice)
      supportChoice = supportId;
      supportPrice = supportPriceValue;
      supportForm = '0';
      
      // Mettre à jour les images (swiper)
      updateSupportImages(supportImages, supportImagesThumb, supportImageCount, supportId);
      
      // Mettre à jour le matériau
      const materialEl = document.getElementById('support-detail-material');
      const materialValueEl = document.getElementById('support-material-value');
      if (materialEl && materialValueEl) {
        if (supportMaterial) {
          materialValueEl.textContent = supportMaterial;
          materialEl.style.display = 'block';
        } else {
          materialEl.style.display = 'none';
        }
      }
      
      // Mettre à jour la finition
      const finishEl = document.getElementById('support-detail-finish');
      const finishValueEl = document.getElementById('support-finish-value');
      if (finishEl && finishValueEl) {
        if (supportFinish) {
          finishValueEl.textContent = supportFinish;
          finishEl.style.display = 'block';
        } else {
          finishEl.style.display = 'none';
        }
      }
      
      // Mettre à jour la composition
      const compositionEl = document.getElementById('support-detail-composition');
      const compositionListEl = document.getElementById('support-composition-list');
      if (compositionEl && compositionListEl) {
        if (supportComposition) {
          // Nettoyer la liste
          compositionListEl.innerHTML = '';
          // Diviser la composition par les retours à la ligne
          const compositionLines = supportComposition.split('\n').filter(function(line) {
            return line.trim() !== '';
          });
          compositionLines.forEach(function(line) {
            const li = document.createElement('li');
            li.textContent = line.trim();
            compositionListEl.appendChild(li);
          });
          compositionEl.style.display = 'block';
        } else {
          compositionEl.style.display = 'none';
        }
      }
      
      // Mettre à jour les dimensions
      const dimensionsEl = document.getElementById('support-detail-dimensions');
      const dimensionsValueEl = document.getElementById('support-dimensions-value');
      if (dimensionsEl && dimensionsValueEl) {
        if (supportDimensions) {
          dimensionsValueEl.textContent = supportDimensions;
          dimensionsEl.style.display = 'block';
        } else {
          dimensionsEl.style.display = 'none';
        }
      }
      
      // Mettre à jour le poids
      const weightEl = document.getElementById('support-detail-weight');
      const weightValueEl = document.getElementById('support-weight-value');
      if (weightEl && weightValueEl) {
        if (supportWeight) {
          weightValueEl.textContent = supportWeight;
          weightEl.style.display = 'block';
        } else {
          weightEl.style.display = 'none';
        }
      }
      
      // Désélectionner le bouton "NON"
      if (noSupportBtn) {
        noSupportBtn.classList.remove('selected');
      }
      
      // Ajouter la classe selected à la carte (comme les autres étapes)
      if (supportProductDisplay) {
        supportProductDisplay.classList.add('selected');
      }
      
      updateStep10Validation();
    }
    
    function hideSupportStaticPreview() {
      const staticPreview = document.getElementById('support-static-preview');
      if (!staticPreview) {
        return;
      }
      staticPreview.style.display = 'none';
      staticPreview.hidden = true;
      staticPreview.setAttribute('aria-hidden', 'true');
    }

    // Galeries support pré-rendues en Liquid : afficher la bonne + init Swiper
    function showSupportGallery(supportId) {
      const galleriesRoot = document.getElementById('support-arche-galleries');
      const imagePlaceholder = document.getElementById('support-image-placeholder');
      hideSupportStaticPreview();

      if (supportSwiper) {
        supportSwiper.destroy(true, true);
        supportSwiper = null;
      }

      if (!galleriesRoot || !supportId) {
        if (imagePlaceholder) {
          imagePlaceholder.style.display = 'block';
        }
        return;
      }
      bindSupportZoomButtons(galleriesRoot);

      let activeGallery = null;
      let slideCount = 0;
      galleriesRoot.querySelectorAll('.support-arche-gallery').forEach(function(gallery) {
        const match = gallery.getAttribute('data-support-id') === String(supportId);
        gallery.classList.toggle('is-active', match);
        gallery.classList.toggle('is-inactive', !match);
        gallery.setAttribute('aria-hidden', match ? 'false' : 'true');
        if (match) {
          activeGallery = gallery;
          slideCount = gallery.querySelectorAll('.swiper-slide').length;
        } else {
          const swiperEl = gallery.querySelector('.support-image-swiper');
          if (swiperEl && swiperEl.swiper) {
            swiperEl.swiper.destroy(true, true);
          }
        }
      });

      if (activeGallery && slideCount === 0) {
        const staticGalleryImage = activeGallery.querySelector('.table-honneur-image img');
        if (staticGalleryImage) {
          if (imagePlaceholder) {
            imagePlaceholder.style.display = 'none';
          }
          primeImagesInRoot(activeGallery);
          reloadStepImages(activeGallery);
          fixBrokenImagesInStep(activeGallery);
          setupSupportFormSelection();
          return;
        }
      }

      if (!activeGallery || slideCount === 0) {
        const select = document.getElementById('support-product-select');
        const opt = select && select.querySelector('option[value="' + supportId + '"]');
        const images = opt ? (opt.getAttribute('data-support-images-thumb') || opt.getAttribute('data-support-images') || '').split('|||').filter(Boolean) : [];
        if (images.length && supportProductDisplay) {
          const thumb = images[0];
          ensureTableHonneurImage(supportProductDisplay, thumb, images[images.length - 1]);
          if (imagePlaceholder) {
            imagePlaceholder.style.display = 'none';
          }
          return;
        }
        if (imagePlaceholder) {
          imagePlaceholder.style.display = 'block';
        }
        return;
      }

      if (imagePlaceholder) {
        imagePlaceholder.style.display = 'none';
      }

      primeImagesInRoot(galleriesRoot);
      reloadStepImages(activeGallery);
      const swiperEl = activeGallery.querySelector('.support-image-swiper');
      if (supportSwiper) {
        supportSwiper.destroy(true, true);
        supportSwiper = null;
      }
      if (swiperEl && swiperEl.swiper) {
        swiperEl.swiper.destroy(true, true);
      }
      supportSwiper = initQuestionnairePresetSwiper(swiperEl);
      scheduleSwiperUpdates(activeGallery);
      setupSupportFormSelection();

      if (supportChoice && supportChoice !== 'no') {
        supportForm = '0';
        const firstSlide = supportProductDisplay
          ? supportProductDisplay.querySelector(
              '.support-form-slide[data-support-id="' + supportId + '"][data-form-index="0"]'
            )
          : null;
        if (firstSlide) {
          const allFormSlides = supportProductDisplay.querySelectorAll('.support-form-slide');
          allFormSlides.forEach(function(slide) {
            slide.classList.remove('selected');
          });
          firstSlide.classList.add('selected');
        }
        updateStep10Validation();
      }
    }

    function updateSupportImages(imagesFull, imagesThumb, imageCount, supportId) {
      showSupportGallery(supportId);
    }

    window.showSupportGallery = showSupportGallery;

    // Gestion du changement de sélection dans le select
    if (supportProductSelect) {
      supportProductSelect.addEventListener('change', function() {
        const selectedValue = this.value;
        updateSupportCustomSelectState(selectedValue || '');
        if (selectedValue) {
          updateSupportProductDisplay(selectedValue);
        } else {
          supportProductDisplay.style.display = 'none';
          supportProductDisplay.classList.remove('selected');
          supportChoice = null;
          supportPrice = 0;
          supportForm = null;
          updateStep10Validation();
        }
      });
      
      // Initialiser avec le premier produit si sélectionné par défaut
      const firstOption = supportProductSelect.querySelector('option[selected]');
      if (firstOption && firstOption.value) {
        updateSupportProductDisplay(firstOption.value);
      }
    }

    initSupportCustomSelect();

    // Rendre toute la carte support-product-display cliquable (comme les autres étapes)
    if (supportProductDisplay) {
      supportProductDisplay.addEventListener('click', function(e) {
        // Ne pas déclencher si le clic est sur un bouton zoom, les contrôles swiper, ou le select
        if (e.target.closest('.image-zoom-btn') || 
            e.target.closest('.swiper-button-next') || 
            e.target.closest('.swiper-button-prev') || 
            e.target.closest('.swiper-pagination') ||
            e.target.closest('#support-product-select')) {
          return;
        }
        
        // Si un produit est déjà sélectionné dans le select
        if (supportProductSelect && supportProductSelect.value) {
          // Si aucune forme n'est sélectionnée, sélectionner la première (index 0)
          if (supportForm === null) {
            const firstFormSlide = supportProductDisplay.querySelector('.support-form-slide[data-form-index="0"]');
            if (firstFormSlide) {
              selectSupportForm(firstFormSlide);
            }
          } else {
            // Si une forme est déjà sélectionnée, ne rien faire (ou on pourrait toggle)
            // Pour l'instant, on ne fait rien si déjà sélectionné
          }
        }
      });
    }
    
    // Ajouter les event listeners pour la sélection de forme
    function setupSupportFormSelection() {
      // Utiliser la délégation d'événements pour éviter les problèmes avec le swiper
      const supportContainer = document.getElementById('support-arche-galleries') || document.getElementById('support-product-display');
      if (supportContainer) {
        // Retirer les anciens listeners si nécessaire
        supportContainer.removeEventListener('click', handleFormSlideClick);
        supportContainer.addEventListener('click', handleFormSlideClick);
      }
    }
    
    // Handler pour les clics sur les slides de forme
    function handleFormSlideClick(e) {
      const formSlide = e.target.closest('.support-form-slide');
      if (!formSlide) return;
      
      // Ne pas déclencher si on clique sur le bouton zoom
      if (e.target.closest('.image-zoom-btn')) {
        return;
      }
      
      // Ne pas déclencher si on clique sur les boutons de navigation du swiper
      if (e.target.closest('.swiper-button-next') || e.target.closest('.swiper-button-prev') || e.target.closest('.swiper-pagination')) {
        return;
      }
      
      selectSupportForm(formSlide);
    }

    // Option NON pour le support - Utilisation de la fonction utilitaire
    setupNoOptionButton(
      noSupportBtn,
      supportProductDisplay ? [supportProductDisplay] : [],
      function(isActive) {
        // Callback onToggle
        if (isActive) {
          supportChoice = 'no';
          supportPrice = 0;
          supportForm = null;
          
          // Désélectionner le select
          if (supportProductSelect) {
            supportProductSelect.value = '';
          }
          updateSupportCustomSelectState('');
          
          // Masquer l'affichage du produit
          if (supportProductDisplay) {
            supportProductDisplay.style.display = 'none';
          }
          
          // Désélectionner toutes les formes
          const allFormSlides = document.querySelectorAll('.support-form-slide');
          allFormSlides.forEach(function(slide) {
            slide.classList.remove('selected');
          });
        } else {
          supportChoice = null;
          supportForm = null;
          // Retirer la classe selected de la carte
          if (supportProductDisplay) {
            supportProductDisplay.classList.remove('selected');
          }
        }
      },
      updateStep10Validation
    );

    // Fonction pour restaurer l'état du support quand on revient à l'étape 10
    function restoreStep10SupportState() {
      if (!supportProductSelect || !supportProductDisplay) return;
      
      // Si un support était sélectionné, restaurer l'affichage
      if (supportChoice && supportChoice !== 'no') {
        // Restaurer la valeur du select
        supportProductSelect.value = supportChoice;
        
        // Restaurer l'affichage du produit
        updateSupportProductDisplay(supportChoice);
        
        // Restaurer la sélection de forme après un petit délai (pour que le swiper soit initialisé)
        setTimeout(function() {
          if (supportForm !== null) {
            const formSlide = supportProductDisplay.querySelector('.support-form-slide[data-form-index="' + supportForm + '"]');
            if (formSlide) {
              selectSupportForm(formSlide);
            } else if (supportForm === 0) {
              // Si supportForm est 0 mais que le slide n'existe pas encore, attendre un peu plus
              setTimeout(function() {
                const formSlide0 = supportProductDisplay.querySelector('.support-form-slide[data-form-index="0"]');
                if (formSlide0) {
                  selectSupportForm(formSlide0);
                }
              }, 200);
            }
          } else {
            // Si aucune forme n'était sélectionnée mais qu'un produit était choisi, sélectionner la première
            const firstFormSlide = supportProductDisplay.querySelector('.support-form-slide[data-form-index="0"]');
            if (firstFormSlide) {
              selectSupportForm(firstFormSlide);
            }
          }
        }, 300);
        
        // Ajouter la classe selected à la carte
        supportProductDisplay.classList.add('selected');
      } else if (supportChoice === 'no') {
        // Restaurer l'état du bouton "NON"
        if (noSupportBtn) {
          noSupportBtn.classList.add('selected');
        }
        // Masquer l'affichage du produit
        supportProductDisplay.style.display = 'none';
        supportProductDisplay.classList.remove('selected');
      } else {
        // Aucune sélection, masquer l'affichage
        supportProductDisplay.style.display = 'none';
        supportProductDisplay.classList.remove('selected');
        if (noSupportBtn) {
          noSupportBtn.classList.remove('selected');
        }
      }
    }

    // Initialiser les swipers pour les supports avec plusieurs images
    function initSupportSwipers() {
      // Le swiper est maintenant géré dynamiquement par updateSupportImages
      // On s'assure que le premier produit est affiché
      if (supportProductSelect) {
        // Si une valeur est déjà sélectionnée, l'afficher
        if (supportProductSelect.value) {
          updateSupportProductDisplay(supportProductSelect.value);
        } else {
          // Ne pas sélectionner automatiquement le premier produit
          // L'utilisateur doit faire un choix explicite
        }
      }
      
      // Configurer la sélection de forme
      setupSupportFormSelection();
      bindSupportZoomButtons(document.querySelector('[data-step="10"]') || document);
      
      // Restaurer l'état du support si on revient à l'étape 10
      restoreStep10SupportState();
    }

    // Initialiser les swipers quand on arrive à l'étape 10
    const step10El = document.querySelector('[data-step="10"]');
    if (step10El) {
      let step10WasVisible = step10El.style.display !== 'none';
      // Observer pour détecter quand l'étape 10 devient visible
      const observer = new MutationObserver(function(mutations) {
        mutations.forEach(function(mutation) {
          if (mutation.type === 'attributes' && mutation.attributeName === 'style') {
            const isVisible = step10El.style.display !== 'none';
            if (isVisible && !step10WasVisible) {
              initQuestionnaireMediaRobust(10);
            }
            step10WasVisible = isVisible;
          }
        });
      });
      
      observer.observe(step10El, {
        attributes: true,
        attributeFilter: ['style']
      });
      
      // Initialiser immédiatement si l'étape est déjà visible
      if (step10El.style.display !== 'none') {
        setTimeout(function() {
          initQuestionnaireMediaRobust(10);
        }, 100);
      }
    }

    // Étape 11 - Bouquets de chaise pour l'allée de cérémonie
    const validateStep11 = document.getElementById('validate-step-11');
    const step11Fresh = document.getElementById('step11-fresh-option');
    const step11Artificial = document.getElementById('step11-artificial-option');
    const noChairBtn = document.getElementById('no-chair-btn');
    const chairColorSelect = document.getElementById('chair-color');
    const step11ArtificialPriceEl = document.getElementById('step11-artificial-price');
    const chairQuantitySection = document.getElementById('chair-quantity-section');
    const chairHelpLink = document.getElementById('chair-help-link');
    const chairHelpModal = document.getElementById('chair-help-modal');
    const chairHelpClose = document.getElementById('chair-help-close');
    
    let chairChoice = null; // 'fresh', 'artificial', ou 'no'
    let chairFlowers = 0; // Nombre de fleurs selon la quantité
    const chairBasePrice = step11ArtificialPriceEl
      ? (parsePriceFromText(step11ArtificialPriceEl.textContent) || 0)
      : (parseFloat(window.questionnaireConfig.step11ArtificialPrice) || 0);
    let chairPrice = chairBasePrice; // Prix si artificial (une seule source : couleur ou prix de base)
    let chairQuantity = 0; // Quantité de chaises sélectionnée

    function updateStep11ArtificialPriceDisplay() {
      if (!step11ArtificialPriceEl) return;
      step11ArtificialPriceEl.textContent = ((chairPrice > 0 ? chairPrice : 0) + ' €');
    }

    function applyStep11ArtificialColorSelection(selectedOption) {
      const hasColor = !!(selectedOption && selectedOption.value);
      const colorPrice = hasColor
        ? (parseFloat(selectedOption.getAttribute('data-price')) || 0)
        : 0;
      chairPrice = hasColor
        ? colorPrice
        : (chairChoice === 'artificial' ? chairBasePrice : 0);

      const colorImages = hasColor
        ? ((selectedOption.getAttribute('data-color-images') || '')
            .split('|||')
            .map(function(u) { return u.trim(); })
            .filter(Boolean))
        : [];
      const colorThumb = hasColor
        ? (colorImages[0] || selectedOption.getAttribute('data-image') || '')
        : '';
      const colorFull = hasColor
        ? (colorImages[colorImages.length - 1] || colorThumb)
        : '';

      if (step11Artificial && colorThumb) {
        ensureTableHonneurImage(step11Artificial, colorThumb, colorFull || colorThumb);
        bindStep11ChairZoomButtons(step11Artificial);
      }

      updateStep11ArtificialPriceDisplay();
    }

    function updateStep11Validation() {
      updateStep11ArtificialPriceDisplay();
      if (validateStep11) {
        // Une option doit être sélectionnée
        if (!chairChoice) {
          validateStep11.disabled = true;
          return;
        }
        
        // Si artificial, il faut une couleur
        if (chairChoice === 'artificial' && (!chairColorSelect || chairColorSelect.value === '')) {
          validateStep11.disabled = true;
          return;
        }
        
        // Si fresh ou artificial, il faut une quantité de chaises
        if (chairChoice !== 'no' && chairQuantity === 0) {
          validateStep11.disabled = true;
          return;
        }
        
        validateStep11.disabled = false;
      }
    }

    function ensureFirstChairColorSelected() {
      if (!chairColorSelect) {
        return;
      }
      if (chairColorSelect.value) {
        const selectedOption = chairColorSelect.options[chairColorSelect.selectedIndex];
        applyStep11ArtificialColorSelection(selectedOption);
        return;
      }
      for (let i = 0; i < chairColorSelect.options.length; i++) {
        const opt = chairColorSelect.options[i];
        if (opt && opt.value) {
          chairColorSelect.selectedIndex = i;
          chairColorSelect.dispatchEvent(new Event('change', { bubbles: true }));
          return;
        }
      }
    }

    // Fonction pour gérer l'affichage de la section des chaises
    function toggleChairQuantitySection(show) {
      if (!chairQuantitySection) {
        return;
      }
      const chairQuantityButtons = chairQuantitySection.querySelectorAll('.chair-quantity-btn');
      if (show) {
        chairQuantitySection.style.display = 'block';
        chairQuantitySection.setAttribute('aria-hidden', 'false');
        chairQuantityButtons.forEach(function(btn) {
          btn.disabled = false;
          btn.style.opacity = '1';
          btn.style.pointerEvents = 'auto';
        });
        requestAnimationFrame(function() {
          chairQuantitySection.scrollIntoView({ behavior: 'smooth', block: 'nearest' });
        });
      } else {
        chairQuantitySection.style.display = 'none';
        chairQuantitySection.setAttribute('aria-hidden', 'true');
        chairQuantity = 0;
        chairFlowers = 0;
        chairQuantityButtons.forEach(function(btn) {
          btn.disabled = true;
          btn.style.opacity = '0.5';
          btn.style.pointerEvents = 'none';
          btn.classList.remove('selected');
        });
      }
    }

    // Option fleurs fraîches
    if (step11Fresh) {
      step11Fresh.addEventListener('click', function(e) {
        if (e.target.closest('.image-zoom-btn') || e.target.closest('.table-honneur-color-selector')) {
          return;
        }
        if (step11Artificial) step11Artificial.classList.remove('selected');
        if (noChairBtn) noChairBtn.classList.remove('selected');
        
        this.classList.add('selected');
        chairChoice = 'fresh';
        chairQuantity = 0;
        toggleChairQuantitySection(true);
        updateStep11Validation();
      });
    }

    // Option fleurs artificielles
    if (step11Artificial) {
      step11Artificial.addEventListener('click', function(e) {
        if (e.target.closest('.image-zoom-btn') || e.target.closest('.table-honneur-color-selector')) {
          return;
        }
        if (step11Fresh) step11Fresh.classList.remove('selected');
        if (noChairBtn) noChairBtn.classList.remove('selected');
        
        this.classList.add('selected');
        chairChoice = 'artificial';
        chairQuantity = 0;
        if (chairColorSelect) {
          const selectedOption = chairColorSelect.options[chairColorSelect.selectedIndex];
          applyStep11ArtificialColorSelection(selectedOption);
        }
        toggleChairQuantitySection(true);
        updateStep11Validation();
      });
    }

    // Option NON
    if (noChairBtn) {
      noChairBtn.addEventListener('click', function() {
        if (step11Fresh) step11Fresh.classList.remove('selected');
        if (step11Artificial) step11Artificial.classList.remove('selected');
        
        this.classList.toggle('selected');
        if (this.classList.contains('selected')) {
          chairChoice = 'no';
          chairFlowers = 0;
          chairPrice = 0;
          chairQuantity = 0;
          // Masquer et désactiver la section des chaises
          toggleChairQuantitySection(false);
        } else {
          chairChoice = null;
          // Réafficher la section des chaises
          toggleChairQuantitySection(true);
        }
        updateStep11Validation();
      });
    }

    // Sélecteur de couleur pour les fleurs artificielles
    if (chairColorSelect) {
      chairColorSelect.addEventListener('change', function() {
        const selectedOption = this.options[this.selectedIndex];
        if (selectedOption && selectedOption.value) {
          const wasArtificialSelected = chairChoice === 'artificial';
          if (step11Fresh) step11Fresh.classList.remove('selected');
          if (noChairBtn) noChairBtn.classList.remove('selected');
          if (step11Artificial) step11Artificial.classList.add('selected');
          chairChoice = 'artificial';
          if (!wasArtificialSelected) {
            chairQuantity = 0;
            chairFlowers = 0;
            toggleChairQuantitySection(true);
          }
        }
        applyStep11ArtificialColorSelection(selectedOption);
        updateStep11Validation();
      });
    }

    // Boutons de quantité de chaises (délégation : section parfois masquée au chargement)
    if (chairQuantitySection) {
      chairQuantitySection.addEventListener('click', function(e) {
        const button = e.target.closest('.chair-quantity-btn');
        if (!button || button.disabled) {
          return;
        }
        const buttons = chairQuantitySection.querySelectorAll('.chair-quantity-btn');
        buttons.forEach(function(btn) {
          btn.classList.remove('selected');
        });
        button.classList.add('selected');
        chairQuantity = parseInt(button.getAttribute('data-quantity'), 10) || 0;
        chairFlowers = parseInt(button.getAttribute('data-flowers'), 10) || 0;
        updateStep11Validation();
      });
    }

    // Masquer la quantité tant qu'aucune option arche n'est choisie
    toggleChairQuantitySection(false);
    updateStep11Validation();

    // Fonctions pour gérer la modal d'aide des bouquets de chaises
    function openChairHelpModal() {
      if (!chairHelpModal) return;
      
      // Afficher la modal
      chairHelpModal.classList.add('active');
      document.body.style.overflow = 'hidden';
    }

    function closeChairHelpModal() {
      if (chairHelpModal) {
        chairHelpModal.classList.remove('active');
        document.body.style.overflow = '';
      }
    }

    // Modal d'aide - Lien texte
    if (chairHelpLink) {
      chairHelpLink.addEventListener('click', function(e) {
        e.preventDefault();
        openChairHelpModal();
      });
    }

    if (chairHelpClose) {
      chairHelpClose.addEventListener('click', closeChairHelpModal);
    }

    if (chairHelpModal) {
      const modalOverlay = chairHelpModal.querySelector('.modal-overlay');
      if (modalOverlay) {
        modalOverlay.addEventListener('click', closeChairHelpModal);
      }
    }

    // Fermer avec Escape
    document.addEventListener('keydown', function(e) {
      if (e.key === 'Escape' && chairHelpModal && chairHelpModal.classList.contains('active')) {
        closeChairHelpModal();
      }
    });

    // Étape 12 - Accessoires en fleurs stabilisées
    const validateStep12 = document.getElementById('validate-step-12');
    const step12AccessoriesOptions = document.querySelectorAll('.step12-accessories-option');
    const step12NoOption = document.getElementById('step12-no-option');
    const accessoriesColorSelects = document.querySelectorAll('.accessories-color-select');
    
    let accessoriesChoice = null; // 'accessories' ou 'no'
    let selectedAccessoryId = null; // ID du bloc accessoire sélectionné
    let accessoriesPrice = 0; // Prix si accessories

    function checkStep12ColorSelection() {
      if (accessoriesChoice === 'accessories') {
        const selectedAccessories = document.querySelectorAll('.step12-accessories-option.selected');
        const accessoriesWithoutColor = [];
        
        selectedAccessories.forEach(accessory => {
          const colorSelect = accessory.querySelector('.accessories-color-select');
          if (!colorSelect || colorSelect.value === '') {
            // Obtenir le titre de l'accessoire
            const accessoryTitle = accessory.querySelector('.table-honneur-title')?.textContent || 'cet accessoire';
            accessoriesWithoutColor.push(accessoryTitle.trim());
          }
        });
        
        if (accessoriesWithoutColor.length > 0) {
          alert('Veuillez sélectionner une couleur pour : ' + accessoriesWithoutColor.join(', '));
          return false;
        }
      }
      return true;
    }

    function updateStep12Validation() {
      if (validateStep12) {
        // Le bouton s'active dès qu'une option est sélectionnée avec quantité > 0
        // La vérification de couleur se fait au clic sur VALIDER
        if (!accessoriesChoice) {
          validateStep12.disabled = true;
          return;
        }
        
        // Si accessories, vérifier qu'au moins une option est sélectionnée avec quantité > 0
        if (accessoriesChoice === 'accessories') {
          const selectedAccessories = document.querySelectorAll('.step12-accessories-option.selected');
          let hasQuantity = false;
          selectedAccessories.forEach(accessory => {
            const accessoryId = accessory.getAttribute('data-accessory-id');
            const quantityInput = accessory.querySelector(`#accessory-quantity-${accessoryId}`);
            if (quantityInput && parseInt(quantityInput.value) > 0) {
              hasQuantity = true;
            }
          });
          if (!hasQuantity) {
            validateStep12.disabled = true;
            return;
          }
        }
        
        // Activer le bouton (la vérification de couleur se fera au clic)
        validateStep12.disabled = false;
      }
    }

    // Options accessoires - Clic sur la carte pour augmenter la quantité
    step12AccessoriesOptions.forEach(option => {
      option.addEventListener('click', function(e) {
        // Ne pas déclencher si le clic est sur un élément interactif (select, bouton, input)
        if (e.target.closest('select') || e.target.closest('button') || e.target.closest('input') || e.target.closest('.image-zoom-btn')) {
          return;
        }
        
        // Désélectionner le bouton "NON" si une option est sélectionnée
        if (step12NoOption) step12NoOption.classList.remove('selected');
        
        const accessoryId = this.getAttribute('data-accessory-id');
        const quantityInput = this.querySelector(`#accessory-quantity-${accessoryId}`);
        const plusBtn = this.querySelector('.quantity-plus[data-accessory-id="' + accessoryId + '"]');
        
        if (quantityInput && plusBtn) {
          // Si la quantité est à 0, la mettre à 1 et activer
          if (parseInt(quantityInput.value) === 0) {
            quantityInput.value = 1;
            quantityInput.disabled = false;
            const minusBtn = this.querySelector('.quantity-minus[data-accessory-id="' + accessoryId + '"]');
            if (minusBtn) minusBtn.disabled = false;
            this.classList.add('selected');
            
            // S'assurer qu'une couleur est sélectionnée
            const colorSelect = this.querySelector('.accessories-color-select');
            if (colorSelect && colorSelect.value) {
              accessoriesChoice = 'accessories';
            }
            
            // Recalculer le prix total
            let totalPrice = 0;
            const selectedAccessories = document.querySelectorAll('.step12-accessories-option.selected');
            selectedAccessories.forEach(accessory => {
              const priceEl = accessory.querySelector('.accessories-price');
              const qtyInput = accessory.querySelector('.quantity-input');
              if (priceEl && qtyInput) {
                const priceText = priceEl.textContent.replace(' €', '').trim();
                const qty = parseInt(qtyInput.value) || 0;
                totalPrice += (parseFloat(priceText) || 0) * qty;
              }
            });
            accessoriesPrice = totalPrice;
          } else {
            // Si déjà sélectionné, réinitialiser à 0
            quantityInput.value = 0;
            quantityInput.disabled = true;
            const minusBtn = this.querySelector('.quantity-minus[data-accessory-id="' + accessoryId + '"]');
            if (minusBtn) minusBtn.disabled = true;
            this.classList.remove('selected');
            
            // Vérifier s'il reste des accessoires sélectionnés
            const selectedAccessories = document.querySelectorAll('.step12-accessories-option.selected');
            if (selectedAccessories.length === 0) {
              accessoriesChoice = null;
            }
            
            // Recalculer le prix total
            let totalPrice = 0;
            selectedAccessories.forEach(accessory => {
              const priceEl = accessory.querySelector('.accessories-price');
              const qtyInput = accessory.querySelector('.quantity-input');
              if (priceEl && qtyInput) {
                const priceText = priceEl.textContent.replace(' €', '').trim();
                const qty = parseInt(qtyInput.value) || 0;
                totalPrice += (parseFloat(priceText) || 0) * qty;
              }
            });
            accessoriesPrice = totalPrice;
          }
        }
        
        updateStep12Validation();
      });
    });

    // Option NON
    if (step12NoOption) {
      step12NoOption.addEventListener('click', function() {
        // Désélectionner toutes les options accessoires
        step12AccessoriesOptions.forEach(opt => opt.classList.remove('selected'));
        
        this.classList.toggle('selected');
        if (this.classList.contains('selected')) {
          accessoriesChoice = 'no';
          selectedAccessoryId = null;
          accessoriesPrice = 0;
          // Réinitialiser les quantités de tous les accessoires
          step12AccessoriesOptions.forEach(accessory => {
            const accessoryId = accessory.getAttribute('data-accessory-id');
            const quantityInput = document.getElementById('accessory-quantity-' + accessoryId);
            const minusBtn = accessory.querySelector('.quantity-minus[data-accessory-id="' + accessoryId + '"]');
            if (quantityInput) {
              quantityInput.value = 0;
              quantityInput.disabled = true;
              if (minusBtn) minusBtn.disabled = true;
            }
          });
        } else {
          accessoriesChoice = null;
        }
        updateStep12Validation();
      });
    }

    // Fonction pour parser les données des couleurs
    function parseAccessoryColors(colorsData) {
      if (!colorsData) return {};
      const colors = {};
      const colorBlocks = colorsData.split(':::COLOR:::');
      
      colorBlocks.forEach(block => {
        if (!block) return;
        const parts = block.split('|||PRICE|||');
        if (parts.length < 2) return;
        
        const colorName = parts[0];
        const rest = parts[1].split('|||IMAGES|||');
        if (rest.length < 2) return;
        
        const price = parseFloat(rest[0]) || 0;
        const imagesPart = rest[1].split('|||COUNT|||');
        const images = imagesPart[0] ? imagesPart[0].split('|||') : [];
        const imageCount = parseInt(imagesPart[1]) || 0;
        
        colors[colorName] = {
          price: price,
          images: images,
          imageCount: imageCount
        };
      });
      
      return colors;
    }

    // Fonction pour créer un swiper pour une couleur
    function createAccessoryColorSwiper(accessoryId, colorData) {
      const accessoryCard = document.querySelector(`.step12-accessories-option[data-accessory-id="${accessoryId}"]`);
      if (accessoryCard && colorData && colorData.images && colorData.images.length) {
        applyAccessoryCardImage(accessoryCard, colorData.images);
      }
      if (!colorData || !colorData.images || colorData.images.length <= 1) {
        return null;
      }
      const swiperContainer = document.querySelector(`.accessories-color-swiper-container[data-accessory-id="${accessoryId}"]`);
      if (!swiperContainer) return null;
      
      const swiperElement = swiperContainer.querySelector('.accessories-color-swiper');
      if (!swiperElement) return null;
      
      // Nettoyer le swiper existant
      const wrapper = swiperElement.querySelector('.swiper-wrapper');
      if (!wrapper) {
        return null;
      }
      wrapper.innerHTML = '';
      
      // Créer les slides
      colorData.images.forEach((imageUrl, index) => {
        if (!imageUrl) return;
        const thumbUrl = resizeShopifyImageUrl(imageUrl, 600) || imageUrl;
        const slide = document.createElement('div');
        slide.className = 'swiper-slide accessories-color-slide';
        slide.innerHTML = `
          <img src="${thumbUrl}" 
               alt="Accessoire couleur"
               loading="eager"
               decoding="async"
               data-lightbox-src="${imageUrl}"/>
          <div class="table-honneur-overlay">
            <svg class="svg-icon" width="30" height="30" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2">
              <polyline points="20 6 9 17 4 12"></polyline>
            </svg>
          </div>
          <button class="image-zoom-btn" data-lightbox-src="${imageUrl}" aria-label="Agrandir l'image">
            <svg class="svg-icon" width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round">
              <circle cx="12" cy="12" r="10"></circle>
              <path d="M9.09 9a3 3 0 0 1 5.83 1c0 2-3 3-3 3"></path>
              <line x1="12" y1="17" x2="12.01" y2="17"></line>
            </svg>
          </button>
        `;
        wrapper.appendChild(slide);
      });
      
      // Détruire le swiper existant s'il existe
      if (swiperElement.swiper) {
        swiperElement.swiper.destroy(true, true);
      }

      const showNavigation = colorData.imageCount > 1;
      const nextBtn = swiperElement.querySelector('.accessories-swiper-next');
      const prevBtn = swiperElement.querySelector('.accessories-swiper-prev');
      const pagination = swiperElement.querySelector('.accessories-swiper-pagination');

      if (nextBtn) nextBtn.style.display = showNavigation ? 'flex' : 'none';
      if (prevBtn) prevBtn.style.display = showNavigation ? 'flex' : 'none';
      if (pagination) pagination.style.display = showNavigation ? 'block' : 'none';

      if (typeof Swiper === 'undefined') {
        console.warn('[Questionnaire] Swiper indisponible — images accessoires sans carrousel.');
        return null;
      }

      let swiper = null;
      try {
        swiper = new Swiper(swiperElement, {
          slidesPerView: 1,
          spaceBetween: 0,
          loop: false,
          observer: true,
          observeParents: true,
          navigation: {
            nextEl: nextBtn,
            prevEl: prevBtn,
          },
          pagination: {
            el: pagination,
            clickable: true,
          },
        });
      } catch (err) {
        console.error('[Questionnaire] createAccessoryColorSwiper:', err);
        return null;
      }

      requestAnimationFrame(function() {
        if (swiper && typeof swiper.update === 'function') {
          swiper.update();
        }
      });

      return swiper;
    }

    // Sélecteurs de couleur - sélectionner automatiquement la carte dès qu'une couleur est choisie
    accessoriesColorSelects.forEach(select => {
      select.addEventListener('change', function(e) {
        e.stopPropagation(); // Empêcher le déclenchement du clic sur l'option parente
        e.stopImmediatePropagation(); // Empêcher les autres gestionnaires d'événements
        const accessoryCard = this.closest('.step12-accessories-option');
        const accessoryId = accessoryCard.getAttribute('data-accessory-id');

        // Mettre à jour la couleur, le prix et le swiper
        const selectedColor = this.value;
        const swiperContainer = accessoryCard.querySelector('.accessories-color-swiper-container');
        const priceElement = accessoryCard.querySelector('.accessories-price');
        
        if (selectedColor) {
          if (step12NoOption) step12NoOption.classList.remove('selected');
          accessoryCard.classList.add('selected');
          accessoriesChoice = 'accessories';
          selectedAccessoryId = accessoryId;

          const quantityInput = accessoryCard.querySelector(`#accessory-quantity-${accessoryId}`);
          const minusBtn = accessoryCard.querySelector('.quantity-minus[data-accessory-id="' + accessoryId + '"]');
          if (quantityInput) {
            if ((parseInt(quantityInput.value, 10) || 0) <= 0) {
              quantityInput.value = 1;
            }
            quantityInput.disabled = false;
          }
          if (minusBtn) minusBtn.disabled = false;

          const colors = getAccessoryColorsForCard(accessoryId, accessoryCard);
          let colorData = colors[selectedColor];
          if (!colorData || !colorData.images || !colorData.images.length) {
            const selectImages = getColorImagesFromSelect(this, selectedColor);
            if (selectImages.length) {
              colorData = {
                price: parseFloat(this.options[this.selectedIndex].getAttribute('data-price')) || 0,
                images: selectImages,
                imageCount: selectImages.length
              };
            }
          }
          
          if (colorData) {
            // Mettre à jour le prix (uniquement le prix de la couleur, pas de prix de base)
            if (priceElement) {
              priceElement.textContent = colorData.price + ' €';
            }
            
            if (colorData.images.length > 0) {
              applyAccessoryCardImage(accessoryCard, colorData.images);
              if (swiperContainer && colorData.images.length > 1) {
                createAccessoryColorSwiper(accessoryId, colorData);
              }
            }
          }
        } else {
          // Réinitialiser : masquer le swiper et réinitialiser le prix
          if (priceElement) {
            priceElement.textContent = '0 €';
          }
          if (swiperContainer) {
            swiperContainer.style.display = 'none';
            // Détruire le swiper
            const swiperElement = swiperContainer.querySelector('.accessories-color-swiper');
            if (swiperElement && swiperElement.swiper) {
              swiperElement.swiper.destroy(true, true);
            }
          }
        }
        
        // Recalculer le prix total avec les options actuellement sélectionnées (en tenant compte des quantités)
        let totalPrice = 0;
        const selectedAccessories = document.querySelectorAll('.step12-accessories-option.selected');
        
        selectedAccessories.forEach(accessory => {
          const priceEl = accessory.querySelector('.accessories-price');
          const qtyInput = accessory.querySelector('.quantity-input');
          if (priceEl && qtyInput) {
            const priceText = priceEl.textContent.replace(' €', '').trim();
            const qty = parseInt(qtyInput.value) || 0;
            totalPrice += (parseFloat(priceText) || 0) * qty;
          }
        });
        
        accessoriesPrice = totalPrice;
        updateStep12Validation();
      });
    });

    // Gestion des quantités individuelles pour chaque accessoire
    step12AccessoriesOptions.forEach(accessory => {
      const accessoryId = accessory.getAttribute('data-accessory-id');
      const quantityInput = accessory.querySelector(`#accessory-quantity-${accessoryId}`);
      const minusBtn = accessory.querySelector('.quantity-minus[data-accessory-id="' + accessoryId + '"]');
      const plusBtn = accessory.querySelector('.quantity-plus[data-accessory-id="' + accessoryId + '"]');
      
      if (quantityInput && minusBtn && plusBtn) {
        // Fonction pour mettre à jour l'état des boutons et activer/désactiver l'input
        function updateQuantityState() {
          const currentValue = parseInt(quantityInput.value) || 0;
          minusBtn.disabled = currentValue <= 0;
          quantityInput.disabled = currentValue <= 0;
          
          // Si la quantité est > 0, sélectionner l'accessoire, sinon le désélectionner
          if (currentValue > 0) {
            accessory.classList.add('selected');
            // S'assurer qu'une couleur est sélectionnée
            const colorSelect = accessory.querySelector('.accessories-color-select');
            if (colorSelect && colorSelect.value) {
              accessoriesChoice = 'accessories';
            }
          } else {
            accessory.classList.remove('selected');
            // Vérifier s'il reste des accessoires sélectionnés
            const selectedAccessories = document.querySelectorAll('.step12-accessories-option.selected');
            if (selectedAccessories.length === 0) {
              accessoriesChoice = null;
            }
          }
          
          // Recalculer le prix total
          let totalPrice = 0;
          const selectedAccessories = document.querySelectorAll('.step12-accessories-option.selected');
          selectedAccessories.forEach(acc => {
            const priceEl = acc.querySelector('.accessories-price');
            const qtyInput = acc.querySelector('.quantity-input');
            if (priceEl && qtyInput) {
              const priceText = priceEl.textContent.replace(' €', '').trim();
              const qty = parseInt(qtyInput.value) || 0;
              totalPrice += (parseFloat(priceText) || 0) * qty;
            }
          });
          accessoriesPrice = totalPrice;
          
          updateStep12Validation();
        }
        
        // Bouton moins
        minusBtn.addEventListener('click', function(e) {
          e.preventDefault();
          e.stopPropagation();
          
          if (step12NoOption && step12NoOption.classList.contains('selected')) {
            return;
          }
          
          let currentValue = parseInt(quantityInput.value) || 0;
          if (currentValue > 0) {
            currentValue--;
            quantityInput.value = currentValue;
            updateQuantityState();
          }
        });
        
        // Bouton plus
        plusBtn.addEventListener('click', function(e) {
          e.preventDefault();
          e.stopPropagation();
          
          if (step12NoOption && step12NoOption.classList.contains('selected')) {
            return;
          }
          
          let currentValue = parseInt(quantityInput.value) || 0;
          currentValue++;
          quantityInput.value = currentValue;
          quantityInput.disabled = false;
          minusBtn.disabled = false;
          updateQuantityState();
        });
        
        // Initialiser l'état
        updateQuantityState();
      }
    });

    function initStep12AccessorySwipers() {
      accessoriesColorSelects.forEach(select => {
        const accessoryCard = select.closest('.step12-accessories-option');
        if (!accessoryCard) return;

        const accessoryId = accessoryCard.getAttribute('data-accessory-id');
        let firstColorName = accessoryCard.getAttribute('data-accessory-first-color');
        let firstColorPrice = accessoryCard.getAttribute('data-accessory-first-price') || '0';
        let firstColorImages = accessoryCard.getAttribute('data-accessory-first-images') || '';
        let firstColorCount = parseInt(accessoryCard.getAttribute('data-accessory-first-count'), 10) || 0;
        const swiperContainer = accessoryCard.querySelector('.accessories-color-swiper-container');

        if (!firstColorName || !firstColorImages) {
          const colors = getAccessoryColorsForCard(accessoryId, accessoryCard);
          const colorKeys = Object.keys(colors);
          if (colorKeys.length) {
            firstColorName = colorKeys[0];
            const firstColor = colors[firstColorName];
            firstColorPrice = String(firstColor.price || 0);
            firstColorImages = (firstColor.images || []).join('|||');
            firstColorCount = firstColor.imageCount || firstColor.images.length;
          }
        }

        if (firstColorName && !firstColorImages) {
          const fromSelect = getColorImagesFromSelect(select, firstColorName);
          if (fromSelect.length) {
            firstColorImages = fromSelect.join('|||');
            firstColorCount = fromSelect.length;
          }
        }

        if (!firstColorName || !firstColorImages) return;

        select.value = firstColorName;

        const priceElement = accessoryCard.querySelector('.accessories-price');
        if (priceElement) {
          priceElement.textContent = firstColorPrice + ' €';
        }

        const colorData = {
          price: parseFloat(firstColorPrice) || 0,
          images: firstColorImages.split('|||').filter(function(img) { return img; }),
          imageCount: firstColorCount
        };

        if (colorData.images.length > 0) {
          applyAccessoryCardImage(accessoryCard, colorData.images);
          if (swiperContainer && colorData.images.length > 1) {
            swiperContainer.style.display = '';
            createAccessoryColorSwiper(accessoryId, colorData);
          }
        }
      });
    }

    window.initStep12AccessorySwipers = initStep12AccessorySwipers;

    // Initialiser l'état
    updateStep12Validation();

    // Fonction pour ouvrir la modal d'aide avec calcul
    function openTablesHelpModal() {
      if (!tablesHelpModal) return;
      
      // Récupérer le nombre d'invités de l'étape 3 (utiliser le cache si disponible)
      const invitesInputValue = invitesInput ? invitesInput.value : (getElement('nombre-invites')?.value || '0');
      const invitesCount = parseInt(invitesInputValue) || 0;
      const calculatedTables = Math.ceil(invitesCount / 6);
      
      // Mettre à jour la modal
      const modalInvitesCount = document.getElementById('modal-invites-count');
      const modalTablesResult = document.getElementById('modal-tables-result');
      const modalAutofillHint = document.getElementById('modal-tables-autofill-hint');
      if (modalInvitesCount) {
        modalInvitesCount.textContent = invitesCount + ' invités';
      }
      if (modalTablesResult) {
        modalTablesResult.textContent = calculatedTables + ' tables';
      }
      if (modalAutofillHint) {
        if (calculatedTables > 0) {
          modalAutofillHint.hidden = false;
          modalAutofillHint.textContent =
            'Ce nombre a été saisi automatiquement dans le champ sous la question (nombre de tables). Vous pouvez le modifier si besoin.';
        } else {
          modalAutofillHint.hidden = false;
          modalAutofillHint.textContent =
            'Indiquez d’abord le nombre d’invités à l’étape 3 pour obtenir une estimation, puis saisissez le nombre de tables dans le champ prévu.';
        }
      }

      // Pré-remplissage automatique du champ (dès que le calcul donne au moins 1 table)
      if (tablesInput && !tablesInput.disabled && calculatedTables > 0) {
        tablesInput.value = String(calculatedTables);
        tablesInput.dispatchEvent(new Event('input', { bubbles: true }));
      }
      
      // Afficher la modal
      tablesHelpModal.classList.add('active');
      document.body.style.overflow = 'hidden';
    }

    function closeTablesHelpModal() {
      if (tablesHelpModal) {
        tablesHelpModal.classList.remove('active');
        document.body.style.overflow = '';
      }
    }

    // Modal d'aide - Lien texte
    if (tablesHelpLink) {
      tablesHelpLink.addEventListener('click', function(e) {
        e.preventDefault();
        openTablesHelpModal();
      });
    }

    if (tablesHelpClose) {
      tablesHelpClose.addEventListener('click', closeTablesHelpModal);
    }

    if (tablesHelpModal) {
      const modalOverlay = tablesHelpModal.querySelector('.modal-overlay');
      if (modalOverlay) {
        modalOverlay.addEventListener('click', closeTablesHelpModal);
      }
    }

    // Fermer avec Escape
    document.addEventListener('keydown', function(e) {
      if (e.key === 'Escape' && tablesHelpModal && tablesHelpModal.classList.contains('active')) {
        closeTablesHelpModal();
      }
    });

    // Étape 14 - Atelier floral (nombre de participants)
    const validateStep14Workshop = DOMCache.validateStep14 || document.getElementById('validate-step-14');
    const workshopParticipantsInput = document.getElementById('workshop-participants-input');

    function checkStep13ColorSelection() {
      // Utiliser un sélecteur standardisé pour les matériels
      const selectedMaterials = document.querySelectorAll('.step13-material-option.selected');
      
      // Si aucun matériel n'est sélectionné, pas besoin de vérifier les couleurs
      if (selectedMaterials.length === 0) {
        return true;
      }
      
      const materialsWithoutColor = [];
      
      selectedMaterials.forEach(material => {
        const colorSelect = material.querySelector('.step13-color-select, .material-color-select');
        // Si un sélecteur de couleur existe mais n'a pas de valeur, c'est une erreur
        if (colorSelect && colorSelect.value === '') {
          const materialTitle = material.querySelector('.step13-material-title, .material-option-title, .material-title')?.textContent || 'ce matériel';
          materialsWithoutColor.push(materialTitle.trim());
        }
      });
      
      if (materialsWithoutColor.length > 0) {
        alert('Veuillez sélectionner une couleur pour : ' + materialsWithoutColor.join(', '));
        return false;
      }
      return true;
    }

    function updateStep14WorkshopValidation() {
      if (!validateStep14Workshop || !workshopParticipantsInput) return;
      const raw = String(workshopParticipantsInput.value || '').trim();
      const n = parseInt(raw, 10);
      validateStep14Workshop.disabled = !(Number.isFinite(n) && n >= 1);
    }

    if (workshopParticipantsInput) {
      workshopParticipantsInput.addEventListener('input', updateStep14WorkshopValidation);
      workshopParticipantsInput.addEventListener('change', updateStep14WorkshopValidation);
    }
    updateStep14WorkshopValidation();

    // Étape 16 (bottes) - Nouveau système à trois niveaux (Catégories, Sous-catégories et Variétés)
    const validateStep15 = document.getElementById('validate-step-16');
    const noFlowersBtn = document.getElementById('no-flowers-btn');
    const flowersCategoriesView = document.getElementById('flowers-categories-view');
    const flowersSubcategoriesView = document.getElementById('flowers-subcategories-view');
    const flowersVarietiesView = document.getElementById('flowers-varieties-view');
    const flowersBackToCategoriesBtn = document.getElementById('flowers-back-to-categories-btn');
    const flowersBackToSubcategoriesBtn = document.getElementById('flowers-back-to-subcategories-btn');
    const flowersSubcategoriesTitle = document.getElementById('flowers-subcategories-title');
    const flowersVarietiesTitle = document.getElementById('flowers-varieties-title');
    const flowersSubcategoriesList = document.getElementById('flowers-subcategories-list');
    const flowersVarietiesList = document.getElementById('flowers-varieties-list');

    // Fonction pour obtenir le mois de la date de mariage (1-12)
    function getWeddingMonth() {
      const weddingDateInput = DOMCache.weddingDateInput || document.getElementById('wedding-date');
      if (!weddingDateInput || !weddingDateInput.value) {
        return null;
      }
      const dateValue = weddingDateInput.value;
      // Format attendu : YYYY-MM-DD
      const match = dateValue.match(/^\d{4}-(\d{2})-\d{2}$/);
      if (match) {
        return parseInt(match[1], 10);
      }
      return null;
    }

    // Fonction pour vérifier si une sous-catégorie est disponible selon le mois
    function isSubcategoryAvailable(subcategoryName, month) {
      if (!month) return true; // Si pas de date, tout est disponible
      
      const normalizedName = subcategoryName.toUpperCase().trim();
      
      // PIVOINE : disponible avril → juin (4-6)
      if (normalizedName.includes('PIVOINE')) {
        return month >= 4 && month <= 6;
      }
      
      // TULIPE : disponible janvier → avril (1-4)
      if (normalizedName.includes('TULIPE')) {
        return month >= 1 && month <= 4;
      }
      
      // RENONCULES : disponible janvier → mars (1-3)
      if (normalizedName.includes('RENONCULE')) {
        return month >= 1 && month <= 3;
      }
      
      // Par défaut, toutes les autres sous-catégories sont disponibles
      return true;
    }

    // Stockage des sélections : { categoryName: { subcategoryName: { varietyId: quantity } } }
    const flowersSelections = {};
    let currentCategoryName = null;
    let currentSubcategoryName = null;

    function getVarietyDisplayName(variety) {
      if (!variety) return '';
      if (variety.displayName) return String(variety.displayName).trim();
      const parent = String(variety.subcategoryName || variety.categoryName || '').trim();
      const shortName = String(variety.name || '').trim();
      if (parent && shortName) return parent + ' — ' + shortName;
      return parent || shortName;
    }

    // Charger les données depuis le script JSON
    const flowersDataScript = document.getElementById('flowers-varieties-data');
    const flowersVarietiesData = {};
    const flowersSubcategoriesData = {};
    const flowersCategoriesData = {};
    let flowersData = null; // Garder une référence aux données brutes pour éviter les doublons
    
    if (flowersDataScript) {
      try {
        flowersData = JSON.parse(flowersDataScript.textContent);
        
        // Organiser les variétés par ID
        if (flowersData.varieties) {
          flowersData.varieties.forEach(variety => {
            variety.displayName = getVarietyDisplayName(variety);
            flowersVarietiesData[variety.id] = variety;
          });
        }
        
        // Organiser les sous-catégories par ID uniquement
        // On garde aussi un index par nom pour faciliter la recherche, mais on utilisera seulement les IDs pour l'itération
        if (flowersData.subcategories) {
          flowersData.subcategories.forEach(subcategory => {
            flowersSubcategoriesData[subcategory.id] = subcategory;
            // Créer aussi un index par nom pour faciliter la recherche (mais on n'itère pas dessus)
            flowersSubcategoriesData[subcategory.name] = subcategory;
          });
        }
        
        // Organiser les catégories par ID et par nom
        if (flowersData.categories) {
          flowersData.categories.forEach(category => {
            flowersCategoriesData[category.id] = category;
            // Créer aussi un index par nom pour faciliter la recherche
            flowersCategoriesData[category.name] = category;
          });
        }
      } catch (e) {
        console.error('Erreur lors du chargement des données des fleurs:', e);
      }
    }

    // Fonction pour calculer le nombre total de sélections pour une variété dans une sous-catégorie
    function getVarietySelectionCount(categoryName, subcategoryName) {
      if (!flowersSelections[categoryName] || !flowersSelections[categoryName][subcategoryName]) return 0;
      let total = 0;
      Object.values(flowersSelections[categoryName][subcategoryName]).forEach(quantity => {
        total += quantity;
      });
      return total;
    }

    // Fonction pour calculer le nombre total de sélections pour une sous-catégorie
    function getSubcategorySelectionCount(categoryName, subcategoryName) {
      return getVarietySelectionCount(categoryName, subcategoryName);
    }

    // Fonction pour calculer le nombre total de sélections pour une catégorie
    function getCategorySelectionCount(categoryName) {
      if (!flowersSelections[categoryName]) return 0;
      let total = 0;
      
      // Compter les variétés directement liées à la catégorie (sans sous-catégorie)
      if (flowersSelections[categoryName]['direct']) {
        Object.values(flowersSelections[categoryName]['direct']).forEach(quantity => {
          total += quantity;
        });
      }
      
      // Compter les variétés via les sous-catégories
      Object.keys(flowersSelections[categoryName]).forEach(subcategoryName => {
        if (subcategoryName !== 'direct') {
          total += getSubcategorySelectionCount(categoryName, subcategoryName);
        }
      });
      
      return total;
    }

    // Fonction pour mettre à jour les compteurs de sélections et l'état visuel
    function updateSelectionCounts() {
      // Mettre à jour les compteurs des catégories
      document.querySelectorAll('.flower-category-option[data-category-id]').forEach(option => {
        const categoryId = option.getAttribute('data-category-id');
        const categoryName = option.getAttribute('data-category-name');
        const countEl = option.querySelector('.flower-category-count');
        
        if (countEl && categoryName) {
          const count = getCategorySelectionCount(categoryName);
          
          if (count > 0) {
            countEl.textContent = count + (count > 1 ? ' sélectionnés' : ' sélectionné');
            option.classList.add('selected');
          } else {
            countEl.textContent = '0 sélectionné';
            option.classList.remove('selected');
          }
        }
      });

      // Mettre à jour les compteurs des sous-catégories (dans la vue des sous-catégories)
      document.querySelectorAll('.flower-category-option[data-subcategory-id]').forEach(option => {
        const subcategoryId = option.getAttribute('data-subcategory-id');
        const subcategoryName = option.getAttribute('data-subcategory-name');
        const countEl = option.querySelector('.flower-category-count');
        
        if (countEl && subcategoryName && currentCategoryName) {
          const count = getSubcategorySelectionCount(currentCategoryName, subcategoryName);
          
          if (count > 0) {
            countEl.textContent = count + (count > 1 ? ' sélectionnés' : ' sélectionné');
            option.classList.add('selected');
          } else {
            countEl.textContent = '0 sélectionné';
            option.classList.remove('selected');
          }
        }
      });
    }

    // Fonction pour afficher les sous-catégories d'une catégorie
    function showSubcategoriesForCategory(categoryId) {
      const category = flowersCategoriesData[categoryId];
      if (!category) return;

      const categoryName = category.name;
      currentCategoryName = categoryName;
      
      // Mettre à jour le titre
      if (flowersSubcategoriesTitle) {
        flowersSubcategoriesTitle.textContent = categoryName;
      }

      // Filtrer les sous-catégories pour cette catégorie (par nom)
      // Ne garder que les clés qui sont des IDs (pas des noms) pour éviter les doublons
      const subcategoriesForCategory = flowersData && flowersData.subcategories
        ? flowersData.subcategories
            .filter(subcategory => subcategory.categoryName === categoryName)
            .map(subcategory => subcategory.id)
        : Object.keys(flowersSubcategoriesData).filter(key => {
            // Vérifier si c'est un ID (présent dans le JSON avec un champ "id" correspondant)
            const subcategory = flowersSubcategoriesData[key];
            return subcategory && subcategory.id === key && subcategory.categoryName === categoryName;
          });

      // Générer le HTML des sous-catégories
      if (flowersSubcategoriesList) {
        flowersSubcategoriesList.innerHTML = '';
        
        // Supprimer l'ancien lien "VOIR PLUS" s'il existe
        const existingSeeMore = flowersSubcategoriesView.querySelector('.questionnaire-see-more');
        if (existingSeeMore) {
          existingSeeMore.remove();
        }
        
        subcategoriesForCategory.forEach((subcategoryId, index) => {
          const subcategory = flowersSubcategoriesData[subcategoryId];
          const subcategoryName = subcategory.name;
          const count = getSubcategorySelectionCount(categoryName, subcategoryName);
          
          // Vérifier la disponibilité saisonnière
          const weddingMonth = getWeddingMonth();
          const isAvailable = isSubcategoryAvailable(subcategoryName, weddingMonth);
          
          const subcategoryItem = document.createElement('div');
          let itemClasses = 'flower-category-option';
          if (count > 0) itemClasses += ' selected';
          if (index >= 3) itemClasses += ' flower-subcategory-hidden';
          if (!isAvailable) itemClasses += ' disabled unavailable';
          
          subcategoryItem.className = itemClasses;
          subcategoryItem.setAttribute('data-subcategory-id', subcategoryId);
          subcategoryItem.setAttribute('data-subcategory-name', subcategoryName);
          
          subcategoryItem.innerHTML = `
            ${subcategory.image ? `<div class="flower-category-icon"><img src="${subcategory.image}" alt="${subcategoryName}" loading="eager" decoding="async" data-fallback-src="${subcategory.image}" ${!isAvailable ? 'style="opacity: 0.5;"' : ''}></div>` : `
              <div class="flower-category-icon">
                <svg class="svg-icon" width="40" height="40" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2">
                  <path d="M12 2L2 7l10 5 10-5-10-5z"></path>
                  <path d="M2 17l10 5 10-5"></path>
                  <path d="M2 12l10 5 10-5"></path>
                </svg>
              </div>
            `}
            <div class="flower-category-name">${subcategoryName}</div>
            <div class="flower-category-arrow">
              <svg class="svg-icon" width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2">
                <polyline points="9 18 15 12 9 6"></polyline>
              </svg>
            </div>
            <div class="flower-category-count" data-count-subcategory="${subcategoryId}">
              ${count > 0 ? count + (count > 1 ? ' sélectionnés' : ' sélectionné') : '0 sélectionné'}
            </div>
            ${!isAvailable ? '<div class="unavailable-badge">Non disponible cette saison</div>' : ''}
          `;
          
          // Event listener pour cliquer sur la sous-catégorie (seulement si disponible)
          if (isAvailable) {
            subcategoryItem.addEventListener('click', function() {
              showVarietiesForSubcategory(subcategoryId);
            });
          } else {
            subcategoryItem.style.cursor = 'not-allowed';
            subcategoryItem.addEventListener('click', function(e) {
              e.preventDefault();
              e.stopPropagation();
            });
          }
          
          flowersSubcategoriesList.appendChild(subcategoryItem);
        });
        
        // Ajouter le lien "VOIR PLUS" si plus de 3 sous-catégories
        if (subcategoriesForCategory.length > 3) {
          const seeMoreContainer = document.createElement('div');
          seeMoreContainer.className = 'questionnaire-see-more';
          seeMoreContainer.innerHTML = '<a href="#" class="see-more-link" id="flowers-subcategories-see-more">VOIR PLUS</a>';
          flowersSubcategoriesList.parentElement.appendChild(seeMoreContainer);
        }
      }

      // Afficher la vue des sous-catégories et masquer la vue des catégories
      if (flowersCategoriesView) flowersCategoriesView.style.display = 'none';
      if (flowersSubcategoriesView) flowersSubcategoriesView.style.display = 'block';
      if (flowersVarietiesView) flowersVarietiesView.style.display = 'none';

      primeFlowerImagesInRoot(flowersSubcategoriesList);
      
      // Mettre à jour la disponibilité des sous-catégories après affichage
      setTimeout(function() {
        updateSubcategoriesAvailability();
      }, 50);
    }

    // Fonction pour afficher les variétés d'une sous-catégorie
    function showVarietiesForSubcategory(subcategoryId) {
      const subcategory = flowersSubcategoriesData[subcategoryId];
      if (!subcategory) return;

      const subcategoryName = subcategory.name;
      currentSubcategoryName = subcategoryName;
      
      // Mettre à jour le titre
      if (flowersVarietiesTitle) {
        flowersVarietiesTitle.textContent = subcategoryName;
      }

      // Filtrer les variétés pour cette sous-catégorie (par nom)
      const varietiesForSubcategory = Object.keys(flowersVarietiesData).filter(varietyId => {
        return flowersVarietiesData[varietyId].subcategoryName === subcategoryName;
      });

      // Générer le HTML des variétés
      if (flowersVarietiesList) {
        flowersVarietiesList.innerHTML = '';
        
        // Supprimer l'ancien lien "VOIR PLUS" s'il existe
        const existingSeeMore = flowersVarietiesView.querySelector('.questionnaire-see-more');
        if (existingSeeMore) {
          existingSeeMore.remove();
        }
        
          varietiesForSubcategory.forEach((varietyId, index) => {
            const variety = flowersVarietiesData[varietyId];
            const varietyLabel = getVarietyDisplayName(variety);
            const currentQuantity = flowersSelections[currentCategoryName] && 
                                    flowersSelections[currentCategoryName][subcategoryName] && 
                                    flowersSelections[currentCategoryName][subcategoryName][varietyId] ? 
                                    flowersSelections[currentCategoryName][subcategoryName][varietyId] : 0;
          
          const varietyItem = document.createElement('div');
          varietyItem.className = 'flower-variety-item' + (currentQuantity > 0 ? ' selected' : '') + (index >= 4 ? ' flower-variety-hidden' : '');
          varietyItem.setAttribute('data-variety-id', varietyId);
          
          // Construire le tableau d'images
          const images = [];
          if (variety.image) images.push(variety.image);
          if (variety.image_1) images.push(variety.image_1);
          if (variety.image_2) images.push(variety.image_2);
          if (variety.image_3) images.push(variety.image_3);
          if (variety.image_4) images.push(variety.image_4);
          
          // Générer le HTML du swiper si plusieurs images, sinon image simple
          let imageHTML = '';
          // Utiliser la première image pour le zoom (ou la seule image disponible)
          const zoomImageUrl = images.length > 0 ? images[0] : '';
          
          if (images.length > 1) {
            // Swiper pour plusieurs images
            imageHTML = `
              <div class="flower-variety-image-swiper-container" data-variety-swiper="${varietyId}">
                <div class="swiper flower-variety-swiper">
                  <div class="swiper-wrapper">
                    ${images.map(img => `
                      <div class="swiper-slide">
                        <img src="${img}" alt="${varietyLabel}" loading="eager" decoding="async" data-fallback-src="${img}">
                      </div>
                    `).join('')}
                  </div>
                  <div class="swiper-button-next flower-variety-swiper-next"></div>
                  <div class="swiper-button-prev flower-variety-swiper-prev"></div>
                  <div class="swiper-pagination flower-variety-swiper-pagination"></div>
                </div>
              </div>
            `;
          } else if (images.length === 1) {
            // Image simple si une seule image
            imageHTML = `
              <div class="flower-variety-image">
                <img src="${images[0]}" alt="${varietyLabel}" loading="eager" decoding="async" data-fallback-src="${images[0]}">
              </div>
            `;
          }
          
          varietyItem.innerHTML = `
            <div class="flower-variety-image-wrapper">
              ${imageHTML}
              ${zoomImageUrl ? `
              <button class="image-zoom-btn" data-lightbox-src="${zoomImageUrl}" aria-label="Agrandir l'image">
                <svg class="svg-icon" width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round">
                  <circle cx="12" cy="12" r="10"></circle>
                  <path d="M9.09 9a3 3 0 0 1 5.83 1c0 2-3 3-3 3"></path>
                  <line x1="12" y1="17" x2="12.01" y2="17"></line>
                </svg>
              </button>
              ` : ''}
              <div class="flower-variety-overlay">
                <svg class="svg-icon" width="30" height="30" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2">
                  <polyline points="20 6 9 17 4 12"></polyline>
                </svg>
              </div>
            </div>
            <div class="flower-variety-name">${varietyLabel}</div>
            <div class="flower-variety-price">${variety.price} €</div>
            <div class="flower-variety-quantity-info">${variety.quantityPerBundle} fleurs par botte</div>
            <div class="flower-variety-bundles-selector">
              <span class="flower-variety-bundles-label">Nombre de bottes :</span>
              <div class="flower-variety-bundles-controls">
                <button type="button" class="flower-variety-bundles-btn variety-bundle-minus" data-variety-id="${varietyId}">-</button>
                <span class="flower-variety-bundles-value" id="variety-quantity-${varietyId}">${currentQuantity}</span>
                <button type="button" class="flower-variety-bundles-btn variety-bundle-plus" data-variety-id="${varietyId}">+</button>
              </div>
            </div>
          `;
          
          // Initialiser Swiper si plusieurs images
          if (images.length > 1) {
            const swiperContainer = varietyItem.querySelector(`.flower-variety-swiper`);
            if (swiperContainer && typeof Swiper !== 'undefined') {
              new Swiper(swiperContainer, {
                slidesPerView: 1,
                spaceBetween: 0,
                loop: false,
                navigation: {
                  nextEl: varietyItem.querySelector('.flower-variety-swiper-next'),
                  prevEl: varietyItem.querySelector('.flower-variety-swiper-prev'),
                },
                pagination: {
                  el: varietyItem.querySelector('.flower-variety-swiper-pagination'),
                  clickable: true,
                },
              });
            }
          }
          
          flowersVarietiesList.appendChild(varietyItem);
          
          // Ajouter l'event listener pour cliquer sur toute la carte
          varietyItem.addEventListener('click', function(e) {
            // Ne pas déclencher si le clic est sur un bouton +/- ou sur les contrôles swiper
            if (e.target.closest('.flower-variety-bundles-btn') || 
                e.target.closest('.flower-variety-swiper-next') || 
                e.target.closest('.flower-variety-swiper-prev') ||
                e.target.closest('.swiper-pagination') ||
                e.target.closest('.image-zoom-btn')) {
          return;
        }
        
            const varietyId = this.getAttribute('data-variety-id');
            const quantityEl = document.getElementById('variety-quantity-' + varietyId);
            if (!quantityEl) return;
            
            const currentValue = parseInt(quantityEl.textContent) || 0;
            
            if (currentValue === 0) {
              // Si pas sélectionné, sélectionner et mettre quantité à 1
              quantityEl.textContent = '1';
              
              // Désélectionner le bouton "JE NE SOUHAITE PAS" si une variété est sélectionnée
              if (noFlowersBtn && noFlowersBtn.classList.contains('selected')) {
                noFlowersBtn.classList.remove('selected');
              }
              
              // Mettre à jour les sélections (structure à 3 niveaux)
              if (!flowersSelections[currentCategoryName]) {
                flowersSelections[currentCategoryName] = {};
              }
              if (!flowersSelections[currentCategoryName][currentSubcategoryName]) {
                flowersSelections[currentCategoryName][currentSubcategoryName] = {};
              }
              flowersSelections[currentCategoryName][currentSubcategoryName][varietyId] = 1;
              
              // Mettre à jour l'état visuel
          this.classList.add('selected');
            } else {
              // Si déjà sélectionné, désélectionner
              quantityEl.textContent = '0';
              
              // Retirer de la sélection (structure à 3 niveaux)
              if (flowersSelections[currentCategoryName] && 
                  flowersSelections[currentCategoryName][currentSubcategoryName]) {
                delete flowersSelections[currentCategoryName][currentSubcategoryName][varietyId];
                
                // Si plus de variétés dans cette sous-catégorie, supprimer la sous-catégorie
                if (Object.keys(flowersSelections[currentCategoryName][currentSubcategoryName]).length === 0) {
                  delete flowersSelections[currentCategoryName][currentSubcategoryName];
                }
                
                // Si plus de sous-catégories dans cette catégorie, supprimer la catégorie
                if (Object.keys(flowersSelections[currentCategoryName]).length === 0) {
                  delete flowersSelections[currentCategoryName];
                }
              }
              
              // Mettre à jour l'état visuel
              this.classList.remove('selected');
            }
            
            // Mettre à jour les compteurs et l'état visuel
            updateSelectionCounts();
            updateStep15Validation();
          });
        });

        // Ajouter les event listeners pour les boutons +/-
        flowersVarietiesList.querySelectorAll('.variety-bundle-minus, .variety-bundle-plus').forEach(btn => {
          btn.addEventListener('click', function() {
            const varietyId = this.getAttribute('data-variety-id');
            const quantityEl = document.getElementById('variety-quantity-' + varietyId);
            if (!quantityEl) return;

            let currentValue = parseInt(quantityEl.textContent) || 0;
            
            if (this.classList.contains('variety-bundle-minus')) {
              if (currentValue > 0) {
                currentValue--;
              }
            } else if (this.classList.contains('variety-bundle-plus')) {
              currentValue++;
            }

            quantityEl.textContent = currentValue;

            // Désélectionner le bouton "JE NE SOUHAITE PAS" si une variété est sélectionnée (quantité > 0)
            if (currentValue > 0 && noFlowersBtn && noFlowersBtn.classList.contains('selected')) {
              noFlowersBtn.classList.remove('selected');
            }

            // Mettre à jour les sélections (structure à 3 niveaux)
            if (!flowersSelections[currentCategoryName]) {
              flowersSelections[currentCategoryName] = {};
            }
            if (!flowersSelections[currentCategoryName][currentSubcategoryName]) {
              flowersSelections[currentCategoryName][currentSubcategoryName] = {};
            }
            if (currentValue > 0) {
              flowersSelections[currentCategoryName][currentSubcategoryName][varietyId] = currentValue;
            } else {
              delete flowersSelections[currentCategoryName][currentSubcategoryName][varietyId];
              
              // Si plus de variétés dans cette sous-catégorie, supprimer la sous-catégorie
              if (Object.keys(flowersSelections[currentCategoryName][currentSubcategoryName]).length === 0) {
                delete flowersSelections[currentCategoryName][currentSubcategoryName];
              }
              
              // Si plus de sous-catégories dans cette catégorie, supprimer la catégorie
              if (Object.keys(flowersSelections[currentCategoryName]).length === 0) {
                delete flowersSelections[currentCategoryName];
              }
            }

            // Mettre à jour l'état visuel
            const varietyItem = document.querySelector(`.flower-variety-item[data-variety-id="${varietyId}"]`);
            if (varietyItem) {
              if (currentValue > 0) {
                varietyItem.classList.add('selected');
              } else {
                varietyItem.classList.remove('selected');
              }
            }
            
            // Empêcher la propagation pour éviter de déclencher le clic sur la carte
            e.stopPropagation();

            // Mettre à jour les compteurs et l'état visuel
            updateSelectionCounts();
        updateStep15Validation();
          });
        });
        
        // Ajouter le lien "VOIR PLUS" si plus de 3 variétés
        if (varietiesForSubcategory.length > 3) {
          const seeMoreContainer = document.createElement('div');
          seeMoreContainer.className = 'questionnaire-see-more';
          seeMoreContainer.innerHTML = '<a href="#" class="see-more-link" id="flowers-varieties-see-more">VOIR PLUS</a>';
          flowersVarietiesView.appendChild(seeMoreContainer);
        }
      }

      primeFlowerImagesInRoot(flowersVarietiesList);

      // Afficher la vue des variétés et masquer les autres vues
      if (flowersCategoriesView) flowersCategoriesView.style.display = 'none';
      if (flowersSubcategoriesView) flowersSubcategoriesView.style.display = 'none';
      if (flowersVarietiesView) flowersVarietiesView.style.display = 'block';
    }

    // Fonction pour afficher directement les variétés d'une catégorie (sans sous-catégories)
    function showVarietiesForCategory(categoryId) {
      const category = flowersCategoriesData[categoryId];
      if (!category) return;

      const categoryName = category.name;
      currentCategoryName = categoryName;
      currentSubcategoryName = null; // Pas de sous-catégorie pour ce cas
      
      // Mettre à jour le titre
      if (flowersVarietiesTitle) {
        flowersVarietiesTitle.textContent = categoryName;
      }

      // Filtrer les variétés pour cette catégorie (par categoryName, sans subcategoryName)
      const varietiesForCategory = Object.keys(flowersVarietiesData).filter(varietyId => {
        const variety = flowersVarietiesData[varietyId];
        return variety.categoryName === categoryName && (!variety.subcategoryName || variety.subcategoryName === '');
      });

      // Générer le HTML des variétés
      if (flowersVarietiesList) {
        flowersVarietiesList.innerHTML = '';
        
        // Supprimer l'ancien lien "VOIR PLUS" s'il existe
        const existingSeeMore = flowersVarietiesView.querySelector('.questionnaire-see-more');
        if (existingSeeMore) {
          existingSeeMore.remove();
        }
        
        varietiesForCategory.forEach((varietyId, index) => {
          const variety = flowersVarietiesData[varietyId];
          const varietyLabel = getVarietyDisplayName(variety);
          // Pour les variétés directement liées à une catégorie, on utilise une structure différente
          // { categoryName: { 'direct': { varietyId: quantity } } }
          const currentQuantity = flowersSelections[categoryName] && 
                                  flowersSelections[categoryName]['direct'] && 
                                  flowersSelections[categoryName]['direct'][varietyId] ? 
                                  flowersSelections[categoryName]['direct'][varietyId] : 0;
        
          const varietyItem = document.createElement('div');
          varietyItem.className = 'flower-variety-item' + (currentQuantity > 0 ? ' selected' : '') + (index >= 4 ? ' flower-variety-hidden' : '');
          varietyItem.setAttribute('data-variety-id', varietyId);
          
          // Construire le tableau d'images
          const images = [];
          if (variety.image) images.push(variety.image);
          if (variety.image_1) images.push(variety.image_1);
          if (variety.image_2) images.push(variety.image_2);
          if (variety.image_3) images.push(variety.image_3);
          if (variety.image_4) images.push(variety.image_4);
          
          // Générer le HTML du swiper si plusieurs images, sinon image simple
          let imageHTML = '';
          if (images.length > 1) {
            // Swiper pour plusieurs images
            imageHTML = `
              <div class="flower-variety-image-swiper-container" data-variety-swiper="${varietyId}">
                <div class="swiper flower-variety-swiper">
                  <div class="swiper-wrapper">
                    ${images.map(img => `
                      <div class="swiper-slide">
                        <img src="${img}" alt="${varietyLabel}" loading="eager" decoding="async" data-fallback-src="${img}">
                      </div>
                    `).join('')}
                  </div>
                  <div class="swiper-button-next flower-variety-swiper-next"></div>
                  <div class="swiper-button-prev flower-variety-swiper-prev"></div>
                  <div class="swiper-pagination flower-variety-swiper-pagination"></div>
                </div>
              </div>
            `;
          } else if (images.length === 1) {
            // Image simple si une seule image
            imageHTML = `
              <div class="flower-variety-image">
                <img src="${images[0]}" alt="${varietyLabel}" loading="eager" decoding="async" data-fallback-src="${images[0]}">
              </div>
            `;
          }
          
          varietyItem.innerHTML = `
            <div class="flower-variety-image-wrapper">
              ${imageHTML}
              <div class="flower-variety-overlay">
                <svg class="svg-icon" width="30" height="30" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2">
                  <polyline points="20 6 9 17 4 12"></polyline>
                </svg>
              </div>
            </div>
            <div class="flower-variety-name">${varietyLabel}</div>
            <div class="flower-variety-price">${variety.price} €</div>
            <div class="flower-variety-quantity-info">${variety.quantityPerBundle} fleurs par botte</div>
            <div class="flower-variety-bundles-selector">
              <span class="flower-variety-bundles-label">Nombre de bottes :</span>
              <div class="flower-variety-bundles-controls">
                <button type="button" class="flower-variety-bundles-btn variety-bundle-minus" data-variety-id="${varietyId}">-</button>
                <span class="flower-variety-bundles-value" id="variety-quantity-${varietyId}">${currentQuantity}</span>
                <button type="button" class="flower-variety-bundles-btn variety-bundle-plus" data-variety-id="${varietyId}">+</button>
              </div>
            </div>
          `;
          
          // Initialiser Swiper si plusieurs images
          if (images.length > 1) {
            const swiperContainer = varietyItem.querySelector(`.flower-variety-swiper`);
            if (swiperContainer && typeof Swiper !== 'undefined') {
              new Swiper(swiperContainer, {
                slidesPerView: 1,
                spaceBetween: 0,
                loop: false,
                navigation: {
                  nextEl: varietyItem.querySelector('.flower-variety-swiper-next'),
                  prevEl: varietyItem.querySelector('.flower-variety-swiper-prev'),
                },
                pagination: {
                  el: varietyItem.querySelector('.flower-variety-swiper-pagination'),
                  clickable: true,
                },
              });
            }
          }
          
          flowersVarietiesList.appendChild(varietyItem);
          
          // Ajouter l'event listener pour cliquer sur toute la carte
          varietyItem.addEventListener('click', function(e) {
            // Ne pas déclencher si le clic est sur un bouton +/- ou sur les contrôles swiper
            if (e.target.closest('.flower-variety-bundles-btn') || 
                e.target.closest('.flower-variety-swiper-next') || 
                e.target.closest('.flower-variety-swiper-prev') ||
                e.target.closest('.swiper-pagination') ||
                e.target.closest('.image-zoom-btn')) {
              return;
            }
        
            const varietyId = this.getAttribute('data-variety-id');
            const quantityEl = document.getElementById('variety-quantity-' + varietyId);
            if (!quantityEl) return;
            
            const currentValue = parseInt(quantityEl.textContent) || 0;
            
            if (currentValue === 0) {
              // Si pas sélectionné, sélectionner et mettre quantité à 1
              quantityEl.textContent = '1';
              
              // Désélectionner le bouton "JE NE SOUHAITE PAS" si une variété est sélectionnée
              if (noFlowersBtn && noFlowersBtn.classList.contains('selected')) {
                noFlowersBtn.classList.remove('selected');
              }
              
              // Mettre à jour les sélections (structure pour variétés directement liées à une catégorie)
              if (!flowersSelections[categoryName]) {
                flowersSelections[categoryName] = {};
              }
              if (!flowersSelections[categoryName]['direct']) {
                flowersSelections[categoryName]['direct'] = {};
              }
              flowersSelections[categoryName]['direct'][varietyId] = 1;
              
              // Mettre à jour l'état visuel
              this.classList.add('selected');
            } else {
              // Si déjà sélectionné, désélectionner
              quantityEl.textContent = '0';
              
              // Retirer de la sélection
              if (flowersSelections[categoryName] && 
                  flowersSelections[categoryName]['direct']) {
                delete flowersSelections[categoryName]['direct'][varietyId];
                
                // Si plus de variétés dans cette catégorie, supprimer la catégorie
                if (Object.keys(flowersSelections[categoryName]['direct']).length === 0) {
                  delete flowersSelections[categoryName]['direct'];
                  if (Object.keys(flowersSelections[categoryName]).length === 0) {
                    delete flowersSelections[categoryName];
                  }
                }
              }
              
              // Mettre à jour l'état visuel
              this.classList.remove('selected');
            }
            
            // Mettre à jour les compteurs et l'état visuel
            updateSelectionCounts();
            updateStep15Validation();
          });
        });

        // Ajouter les event listeners pour les boutons +/-
        flowersVarietiesList.querySelectorAll('.variety-bundle-minus, .variety-bundle-plus').forEach(btn => {
          btn.addEventListener('click', function(e) {
            const varietyId = this.getAttribute('data-variety-id');
            const quantityEl = document.getElementById('variety-quantity-' + varietyId);
            if (!quantityEl) return;

            let currentValue = parseInt(quantityEl.textContent) || 0;
            
            if (this.classList.contains('variety-bundle-minus')) {
              if (currentValue > 0) {
                currentValue--;
              }
            } else if (this.classList.contains('variety-bundle-plus')) {
              currentValue++;
            }

            quantityEl.textContent = currentValue;

            // Désélectionner le bouton "JE NE SOUHAITE PAS" si une variété est sélectionnée (quantité > 0)
            if (currentValue > 0 && noFlowersBtn && noFlowersBtn.classList.contains('selected')) {
              noFlowersBtn.classList.remove('selected');
            }

            // Mettre à jour les sélections (structure pour variétés directement liées à une catégorie)
            if (!flowersSelections[categoryName]) {
              flowersSelections[categoryName] = {};
            }
            if (!flowersSelections[categoryName]['direct']) {
              flowersSelections[categoryName]['direct'] = {};
            }
            if (currentValue > 0) {
              flowersSelections[categoryName]['direct'][varietyId] = currentValue;
            } else {
              delete flowersSelections[categoryName]['direct'][varietyId];
              
              // Si plus de variétés dans cette catégorie, supprimer la catégorie
              if (Object.keys(flowersSelections[categoryName]['direct']).length === 0) {
                delete flowersSelections[categoryName]['direct'];
                if (Object.keys(flowersSelections[categoryName]).length === 0) {
                  delete flowersSelections[categoryName];
                }
              }
            }

            // Mettre à jour l'état visuel
            const varietyItem = document.querySelector(`.flower-variety-item[data-variety-id="${varietyId}"]`);
            if (varietyItem) {
              if (currentValue > 0) {
                varietyItem.classList.add('selected');
              } else {
                varietyItem.classList.remove('selected');
              }
            }
            
            // Empêcher la propagation pour éviter de déclencher le clic sur la carte
            e.stopPropagation();

            // Mettre à jour les compteurs et l'état visuel
            updateSelectionCounts();
            updateStep15Validation();
          });
        });
        
        // Ajouter le lien "VOIR PLUS" si plus de 3 variétés
        if (varietiesForCategory.length > 3) {
          const seeMoreContainer = document.createElement('div');
          seeMoreContainer.className = 'questionnaire-see-more';
          seeMoreContainer.innerHTML = '<a href="#" class="see-more-link" id="flowers-varieties-see-more">VOIR PLUS</a>';
          flowersVarietiesView.appendChild(seeMoreContainer);
        }
      }

      primeFlowerImagesInRoot(flowersVarietiesList);

      // Afficher la vue des variétés et masquer les autres vues
      if (flowersCategoriesView) flowersCategoriesView.style.display = 'none';
      if (flowersSubcategoriesView) flowersSubcategoriesView.style.display = 'none';
      if (flowersVarietiesView) flowersVarietiesView.style.display = 'block';
    }

    // Fonction pour revenir à la vue des sous-catégories
    function showSubcategoriesView() {
      if (flowersCategoriesView) flowersCategoriesView.style.display = 'none';
      if (flowersSubcategoriesView) flowersSubcategoriesView.style.display = 'block';
      if (flowersVarietiesView) flowersVarietiesView.style.display = 'none';
      currentSubcategoryName = null;
      
      // Mettre à jour les compteurs et l'état visuel
      updateSelectionCounts();
    }

    // Fonction pour revenir à la vue des catégories
    function showCategoriesView() {
      if (flowersCategoriesView) flowersCategoriesView.style.display = 'block';
      if (flowersSubcategoriesView) flowersSubcategoriesView.style.display = 'none';
      if (flowersVarietiesView) flowersVarietiesView.style.display = 'none';
      currentCategoryName = null;
      currentSubcategoryName = null;
      
      // Mettre à jour les compteurs et l'état visuel
      updateSelectionCounts();
    }

    // Event listener pour le bouton retour vers catégories
    if (flowersBackToCategoriesBtn) {
      flowersBackToCategoriesBtn.addEventListener('click', function() {
        showCategoriesView();
      });
    }

    // Event listener pour le bouton retour vers sous-catégories
    if (flowersBackToSubcategoriesBtn) {
      flowersBackToSubcategoriesBtn.addEventListener('click', function() {
        // Si on vient directement d'une catégorie (sans sous-catégorie), retourner aux catégories
        // Sinon, retourner aux sous-catégories
        if (currentSubcategoryName === null && currentCategoryName !== null) {
          showCategoriesView();
        } else {
          showSubcategoriesView();
        }
      });
    }

    // Event listeners pour "VOIR PLUS" / "VOIR MOINS" - Catégories
    document.addEventListener('click', function(e) {
      if (e.target && e.target.id === 'flowers-categories-see-more') {
        e.preventDefault();
        const categoriesGrid = document.querySelector('.questionnaire-flowers-categories-grid');
        if (categoriesGrid) {
          const isExpanded = categoriesGrid.classList.contains('show-all');
          if (isExpanded) {
            categoriesGrid.classList.remove('show-all');
            e.target.textContent = 'VOIR PLUS';
          } else {
            categoriesGrid.classList.add('show-all');
            e.target.textContent = 'VOIR MOINS';
          }
        }
      }
    });

    // Event listeners pour "VOIR PLUS" / "VOIR MOINS" - Sous-catégories
    document.addEventListener('click', function(e) {
      if (e.target && e.target.id === 'flowers-subcategories-see-more') {
        e.preventDefault();
        const subcategoriesGrid = document.querySelector('.questionnaire-flowers-subcategories-grid');
        if (subcategoriesGrid) {
          const isExpanded = subcategoriesGrid.classList.contains('show-all');
          if (isExpanded) {
            subcategoriesGrid.classList.remove('show-all');
            e.target.textContent = 'VOIR PLUS';
          } else {
            subcategoriesGrid.classList.add('show-all');
            e.target.textContent = 'VOIR MOINS';
          }
        }
      }
    });

    // Event listeners pour "VOIR PLUS" / "VOIR MOINS" - Variétés
    document.addEventListener('click', function(e) {
      if (e.target && e.target.id === 'flowers-varieties-see-more') {
        e.preventDefault();
        const varietiesList = document.querySelector('.questionnaire-flowers-varieties-list');
        if (varietiesList) {
          const isExpanded = varietiesList.classList.contains('show-all');
          if (isExpanded) {
            varietiesList.classList.remove('show-all');
            e.target.textContent = 'VOIR PLUS';
          } else {
            varietiesList.classList.add('show-all');
            e.target.textContent = 'VOIR MOINS';
          }
        }
      }
    });

    // Event listeners pour les catégories
    document.querySelectorAll('.flower-category-option[data-category-id]').forEach(option => {
      option.addEventListener('click', function() {
        const categoryId = this.getAttribute('data-category-id');
        const hasSubcategories = this.getAttribute('data-has-subcategories');
        
        if (categoryId) {
          // Vérifier si la catégorie a des sous-catégories ou va directement aux variétés
          if (hasSubcategories === 'yes') {
            // A des sous-catégories : afficher les sous-catégories
            showSubcategoriesForCategory(categoryId);
          } else {
            // Va directement aux variétés : afficher les variétés
            showVarietiesForCategory(categoryId);
          }
        }
      });
    });

    // Fonction de validation de l'étape 15
    function updateStep15Validation() {
      if (!validateStep15) return;
      
      const noFlowersSelected = noFlowersBtn && noFlowersBtn.classList.contains('selected');
      const hasSelections = Object.keys(flowersSelections).length > 0 && 
        Object.values(flowersSelections).some(category => 
          Object.values(category).some(subcat => Object.keys(subcat).length > 0)
        );

      if (noFlowersSelected || hasSelections) {
        validateStep15.disabled = false;
      } else {
        validateStep15.disabled = true;
      }
    }

    // Fonction pour mettre à jour la disponibilité des sous-catégories affichées
    function updateSubcategoriesAvailability() {
      if (!flowersSubcategoriesList) return;
      
      const subcategoryItems = flowersSubcategoriesList.querySelectorAll('.flower-category-option[data-subcategory-name]');
      const weddingMonth = getWeddingMonth();
      
      subcategoryItems.forEach(item => {
        const subcategoryName = item.getAttribute('data-subcategory-name');
        const isAvailable = isSubcategoryAvailable(subcategoryName, weddingMonth);
        
        // Mettre à jour les classes
        if (isAvailable) {
          item.classList.remove('disabled', 'unavailable');
          item.style.cursor = 'pointer';
          item.style.pointerEvents = 'auto';
          
          // Retirer le badge
          const badge = item.querySelector('.unavailable-badge');
          if (badge) badge.remove();
          
          // Réactiver le clic si nécessaire
          const subcategoryId = item.getAttribute('data-subcategory-id');
          item.onclick = function() {
            showVarietiesForSubcategory(subcategoryId);
          };
        } else {
          item.classList.add('disabled', 'unavailable');
          item.style.cursor = 'not-allowed';
          item.style.pointerEvents = 'none';
          
          // Ajouter le badge si absent
          if (!item.querySelector('.unavailable-badge')) {
            const badge = document.createElement('div');
            badge.className = 'unavailable-badge';
            badge.textContent = 'Non disponible cette saison';
            item.style.position = 'relative';
            item.appendChild(badge);
          }
          
          // Désactiver le clic
          item.onclick = function(e) {
            e.preventDefault();
            e.stopPropagation();
          };
        }
      });
    }

    // Gestion du bouton "Je ne souhaite pas"
    if (noFlowersBtn) {
      noFlowersBtn.addEventListener('click', function() {
        // Vider toutes les sélections (structure à 3 niveaux)
        Object.keys(flowersSelections).forEach(categoryName => {
          delete flowersSelections[categoryName];
        });
        
        // Toggle : si déjà actif, désactiver
        this.classList.toggle('selected');
        
        // Mettre à jour les compteurs
        updateSelectionCounts();
        updateStep15Validation();
      });
    }

    // Initialiser l'état
    updateSelectionCounts();
    updateStep15Validation();
    
    // Écouter les changements de date pour mettre à jour la disponibilité
    if (DOMCache.weddingDateInput) {
      DOMCache.weddingDateInput.addEventListener('change', function() {
        // Si on est à l'étape 15 et dans la vue des sous-catégories, mettre à jour
        if (currentStep === 16 && flowersSubcategoriesView && flowersSubcategoriesView.style.display !== 'none') {
          updateSubcategoriesAvailability();
        }
      });
    }

    /* ============================================
       ÉTAPE 13 - CONTENANTS
       ============================================ */

    bindStep13ProductZoomButtons(document.querySelector('[data-step="13"]') || document);
    
    // Gestion de la sélection des contenants
    const containerItems = document.querySelectorAll('.container-item');
    const noContainersOption = document.getElementById('step13-no-containers-option');
    const validateStep13Btn = document.getElementById('validate-step-13');
    const containersCalculLink = document.getElementById('containers-calcul-link');
    const containersCalculModal = document.getElementById('containers-calcul-modal');
    const containersCalculModalClose = document.getElementById('containers-calcul-modal-close');
    const containersCalculResults = document.getElementById('containers-calcul-results');

    // Gestion de la sélection des sacs cadeaux
    const giftBagItems = document.querySelectorAll('.gift-bag-item');
    const noGiftBagsBtn = document.getElementById('no-gift-bags-btn');

    // Fonction pour mettre à jour la validation de l'étape 13
    function updateStep13Validation() {
      if (!validateStep13Btn) return;
      
      // Validation pour les contenants : au moins un contenant sélectionné OU "Je n'ai pas besoin"
      const hasSelectedContainer = document.querySelector('.container-item.selected');
      const hasNoContainersSelected = noContainersOption && noContainersOption.classList.contains('selected');
      const containersValid = hasSelectedContainer || hasNoContainersSelected;
      
      // Validation pour les sacs cadeaux : au moins un sac cadeau sélectionné OU "Je ne souhaite pas" OU aucun sac cadeau sélectionné (optionnel)
      const hasSelectedGiftBag = document.querySelector('.gift-bag-item.selected');
      const hasNoGiftBagsSelected = noGiftBagsBtn && noGiftBagsBtn.classList.contains('selected');
      // Les sacs cadeaux sont optionnels, donc on valide même si rien n'est sélectionné
      const giftBagsValid = true; // Toujours valide car optionnel
      
      // Le bouton est activé si les contenants sont valides (les sacs cadeaux sont optionnels)
      if (containersValid) {
        validateStep13Btn.disabled = false;
      } else {
        validateStep13Btn.disabled = true;
      }
    }

    // Gestion des quantités pour les contenants (similaire à l'étape 5)
    containerItems.forEach(item => {
      const containerId = item.getAttribute('data-container-id');
      const quantityInput = item.querySelector(`#container-quantity-${containerId}`);
      const minusBtn = item.querySelector('.quantity-minus[data-container-id="' + containerId + '"]');
      const plusBtn = item.querySelector('.quantity-plus[data-container-id="' + containerId + '"]');
      
      if (quantityInput && minusBtn && plusBtn) {
        // Fonction pour mettre à jour l'état des boutons et activer/désactiver l'input
        function updateQuantityState() {
          const currentValue = parseInt(quantityInput.value) || 0;
          minusBtn.disabled = currentValue <= 0;
          quantityInput.disabled = currentValue <= 0;
          
          // Si la quantité est > 0, sélectionner l'item, sinon le désélectionner
          if (currentValue > 0) {
            item.classList.add('selected');
          } else {
            item.classList.remove('selected');
          }
          
          updateStep13Validation();
        }
        
        // Bouton moins
        minusBtn.addEventListener('click', function(e) {
          e.stopPropagation();
          const currentValue = parseInt(quantityInput.value) || 0;
          if (currentValue > 0) {
            quantityInput.value = currentValue - 1;
            updateQuantityState();
          }
        });
        
        // Bouton plus
        plusBtn.addEventListener('click', function(e) {
          e.stopPropagation();
          const currentValue = parseInt(quantityInput.value) || 0;
          quantityInput.value = currentValue + 1;
          updateQuantityState();
        });
        
        // Initialiser l'état
        updateQuantityState();
      }
    });

    // Gestion de la sélection des contenants
    if (containerItems.length > 0) {
      containerItems.forEach(item => {
        item.addEventListener('click', function(e) {
          // Ne pas déclencher si le clic est sur un élément interactif (bouton zoom, quantité)
          if (e.target.closest('.image-zoom-btn') || e.target.closest('.quantity-selector') || e.target.closest('.quantity-btn')) {
            return;
          }
          
          // Activer le sélecteur de quantité (similaire à l'étape 5)
          const containerId = this.getAttribute('data-container-id');
          const quantityInput = this.querySelector(`#container-quantity-${containerId}`);
          const minusBtn = this.querySelector('.quantity-minus[data-container-id="' + containerId + '"]');
          const plusBtn = this.querySelector('.quantity-plus[data-container-id="' + containerId + '"]');
          
          if (quantityInput && plusBtn) {
            // Si la quantité est à 0, la mettre à 1 et activer
            if (parseInt(quantityInput.value) === 0) {
              quantityInput.value = 1;
              quantityInput.disabled = false;
              if (minusBtn) minusBtn.disabled = false;
              this.classList.add('selected');
            } else {
              // Si déjà sélectionné, réinitialiser à 0
              quantityInput.value = 0;
              quantityInput.disabled = true;
              if (minusBtn) minusBtn.disabled = true;
              this.classList.remove('selected');
            }
            
            // Désélectionner l'option "Je n'ai pas besoin"
            if (noContainersOption) {
              noContainersOption.classList.remove('selected');
            }
            
            updateStep13Validation();
          }
        });
      });
    }

    // Gestion de l'option "Je n'ai pas besoin de contenants" (comme étape 12)
    if (noContainersOption) {
      noContainersOption.addEventListener('click', function(e) {
        // Désélectionner tous les contenants et réinitialiser les quantités
        containerItems.forEach(item => {
          item.classList.remove('selected');
          const containerId = item.getAttribute('data-container-id');
          const quantityInput = item.querySelector(`#container-quantity-${containerId}`);
          const minusBtn = item.querySelector('.quantity-minus[data-container-id="' + containerId + '"]');
          if (quantityInput) {
            quantityInput.value = 0;
            quantityInput.disabled = true;
            if (minusBtn) minusBtn.disabled = true;
          }
        });
        // Toggle cette option
        this.classList.toggle('selected');
        updateStep13Validation();
      });
    }

    // Gestion des quantités pour les sacs cadeaux (similaire aux contenants)
    giftBagItems.forEach(item => {
      const giftBagId = item.getAttribute('data-gift-bag-id');
      const quantityInput = item.querySelector(`#gift-bag-quantity-${giftBagId}`);
      const minusBtn = item.querySelector('.quantity-minus[data-gift-bag-id="' + giftBagId + '"]');
      const plusBtn = item.querySelector('.quantity-plus[data-gift-bag-id="' + giftBagId + '"]');
      
      if (quantityInput && minusBtn && plusBtn) {
        // Fonction pour mettre à jour l'état des boutons et activer/désactiver l'input
        function updateQuantityState() {
          const currentValue = parseInt(quantityInput.value) || 0;
          minusBtn.disabled = currentValue <= 0;
          quantityInput.disabled = currentValue <= 0;
          
          // Si la quantité est > 0, sélectionner l'item, sinon le désélectionner
          if (currentValue > 0) {
            item.classList.add('selected');
          } else {
            item.classList.remove('selected');
          }
          
          updateStep13Validation();
        }
        
        // Bouton moins
        minusBtn.addEventListener('click', function(e) {
          e.stopPropagation();
          const currentValue = parseInt(quantityInput.value) || 0;
          if (currentValue > 0) {
            quantityInput.value = currentValue - 1;
            updateQuantityState();
          }
        });
        
        // Bouton plus
        plusBtn.addEventListener('click', function(e) {
          e.stopPropagation();
          const currentValue = parseInt(quantityInput.value) || 0;
          quantityInput.value = currentValue + 1;
          updateQuantityState();
        });
        
        // Initialiser l'état
        updateQuantityState();
      }
    });

    // Gestion de la sélection des sacs cadeaux
    if (giftBagItems.length > 0) {
      giftBagItems.forEach(item => {
        item.addEventListener('click', function(e) {
          // Ne pas déclencher si le clic est sur un élément interactif (bouton zoom, quantité)
          if (e.target.closest('.image-zoom-btn') || e.target.closest('.quantity-selector') || e.target.closest('.quantity-btn')) {
            return;
          }
          
          // Activer le sélecteur de quantité (similaire à l'étape 5)
          const giftBagId = this.getAttribute('data-gift-bag-id');
          const quantityInput = this.querySelector(`#gift-bag-quantity-${giftBagId}`);
          const minusBtn = this.querySelector('.quantity-minus[data-gift-bag-id="' + giftBagId + '"]');
          const plusBtn = this.querySelector('.quantity-plus[data-gift-bag-id="' + giftBagId + '"]');
          
          if (quantityInput && plusBtn) {
            // Si la quantité est à 0, la mettre à 1 et activer
            if (parseInt(quantityInput.value) === 0) {
              quantityInput.value = 1;
              quantityInput.disabled = false;
              if (minusBtn) minusBtn.disabled = false;
              this.classList.add('selected');
            } else {
              // Si déjà sélectionné, réinitialiser à 0
              quantityInput.value = 0;
              quantityInput.disabled = true;
              if (minusBtn) minusBtn.disabled = true;
              this.classList.remove('selected');
            }
            
            // Désélectionner le bouton "Je ne souhaite pas"
            if (noGiftBagsBtn) {
              noGiftBagsBtn.classList.remove('selected');
            }
            
            updateStep13Validation(); 
          }
        });
      });
    }

    // Gestion du bouton "Je ne souhaite pas prendre de sacs cadeaux"
    if (noGiftBagsBtn) {
      noGiftBagsBtn.addEventListener('click', function(e) {
        e.preventDefault();
        // Désélectionner tous les sacs cadeaux et réinitialiser les quantités
        giftBagItems.forEach(item => {
          item.classList.remove('selected');
          const giftBagId = item.getAttribute('data-gift-bag-id');
          const quantityInput = item.querySelector(`#gift-bag-quantity-${giftBagId}`);
          const minusBtn = item.querySelector('.quantity-minus[data-gift-bag-id="' + giftBagId + '"]');
          if (quantityInput) {
            quantityInput.value = 0;
            quantityInput.disabled = true;
            if (minusBtn) minusBtn.disabled = true;
          }
        });
        // Toggle ce bouton
        if (this.classList.contains('selected')) {
          this.classList.remove('selected');
        } else {
          this.classList.add('selected');
        }
        updateStep13Validation();
      });
    }

    function resolveContainerTypeFromLabel(label) {
      const titleUpper = (label || '').toUpperCase();
      if (titleUpper.includes('SOLIFLORE')) {
        return 'soliflore';
      }
      if (titleUpper.includes('VASE')) {
        return 'vase';
      }
      if (titleUpper.includes('COUPELLE') || titleUpper.includes('DORÉE') || titleUpper.includes('DOREE')) {
        return 'coupelle';
      }
      return null;
    }

    function normalizeContainerTypeKey(type) {
      if (type === 'pique') {
        return 'coupelle';
      }
      return type;
    }

    function setContainerItemQuantity(item, qty) {
      if (!item) return;
      const containerId = item.getAttribute('data-container-id');
      const quantityInput = item.querySelector('#container-quantity-' + containerId);
      const minusBtn = item.querySelector('.quantity-minus[data-container-id="' + containerId + '"]');
      if (!quantityInput) return;

      const value = Math.max(0, parseInt(qty, 10) || 0);
      quantityInput.value = String(value);
      quantityInput.disabled = value <= 0;
      if (minusBtn) {
        minusBtn.disabled = value <= 0;
      }
      if (value > 0) {
        item.classList.add('selected');
      } else {
        item.classList.remove('selected');
      }
    }

    /** Applique les quantités conseillées aux cartes contenant correspondantes (étape 13). */
    function applyContainersRecommendations(quantities) {
      if (!quantities || !containerItems.length) {
        return;
      }

      const typeQty = {
        soliflore: quantities.soliflores || 0,
        vase: quantities.vase || 0,
        coupelle: quantities.coupelle || 0
      };
      const hasRecommendation = typeQty.soliflore > 0 || typeQty.vase > 0 || typeQty.coupelle > 0;
      if (!hasRecommendation) {
        return;
      }

      if (noContainersOption) {
        noContainersOption.classList.remove('selected');
      }

      const appliedByType = {
        soliflore: false,
        vase: false,
        coupelle: false
      };

      containerItems.forEach(function(item) {
        const typeAttr = normalizeContainerTypeKey(item.getAttribute('data-container-type'));
        const label = item.querySelector('.container-item-label');
        const type = typeAttr || resolveContainerTypeFromLabel(label ? label.textContent.trim() : '');
        if (type && typeQty[type] > 0 && !appliedByType[type]) {
          setContainerItemQuantity(item, typeQty[type]);
          appliedByType[type] = true;
        } else {
          setContainerItemQuantity(item, 0);
        }
      });

      updateStep13Validation();

      const firstSelected = document.querySelector('.container-item.selected');
      if (firstSelected && typeof firstSelected.scrollIntoView === 'function') {
        firstSelected.scrollIntoView({ behavior: 'smooth', block: 'nearest' });
      }
    }

    // Fonction pour calculer les quantités recommandées de contenants
    function calculateContainersQuantities() {
      // Récupérer les réponses des questions 6, 7 et 9
      const question7Data = getQuestion7Data(); // Type de décoration + nombre de tables
      const question9Data = getQuestion9Data(); // Type de table d'honneur
      const question6Data = getQuestion6Data(); // Éléments du vin d'honneur
      
      const results = {
        decorationType: question7Data.type || null, // 'soliflore', 'vase', 'coupelle'
        decorationTitle: question7Data.title || null,
        tablesCount: question7Data.tablesCount || 0,
        soliflores: 0,
        coupelle: 0,
        vase: 0,
        hasTableHonneur: question9Data.hasTableHonneur || false,
        hasTableTraiteurs: question6Data.hasTableTraiteurs || false,
        hasMangeDebout: question6Data.hasMangeDebout || false
      };
      
      // Question 7 : base pour les tables des invités.
      const tablesCount = results.tablesCount;
      
      if (results.decorationType === 'soliflore') {
        results.soliflores = tablesCount; // 1 pack par table
      } else if (results.decorationType === 'vase') {
        results.vase = tablesCount; // 1 vase par table
      } else if (results.decorationType === 'coupelle') {
        results.coupelle = tablesCount; // 1 coupelle dorée par table
      }
      
      // Question 9 : ajouts selon le choix propre de la table d'honneur.
      if (results.hasTableHonneur && question9Data.containerType) {
        if (question9Data.containerType === 'soliflore') {
          results.soliflores += 3; // +3 packs soliflores
        } else if (question9Data.containerType === 'vase') {
          results.vase += 2; // +2 vases
        } else if (question9Data.containerType === 'coupelle') {
          results.coupelle += question9Data.containerQuantity || 2; // +2 coupelles dorées ou +1 grosse coupelle dorée
        }
      }
      
      // Question 6 : ajouts pour vin d'honneur.
      if (results.hasTableTraiteurs) {
        results.soliflores += 2; // +2 packs de soliflores
      }
      if (results.hasMangeDebout) {
        results.soliflores += 4; // +4 packs de soliflores
      }
      
      return results;
    }

    // Fonctions helper pour récupérer les réponses détaillées
    function getQuestion6Data() {
      // Question 6 : Éléments du vin d'honneur
      const selectedElements = document.querySelectorAll('.element-item.selected');
      let hasTableTraiteurs = false;
      let hasMangeDebout = false;
      
      selectedElements.forEach(element => {
        const title = element.querySelector('.element-item-label')?.textContent?.trim() || '';
        const titleUpper = title.toUpperCase();
        
        // Vérifier si c'est la table des traiteurs (variantes : TRAITEUR, TRAITEURS, TABLE DU TRAITEUR, TABLE DES TRAITEURS)
        if (titleUpper.includes('TRAITEUR')) {
          hasTableTraiteurs = true;
        }
        // Vérifier si c'est mange-debout (variantes : MANGE, DEBOUT, TABLES HAUTES, MANGE DEBOUT, VIN D'HONNEUR)
        if (titleUpper.includes('MANGE') || titleUpper.includes('DEBOUT') || 
            titleUpper.includes('TABLES HAUTES') || 
            (titleUpper.includes('VIN') && titleUpper.includes('HONNEUR') && !titleUpper.includes('TRAITEUR'))) {
          hasMangeDebout = true;
        }
      });
      
      return {
        hasTableTraiteurs: hasTableTraiteurs,
        hasMangeDebout: hasMangeDebout,
        selectedElements: Array.from(selectedElements).map(el => ({
          title: el.querySelector('.element-item-label')?.textContent?.trim() || ''
        }))
      };
    }

    function getQuestion7Data() {
      // Question 7 : Type de décoration + nombre de tables
      const selectedDecoration = document.querySelector('.decoration-item.selected');
      const tablesInput = document.getElementById('tables-quantity');
      const tablesCount = parseInt(tablesInput?.value) || 0;
      
      let decorationType = null;
      let decorationTitle = null;
      
      if (selectedDecoration) {
        decorationTitle = selectedDecoration.getAttribute('data-decoration-title') || 
                         selectedDecoration.querySelector('.decoration-item-label')?.textContent?.trim() || '';
        const titleUpper = decorationTitle.toUpperCase();
        
        // Déterminer le type de décoration
        if (titleUpper.includes('SOLIFLORE')) {
          decorationType = 'soliflore';
        } else if (titleUpper.includes('VASE') || titleUpper.includes('VASES')) {
          decorationType = 'vase';
        } else if (
          titleUpper.includes('COUPELLE') ||
          titleUpper.includes('DORÉE') ||
          titleUpper.includes('DOREE')
        ) {
          decorationType = 'coupelle';
        }
      }
      
      return {
        type: decorationType,
        title: decorationTitle,
        tablesCount: tablesCount
      };
    }

    function getQuestion9Data() {
      // Question 9 : Table d'honneur
      // Vérifier si l'utilisateur a sélectionné une option (fresh ou artificial) et non "no"
      const selectedOption = document.querySelector('.questionnaire-table-honneur-options .table-honneur-option.selected');
      const noOption = document.querySelector('.no-table-honneur-btn.selected');
      const hasTableHonneur = selectedOption && !noOption;
      let containerType = null;
      let suboptionTitle = '';

      const selectedFreshSuboption = document.querySelector('.table-honneur-suboption.selected');
      let containerQuantity = 0;
      if (selectedFreshSuboption) {
        const suboptionKey = selectedFreshSuboption.getAttribute('data-suboption') || '';
        const titleEl = selectedFreshSuboption.querySelector('.table-honneur-title');
        suboptionTitle = titleEl ? titleEl.textContent.trim() : '';
        const titleUpper = suboptionTitle.toUpperCase();

        if (suboptionKey.includes('soliflore') || titleUpper.includes('SOLIFLORE')) {
          containerType = 'soliflore';
          containerQuantity = 3;
        } else if (suboptionKey.includes('vase') || titleUpper.includes('VASE')) {
          containerType = 'vase';
          containerQuantity = 2;
        } else if (
          suboptionKey.includes('pique') ||
          suboptionKey.includes('composition') ||
          titleUpper.includes('COUPELLE') ||
          titleUpper.includes('DORÉE') ||
          titleUpper.includes('DOREE') ||
          titleUpper.includes('PIQU')
        ) {
          containerType = 'coupelle';
          containerQuantity = suboptionKey.includes('grosse') || titleUpper.includes('GROSSE') ? 1 : 2;
        }
      }
      
      return {
        hasTableHonneur: hasTableHonneur,
        containerType: containerType,
        containerQuantity: containerQuantity,
        suboptionTitle: suboptionTitle
      };
    }

    // Gestion de l'ouverture de la modal de calcul
    if (containersCalculLink) {
      containersCalculLink.addEventListener('click', function(e) {
        e.preventDefault();
        const quantities = calculateContainersQuantities();
        
        // Générer le contenu HTML de la modal selon le format de la capture
        let html = '';
        
        // Titre (déjà dans le HTML, mais on peut le mettre à jour si nécessaire)
        
        // Section "Vous avez choisi"
        html += '<div class="containers-calcul-section">';
        html += '<div class="containers-calcul-section-label">Vous avez choisi</div>';
        if (quantities.decorationTitle) {
          html += '<div class="containers-calcul-choice decoration-title">' + quantities.decorationTitle.toUpperCase() + '</div>';
        }
        if (quantities.tablesCount > 0) {
          html += '<div class="containers-calcul-choice tables-count">' + quantities.tablesCount + ' TABLES DES INVITÉS</div>';
        }
        html += '</div>';
        
        // Section "Vous nous avez indiqué"
        const indicatedItems = [];
        if (quantities.hasTableHonneur) {
          indicatedItems.push('TABLE D\'HONNEUR');
        }
        if (quantities.hasTableTraiteurs) {
          indicatedItems.push('TABLE DES TRAITEURS');
        }
        if (quantities.hasMangeDebout) {
          indicatedItems.push('MANGE DEBOUT (VIN D\'HONNEUR)');
        }
        
        if (indicatedItems.length > 0) {
          html += '<div class="containers-calcul-section">';
          html += '<div class="containers-calcul-indicated-box">';
          html += '<div class="containers-calcul-section-label">Vous nous avez indiqué :</div>';
          indicatedItems.forEach((item, index) => {
            const isActive = item !== 'MANGE DEBOUT (VIN D\'HONNEUR)';
            html += '<div class="containers-calcul-indicated-item' + (isActive ? ' active' : ' inactive') + '">' + item + '</div>';
          });
          html += '</div>';
          html += '</div>';
        }
        
        // Section "Nous vous conseillons"
        const recommendations = [];
        if (quantities.vase > 0) {
          recommendations.push({
            text: quantities.vase + ' VASES',
            type: 'vase'
          });
        }
        if (quantities.soliflores > 0) {
          recommendations.push({
            text: quantities.soliflores + ' PACK SOLIFLORES',
            type: 'soliflore'
          });
        }
        if (quantities.coupelle > 0) {
          const coupelleLabel = quantities.coupelle > 1 ? 'COUPELLES DORÉES' : 'COUPELLE DORÉE';
          recommendations.push({
            text: quantities.coupelle + ' ' + coupelleLabel,
            type: 'coupelle'
          });
        }
        
        if (recommendations.length > 0) {
          html += '<div class="containers-calcul-section">';
          html += '<div class="containers-calcul-section-label">Nous vous conseillons :</div>';
          html += '<div class="containers-calcul-recommendation-box">';
          recommendations.forEach((rec, index) => {
            if (index > 0) {
              html += '<div class="containers-calcul-recommendation-connector">ET</div>';
            }
            html += '<div class="containers-calcul-recommendation-item">' + rec.text + '</div>';
          });
          html += '</div>';
          html += '</div>';
        }
        
        if (containersCalculResults) {
          containersCalculResults.innerHTML = html;
        }

        applyContainersRecommendations(quantities);
        
        if (containersCalculModal) {
          containersCalculModal.classList.add('active');
          document.body.style.overflow = 'hidden';
        }
      });
    }

    // Gestion de la fermeture de la modal de calcul
    if (containersCalculModalClose) {
      containersCalculModalClose.addEventListener('click', function(e) {
        e.preventDefault();
        if (containersCalculModal) {
          containersCalculModal.classList.remove('active');
          document.body.style.overflow = '';
        }
      });
    }

    // Fermeture de la modal au clic sur l'overlay
    if (containersCalculModal) {
      const overlay = containersCalculModal.querySelector('.modal-overlay');
      if (overlay) {
        overlay.addEventListener('click', function() {
          containersCalculModal.classList.remove('active');
          document.body.style.overflow = '';
        });
      }
    }

    // Initialiser l'état
    updateStep13Validation();

    /* ============================================
       ÉTAPE 15 - MATÉRIELS (NOUVEAU DESIGN)
       ============================================ */
    
    // Toggle "VOIR PLUS" pour afficher/masquer les matériels supplémentaires
    const materialsSeeMoreLink = document.getElementById('materials-see-more');
    if (materialsSeeMoreLink) {
      materialsSeeMoreLink.addEventListener('click', function(e) {
        e.preventDefault();
        const materialsGrid = document.getElementById('materials-grid');
        if (materialsGrid) {
          const isExpanded = materialsGrid.classList.contains('show-all');
          if (isExpanded) {
            materialsGrid.classList.remove('show-all');
            this.textContent = 'VOIR PLUS';
          } else {
            materialsGrid.classList.add('show-all');
            this.textContent = 'VOIR MOINS';
          }
        }
      });
    }

    // Gestion des modals d'aide pour les matériels
    document.querySelectorAll('.material-help-btn').forEach(btn => {
      btn.addEventListener('click', function(e) {
        e.preventDefault();
        e.stopPropagation();
        const materialHelpId = this.getAttribute('data-material-help');
        if (materialHelpId) {
          const modal = document.getElementById('material-help-modal-' + materialHelpId);
          if (modal) {
            modal.classList.add('active');
            document.body.style.overflow = 'hidden';
          }
        }
      });
    });

    // Fermeture des modals d'aide pour les matériels
    document.querySelectorAll('[data-close-modal]').forEach(closeBtn => {
      closeBtn.addEventListener('click', function(e) {
        e.preventDefault();
        e.stopPropagation();
        const modalId = this.getAttribute('data-close-modal');
        if (modalId) {
          const modal = document.getElementById(modalId);
          if (modal) {
            modal.classList.remove('active');
            document.body.style.overflow = '';
          }
        }
      });
    });

    // Fermeture des modals au clic sur l'overlay
    document.querySelectorAll('.material-help-modal .modal-overlay').forEach(overlay => {
      overlay.addEventListener('click', function(e) {
        e.preventDefault();
        e.stopPropagation();
        const modal = this.closest('.material-help-modal');
        if (modal) {
          modal.classList.remove('active');
          document.body.style.overflow = '';
        }
      });
    });

    // Fermeture des modals avec la touche Escape
    document.addEventListener('keydown', function(e) {
      if (e.key === 'Escape') {
        document.querySelectorAll('.material-help-modal.active').forEach(modal => {
          modal.classList.remove('active');
          document.body.style.overflow = '';
        });
      }
    });

    // Gestion de la sélection + quantité des matériels
    document.querySelectorAll('.material-item').forEach(item => {
      const materialId = item.getAttribute('data-material-id');
      const quantityInput = item.querySelector(`#material-quantity-${materialId}`);
      const minusBtn = item.querySelector(`.quantity-minus[data-material-id="${materialId}"]`);
      const plusBtn = item.querySelector(`.quantity-plus[data-material-id="${materialId}"]`);

      function updateMaterialQuantityState() {
        if (!quantityInput || !minusBtn) return;
        const currentValue = parseInt(quantityInput.value, 10) || 0;
        minusBtn.disabled = currentValue <= 0;
        quantityInput.disabled = currentValue <= 0;

        if (currentValue > 0) {
          item.classList.add('selected');
          const noMaterialsBtn = document.getElementById('no-materials-btn');
          if (noMaterialsBtn && noMaterialsBtn.classList.contains('selected')) {
            noMaterialsBtn.classList.remove('selected');
          }
        } else {
          item.classList.remove('selected');
        }
      }

      item.addEventListener('click', function(e) {
        // Ne pas sélectionner si on clique sur les éléments interactifs
        if (
          e.target.closest('.material-help-btn') ||
          e.target.closest('.image-zoom-btn') ||
          e.target.closest('.quantity-btn') ||
          e.target.closest('.quantity-input')
        ) {
          return;
        }

        if (!quantityInput) return;
        const currentValue = parseInt(quantityInput.value, 10) || 0;
        quantityInput.value = currentValue > 0 ? 0 : 1;
        updateMaterialQuantityState();
        updateStep15MaterialsValidation();
      });

      if (minusBtn && quantityInput) {
        minusBtn.addEventListener('click', function(e) {
          e.preventDefault();
          e.stopPropagation();

          const currentValue = parseInt(quantityInput.value, 10) || 0;
          if (currentValue > 0) {
            quantityInput.value = currentValue - 1;
            updateMaterialQuantityState();
            updateStep15MaterialsValidation();
          }
        });
      }

      if (plusBtn && quantityInput) {
        plusBtn.addEventListener('click', function(e) {
          e.preventDefault();
          e.stopPropagation();

          const currentValue = parseInt(quantityInput.value, 10) || 0;
          quantityInput.value = currentValue + 1;
          updateMaterialQuantityState();
          updateStep15MaterialsValidation();
        });
      }

      updateMaterialQuantityState();
    });

    function normalizeRecommendationText(value) {
      return String(value || '')
        .toLowerCase()
        .normalize('NFD')
        .replace(/[\u0300-\u036f]/g, '')
        .replace(/[^a-z0-9]+/g, ' ')
        .trim();
    }

    function getMaterialCardByKeywords(includesKeywords, excludesKeywords) {
      const cards = document.querySelectorAll('.material-item');
      const includes = includesKeywords || [];
      const excludes = excludesKeywords || [];

      return Array.from(cards).find(card => {
        const titleEl = card.querySelector('.material-item-title');
        const title = normalizeRecommendationText(titleEl ? titleEl.textContent : '');
        if (!title) return false;

        const hasIncludes = includes.every(keyword => title.includes(normalizeRecommendationText(keyword)));
        const hasExcludes = excludes.some(keyword => title.includes(normalizeRecommendationText(keyword)));
        return hasIncludes && !hasExcludes;
      }) || null;
    }

    function setMaterialQuantity(card, quantity) {
      if (!card) return;
      const materialId = card.getAttribute('data-material-id');
      if (!materialId) return;

      const quantityInput = card.querySelector(`#material-quantity-${materialId}`);
      const minusBtn = card.querySelector(`.quantity-minus[data-material-id="${materialId}"]`);
      if (!quantityInput) return;

      const safeQuantity = Math.max(0, parseInt(quantity, 10) || 0);
      quantityInput.value = safeQuantity;
      quantityInput.disabled = safeQuantity <= 0;
      if (minusBtn) {
        minusBtn.disabled = safeQuantity <= 0;
      }
      card.classList.toggle('selected', safeQuantity > 0);
    }

    function applyAutoMaterialsRecommendation() {
      const participants = Math.max(0, parseInt((workshopParticipantsInput && workshopParticipantsInput.value) || '0', 10) || 0);
      const recommendedPackQty = Math.max(1, Math.ceil(participants / 3));
      const recommendedRubansQty = 2;

      let recommendedMousseQty = 0;
      let recommendedMousseSupportQty = 0;

      // Étape 6 - Vin d'honneur : Tableau de bienvenue => +1 mousse
      const hasTableauBienvenue = Array.from(document.querySelectorAll('.element-item.selected')).some(item => {
        const title = normalizeRecommendationText(item.querySelector('.element-item-label')?.textContent || '');
        return title.includes('tableau') && title.includes('bienvenue');
      });
      if (hasTableauBienvenue) {
        recommendedMousseQty += 1;
      }

      // Étape 7 - Centre de table coupelle dorée => +1 mousse × nb tables
      const selectedDecorationEl = document.querySelector('.decoration-item.selected');
      const selectedDecorationTitle = normalizeRecommendationText(
        (selectedDecorationEl && selectedDecorationEl.getAttribute('data-decoration-title')) ||
        selectedDecorationEl?.querySelector('.decoration-item-label')?.textContent ||
        ''
      );
      const hasPiqueCenterpiece =
        selectedDecorationTitle.includes('pique') ||
        selectedDecorationTitle.includes('coupelle') ||
        selectedDecorationTitle.includes('doree') ||
        selectedDecorationTitle.includes('dorée');
      if (hasPiqueCenterpiece) {
        recommendedMousseQty += Math.max(0, parseInt(tablesQuantity, 10) || 0);
      }

      // Étape 9 - Table d'honneur
      if (tableHonneurChoice === 'fresh' && tableHonneurFreshSuboption === 'compositions-piquee') {
        recommendedMousseQty += 2;
      }
      if (tableHonneurChoice === 'fresh' && tableHonneurFreshSuboption === 'grosse-composition') {
        recommendedMousseSupportQty += 2;
      }

      // Étape 10 - Arche fleurie => +4 mousse si arche sélectionnée
      if (archeChoice === 'fresh' || archeChoice === 'artificial') {
        recommendedMousseQty += 4;
      }

      const packCard = getMaterialCardByKeywords(['essentiel', 'fleuriste']);
      const rubansCard = getMaterialCardByKeywords(['ruban', 'satin']);
      const mousseSupportCard = getMaterialCardByKeywords(['mousse', 'support']);
      const mousseCard = getMaterialCardByKeywords(['mousse'], ['support']);

      setMaterialQuantity(packCard, recommendedPackQty);
      setMaterialQuantity(rubansCard, recommendedRubansQty);
      setMaterialQuantity(mousseCard, recommendedMousseQty);
      setMaterialQuantity(mousseSupportCard, recommendedMousseSupportQty);

      const noMaterialsBtn = document.getElementById('no-materials-btn');
      const hasAnyRecommendedQty = [recommendedPackQty, recommendedRubansQty, recommendedMousseQty, recommendedMousseSupportQty].some(qty => qty > 0);
      if (noMaterialsBtn && hasAnyRecommendedQty) {
        noMaterialsBtn.classList.remove('selected');
      }

      updateStep15MaterialsValidation();
    }

    // Fonction de validation pour l'étape 15 (matériels) - Nouveau design
    function updateStep15MaterialsValidation() {
      const validateMaterialsBtn = DOMCache.validateStep15 || document.getElementById('validate-step-15');
      if (!validateMaterialsBtn) return;

      // Vérifier les nouveaux matériels (.material-item) et l'ancien système (.step13-material-option)
      const selectedNewMaterials = document.querySelectorAll('.material-item .quantity-input[data-material-id]');
      const hasSelectedNewMaterials = Array.from(selectedNewMaterials).some(input => (parseInt(input.value, 10) || 0) > 0);
      const selectedOldMaterials = document.querySelectorAll('.step13-material-option.selected');
      const noMaterialsBtn = document.getElementById('no-materials-btn');
      const noMaterialsSelected = noMaterialsBtn && noMaterialsBtn.classList.contains('selected');

      if (hasSelectedNewMaterials || selectedOldMaterials.length > 0 || noMaterialsSelected) {
        validateMaterialsBtn.disabled = false;
      } else {
        validateMaterialsBtn.disabled = true;
      }
    }

    // Gestion du bouton "Je n'ai pas besoin de matériels" - Compatible avec nouveau et ancien design
    const noMaterialsBtnNew = document.getElementById('no-materials-btn');
    if (noMaterialsBtnNew) {
      // Supprimer l'ancien gestionnaire d'événement s'il existe
      const oldHandler = noMaterialsBtnNew.getAttribute('data-old-handler');
      if (!oldHandler) {
        // Marquer pour éviter les conflits avec l'ancien code
        noMaterialsBtnNew.setAttribute('data-old-handler', 'removed');
      }
      
      // Ajouter le nouveau gestionnaire (remplace l'ancien)
      noMaterialsBtnNew.addEventListener('click', function(e) {
        e.stopPropagation();
        
        // Désélectionner tous les matériels (nouveau et ancien design)
        document.querySelectorAll('.material-item.selected').forEach(item => {
          item.classList.remove('selected');
        });
        document.querySelectorAll('.material-item .quantity-input[data-material-id]').forEach(input => {
          input.value = 0;
          input.disabled = true;
        });
        document.querySelectorAll('.material-item .quantity-minus[data-material-id]').forEach(btn => {
          btn.disabled = true;
        });
        document.querySelectorAll('.step13-material-option.selected').forEach(item => {
          item.classList.remove('selected');
        });
        
        // Toggle sélection du bouton "Je n'ai pas besoin"
        this.classList.toggle('selected');
        
        // Mettre à jour la validation
        updateStep15MaterialsValidation();
      }, true); // Utiliser capture phase pour être sûr que ça s'exécute
    }

    // Initialiser l'état de validation de l'étape 15 (matériels)
    updateStep15MaterialsValidation();

    /* ============================================
       ÉTAPE 17 - CRÉATION DE COMPTE
       ============================================ */
    // Toggle afficher/masquer mot de passe
    document.querySelectorAll('.password-toggle-btn').forEach(btn => {
      btn.addEventListener('click', function() {
        const targetId = this.getAttribute('data-target');
        const passwordInput = document.getElementById(targetId);
        const eyeIcon = this.querySelector('.password-eye-icon');
        const eyeOffIcon = this.querySelector('.password-eye-off-icon');
        
        if (passwordInput) {
          if (passwordInput.type === 'password') {
            passwordInput.type = 'text';
            if (eyeIcon) eyeIcon.style.display = 'none';
            if (eyeOffIcon) eyeOffIcon.style.display = 'block';
            this.setAttribute('aria-label', 'Masquer le mot de passe');
          } else {
            passwordInput.type = 'password';
            if (eyeIcon) eyeIcon.style.display = 'block';
            if (eyeOffIcon) eyeOffIcon.style.display = 'none';
            this.setAttribute('aria-label', 'Afficher le mot de passe');
          }
        }
      });
    });

    // Le formulaire se soumet normalement, Shopify redirige vers return_to
    // La détection du paramètre account_created est dans DOMContentLoaded

    /* ============================================
       ÉTAPE 18 - RÉSUMÉ FINAL
       ============================================ */
    const FRESH_COLLAPSED_COUNT = 2;
    const SUPP_COLLAPSED_COUNT = 2;
    const SNAPSHOT_STORAGE_KEY = 'floreasy_questionnaire_snapshot_v2';
  /* SVG placeholder en base64 (évite les " dans data:… qui cassent src="…") */
    const PLACEHOLDER_IMG =
      'data:image/svg+xml;base64,PHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHZpZXdCb3g9IjAgMCA2MCA2MCI+PHJlY3Qgd2lkdGg9IjYwIiBoZWlnaHQ9IjYwIiBmaWxsPSIjZjBlOWQ2Ii8+PHBhdGggZD0iTTMwIDE4YTggOCAwIDEwMCAxNiA4IDggMCAwMDAtMTZ6bS0xMiAyOGExMiAxMiAwIDAgMSAyNCAweiIgZmlsbD0iIzhCMTUzOCIgb3BhY2l0eT0iLjM1Ii8+PC9zdmc+';

    function escapeHtmlAttr(value) {
      return String(value || '')
        .replace(/&/g, '&amp;')
        .replace(/"/g, '&quot;')
        .replace(/</g, '&lt;')
        .replace(/>/g, '&gt;');
    }

    function getSummaryImageFromEl(root) {
      if (!root) {
        return '';
      }
      const img = root.querySelector(
        '.table-honneur-image img, .accessory-item-image img, .container-item-image img, .yes-no-image img, .bouquet-item-image img, .element-item-image img, .decoration-item-image img, img'
      );
      if (img) {
        const fromImg = (
          img.getAttribute('src') ||
          img.getAttribute('data-fallback-src') ||
          img.getAttribute('data-lightbox-src') ||
          ''
        ).trim();
        if (fromImg && fromImg.indexOf('data:') !== 0) {
          return fromImg;
        }
      }
      const thumbPipe = root.getAttribute('data-step11-images-thumb') ||
        root.getAttribute('data-step10-images-thumb') ||
        root.getAttribute('data-product-images-thumb') ||
        '';
      const firstThumb = thumbPipe ? thumbPipe.split('|||')[0].trim() : '';
      return (
        root.getAttribute('data-q-thumb') ||
        firstThumb ||
        root.getAttribute('data-q-full') ||
        ''
      ).trim();
    }

    /* ----------- Persistence (snapshot) ----------- */
    function captureSummarySnapshot() {
      try {
        return {
          customerFirstName: (document.getElementById('RegisterForm-FirstName') || {}).value || '',
          customerLastName:  (document.getElementById('RegisterForm-LastName')  || {}).value || '',
          email:             (document.getElementById('RegisterForm-email')     || {}).value || '',
          weddingDate:       (document.getElementById('wedding-date') || document.getElementById('RegisterForm-WeddingDate') || {}).value || '',
          postalCode:        (document.getElementById('RegisterForm-PostalCode') || {}).value || '',
          participants:      (workshopParticipantsInput || {}).value || '0',
          totalMinutes:      computeTotalTimeMinutes(),
          freshItems:        getFreshItems(),
          supplements:       getSupplementsItems(),
          pack:              getRecommendedPackInfo(),
          savedAt:           Date.now()
        };
      } catch (e) {
        console.warn('captureSummarySnapshot error:', e);
        return null;
      }
    }

    function saveSummarySnapshot() {
      try {
        const snap = captureSummarySnapshot();
        if (snap) localStorage.setItem(SNAPSHOT_STORAGE_KEY, JSON.stringify(snap));
      } catch (e) {
        // localStorage indisponible / quota — on continue silencieusement
      }
    }

    function loadSummarySnapshot() {
      try {
        const raw = localStorage.getItem(SNAPSHOT_STORAGE_KEY);
        if (!raw) return null;
        const snap = JSON.parse(raw);
        // Snapshot valide ~24h
        if (!snap || !snap.savedAt || (Date.now() - snap.savedAt) > 86400000) {
          localStorage.removeItem(SNAPSHOT_STORAGE_KEY);
          return null;
        }
        return snap;
      } catch (e) {
        return null;
      }
    }

    function clearSummarySnapshot() {
      try { localStorage.removeItem(SNAPSHOT_STORAGE_KEY); } catch (e) {}
    }

    // Exposer pour le hook dans showStep
    window.saveSummarySnapshot = saveSummarySnapshot;

    function getTimeRates() {
      return (window.questionnaireConfig && window.questionnaireConfig.timeRates) || {};
    }

    function formatDuration(totalMinutes) {
      const mins = Math.max(0, Math.round(totalMinutes || 0));
      const h = Math.floor(mins / 60);
      const m = mins % 60;
      if (h > 0 && m > 0) return h + 'h' + String(m).padStart(2, '0') + 'min';
      if (h > 0)          return h + 'h';
      return m + 'min';
    }

    function getSelectedBouquetTitles() {
      const titles = [];
      document.querySelectorAll('.bouquet-item.selected').forEach(el => {
        const label = el.querySelector('.bouquet-item-label');
        if (label) titles.push(label.textContent.trim());
      });
      return titles;
    }

    function getSelectedVinHonneurElements() {
      const els = [];
      document.querySelectorAll('.element-item.selected').forEach(el => {
        const labelEl = el.querySelector('.element-item-label');
        const imgEl = el.querySelector('.element-item-image img');
        const flowers = parseInt(el.getAttribute('data-element-flowers'), 10) || 0;
        els.push({
          title: labelEl ? labelEl.textContent.trim() : '',
          flowers,
          image: imgEl ? imgEl.src : ''
        });
      });
      return els;
    }

    function getSelectedDecorationInfo() {
      const el = document.querySelector('.decoration-item.selected');
      if (!el) return null;
      const titleAttr = el.getAttribute('data-decoration-title') || '';
      const labelEl = el.querySelector('.decoration-item-label');
      const imgEl = el.querySelector('.decoration-item-image img');
      const multiplier = parseInt(el.getAttribute('data-decoration-multiplier'), 10) || 1;
      const normalized = titleAttr.toLowerCase();
      let kind = 'autre';
      if (normalized.includes('soliflore')) kind = 'soliflore';
      else if (normalized.includes('vase')) kind = 'vase';
      else if (normalized.includes('piqu') || normalized.includes('coupelle') || normalized.includes('dorée') || normalized.includes('doree'))  kind = 'pique';
      return {
        kind,
        title: titleAttr || (labelEl ? labelEl.textContent.trim() : ''),
        multiplier,
        image: imgEl ? imgEl.src : ''
      };
    }

    function parsePriceFromText(text) {
      const match = String(text || '').match(/(\d+(?:[.,]\d+)?)/);
      return match ? parseFloat(match[1].replace(',', '.')) : 0;
    }

    function getExtraBundles() {
      // Étape 16 - bottes de fleurs supplémentaires (fleurs fraîches en supplément)
      const bundles = [];
      document.querySelectorAll('.flowers-variety-item').forEach(card => {
        const qtyEl = card.querySelector('.flower-variety-bundles-value');
        const qty = parseInt(qtyEl && qtyEl.textContent, 10) || 0;
        if (qty <= 0) return;
        const nameEl = card.querySelector('.flower-variety-name, .flowers-variety-name, .variety-name');
        const imgEl = card.querySelector('img');
        bundles.push({
          title: nameEl ? nameEl.textContent.trim() : 'Botte de fleurs',
          quantity: qty,
          image: imgEl ? imgEl.src : ''
        });
      });
      return bundles;
    }

    function getExtraBundlesForSupplements() {
      const items = [];
      document.querySelectorAll('.flowers-variety-item').forEach(card => {
        const qtyEl = card.querySelector('.flower-variety-bundles-value');
        const qty = parseInt(qtyEl && qtyEl.textContent, 10) || 0;
        if (qty <= 0) return;
        const nameEl = card.querySelector('.flower-variety-name');
        const priceEl = card.querySelector('.flower-variety-price');
        const imgEl = card.querySelector('img');
        items.push({
          title: ('BOTTE ' + (nameEl ? nameEl.textContent.trim() : 'FLEURS')).toUpperCase(),
          quantity: qty,
          unitPrice: parsePriceFromText(priceEl ? priceEl.textContent : ''),
          image: imgEl ? imgEl.src : ''
        });
      });
      return items;
    }

    function getAccessoriesItems() {
      // Étape 12 - accessoires fleuris stabilisés
      const items = [];
      document.querySelectorAll('.step12-accessories-option.selected').forEach(el => {
        const accessoryId = el.getAttribute('data-accessory-id');
        const qtyInput = el.querySelector('#accessory-quantity-' + accessoryId)
          || el.querySelector('.quantity-input[data-accessory-id="' + accessoryId + '"]');
        const qty = parseInt(qtyInput && qtyInput.value, 10) || 0;
        if (qty <= 0) return;

        const labelEl = el.querySelector('.table-honneur-title');
        const imgEl = el.querySelector('img');
        const priceEl = el.querySelector('.accessories-price');
        let unitPrice = parsePriceFromText(priceEl ? priceEl.textContent : '');
        if (!unitPrice) {
          const colorSelect = el.querySelector('.accessories-color-select');
          if (colorSelect && colorSelect.selectedOptions.length) {
            unitPrice = parseFloat(colorSelect.selectedOptions[0].getAttribute('data-price')) || 0;
          }
        }
        if (!unitPrice) {
          unitPrice = parseFloat(el.getAttribute('data-accessory-first-price')) || 0;
        }

        items.push({
          title: labelEl ? labelEl.textContent.trim() : 'Accessoire',
          quantity: qty,
          unitPrice: unitPrice,
          image: imgEl ? imgEl.src : ''
        });
      });
      return items;
    }

    function getContainersItems() {
      const items = [];
      document.querySelectorAll('.container-item').forEach(el => {
        const containerId = el.getAttribute('data-container-id');
        const qtyInput = el.querySelector('#container-quantity-' + containerId);
        const qty = parseInt(qtyInput && qtyInput.value, 10) || 0;
        if (qty <= 0) return;

        const labelEl = el.querySelector('.container-item-label');
        const imgEl = el.querySelector('img');
        const unitPrice = parseFloat(el.getAttribute('data-container-price')) || 0;
        items.push({
          title: labelEl ? labelEl.textContent.trim() : 'Contenant',
          quantity: qty,
          unitPrice: unitPrice,
          image: imgEl ? imgEl.src : ''
        });
      });
      return items;
    }

    function getGiftBagItems() {
      const items = [];
      document.querySelectorAll('.gift-bag-item').forEach(el => {
        const bagId = el.getAttribute('data-gift-bag-id');
        const qtyInput = el.querySelector('#gift-bag-quantity-' + bagId);
        const qty = parseInt(qtyInput && qtyInput.value, 10) || 0;
        if (qty <= 0) return;

        const labelEl = el.querySelector('.gift-bag-item-label');
        const imgEl = el.querySelector('img');
        const unitPrice = parseFloat(el.getAttribute('data-gift-bag-price')) || 0;
        items.push({
          title: labelEl ? labelEl.textContent.trim() : 'Sac cadeau',
          quantity: qty,
          unitPrice: unitPrice,
          image: imgEl ? imgEl.src : ''
        });
      });
      return items;
    }

    function getMaterialsItems() {
      // Étape 15 - matériels d'atelier
      const items = [];
      document.querySelectorAll('.material-item').forEach(card => {
        const qInput = card.querySelector('.quantity-input[data-material-id]');
        if (!qInput) return;
        const qty = parseInt(qInput.value, 10) || 0;
        if (qty <= 0) return;
        const nameEl = card.querySelector('.material-item-title, .material-item-name, .material-name');
        const priceAttr = card.getAttribute('data-material-price') || card.getAttribute('data-price') || '0';
        const price = parseFloat(String(priceAttr).replace(',', '.')) || 0;
        const imgEl = card.querySelector('img');
        items.push({
          title: nameEl ? nameEl.textContent.trim() : 'Matériel',
          quantity: qty,
          unitPrice: price,
          image: imgEl ? imgEl.src : ''
        });
      });
      return items;
    }

    /* ----------- Calcul du temps total ----------- */
    function computeTotalTimeMinutes() {
      const R = getTimeRates();
      let total = 0;

      // Étape 4 - Bouquets
      const bouquetTitles = getSelectedBouquetTitles().map(t => t.toLowerCase());
      if (bouquetTitles.some(t => t.includes('mari'))) total += R.bouquetMariee || 0;
      if (bouquetTitles.some(t => t.includes('lancer'))) total += R.bouquetLancer || 0;

      // Étape 5 - Demoiselles d'honneur
      if (typeof demoisellesChoice !== 'undefined' && demoisellesChoice === 'yes') {
        total += (demoisellesQuantity || 0) * (R.bouquetDemoiselle || 0);
      }

      // Étape 6 - Vin d'honneur
      getSelectedVinHonneurElements().forEach(el => {
        const t = el.title.toLowerCase();
        if (t.includes('traiteur'))   total += R.tableTraiteur    || 0;
        if (t.includes('bienvenue'))  total += R.tableauBienvenue || 0;
        if (t.includes('haute'))      total += R.tableHaute       || 0;
      });

      // Étape 7 - Centres de table
      const deco = getSelectedDecorationInfo();
      const nbTables = (typeof tablesQuantity !== 'undefined') ? (parseInt(tablesQuantity, 10) || 0) : 0;
      if (deco && nbTables > 0) {
        if (deco.kind === 'soliflore') {
          const nbSoliflores = nbTables * (deco.multiplier || 6);
          total += Math.ceil(nbSoliflores / 3) * (R.soliflore || 0);
        } else if (deco.kind === 'vase') {
          total += nbTables * (R.vase || 0);
        } else if (deco.kind === 'pique') {
          total += nbTables * (R.pique || 0);
        }
      }

      // Étape 9 - Table d'honneur (uniquement fresh)
      if (typeof tableHonneurChoice !== 'undefined' && tableHonneurChoice === 'fresh') {
        total += R.tableHonneur || 0;
      }

      // Étape 10 - Arche (uniquement fresh)
      if (typeof archeChoice !== 'undefined' && archeChoice === 'fresh') {
        total += R.arche || 0;
      }

      // Étape 11 - Bouquets de chaise (uniquement fresh)
      if (typeof chairChoice !== 'undefined' && chairChoice === 'fresh') {
        const nbChairs = (typeof chairQuantity !== 'undefined') ? (parseInt(chairQuantity, 10) || 0) : 0;
        total += nbChairs * (R.chaise || 0);
      }

      return total;
    }

    function computeCreationDurationMinutes() {
      const totalMins = computeTotalTimeMinutes();
      const participantsRaw = (workshopParticipantsInput && workshopParticipantsInput.value) || '0';
      const participants = Math.max(1, parseInt(participantsRaw, 10) || 1);
      return Math.round(totalMins / participants);
    }

    /* ----------- Items "fleurs fraîches" (Pour rappel) ----------- */
    function getFreshItems() {
      const items = [];

      // Étape 4 - bouquets sélectionnés
      document.querySelectorAll('.bouquet-item.selected').forEach(el => {
        const label = el.querySelector('.bouquet-item-label');
        const flowers = parseInt(el.getAttribute('data-bouquet-flowers'), 10) || 0;
        items.push({
          title: label ? label.textContent.trim() : 'BOUQUET',
          flowers,
          image: getSummaryImageFromEl(el)
        });
      });

      // Étape 5 - demoiselles d'honneur
      if (typeof demoisellesChoice !== 'undefined' && demoisellesChoice === 'yes' && demoisellesQuantity > 0) {
        items.push({
          title: 'BOUQUETS DEMOISELLES D\'HONNEUR (×' + demoisellesQuantity + ')',
          flowers: 10 * demoisellesQuantity,
          image: getSummaryImageFromEl(document.getElementById('yes-option'))
        });
      }

      // Étape 6 - vin d'honneur (toujours fresh)
      getSelectedVinHonneurElements().forEach(el => {
        items.push({ title: el.title.toUpperCase(), flowers: el.flowers, image: el.image });
      });

      // Étape 7 - centre de table (DIY uniquement)
      const deco = getSelectedDecorationInfo();
      const nbTables = (typeof tablesQuantity !== 'undefined') ? (parseInt(tablesQuantity, 10) || 0) : 0;
      if (deco && nbTables > 0) {
        const labelMap = { soliflore: 'CENTRE DE TABLE SOLIFLORES', vase: 'CENTRE DE TABLE VASES', pique: 'CENTRES COUPELLES DORÉES' };
        items.push({
          title: labelMap[deco.kind] || ('CENTRE DE TABLE ' + (deco.title || '').toUpperCase()),
          flowers: nbTables * (deco.multiplier || 0),
          image: deco.image
        });
      }

      // Étape 9 - table d'honneur fresh uniquement
      if (typeof tableHonneurChoice !== 'undefined' && tableHonneurChoice === 'fresh') {
        const thFreshImg = getSummaryImageFromEl(document.getElementById('table-honneur-fresh'));
        items.push({ title: 'COMPOSITION TABLE D\'HONNEUR', flowers: 25, image: thFreshImg });
      }

      // Étape 10 - arche fresh uniquement
      if (typeof archeChoice !== 'undefined' && archeChoice === 'fresh') {
        items.push({
          title: 'ARCHE FLEURIE',
          flowers: (typeof archeFlowers !== 'undefined' ? archeFlowers : 0) || 50,
          image: getSummaryImageFromEl(document.getElementById('arche-fresh'))
        });
      }

      // Étape 11 - chaises fresh uniquement
      if (typeof chairChoice !== 'undefined' && chairChoice === 'fresh') {
        const nbChairs = (typeof chairQuantity !== 'undefined') ? (parseInt(chairQuantity, 10) || 0) : 0;
        if (nbChairs > 0) {
          const chairFreshImg = getSummaryImageFromEl(document.getElementById('step11-fresh-option'));
          items.push({
            title: 'BOUQUETS DE CHAISE (×' + nbChairs + ')',
            flowers: 5 * nbChairs,
            image: chairFreshImg
          });
        }
      }

      // Étape 16 - bottes supplémentaires fresh
      getExtraBundles().forEach(b => {
        items.push({ title: ('BOTTE ' + b.title).toUpperCase(), flowers: b.quantity * 5, image: b.image });
      });

      return items;
    }

    /* ----------- Items "Suppléments" (artificiels, stabilisés, contenants…) ----------- */
    function getSupplementsItems() {
      const items = [];

      // Étape 9 - table d'honneur artificielle
      if (typeof tableHonneurChoice !== 'undefined' && tableHonneurChoice === 'artificial') {
        const price = parseFloat(((window.questionnaireConfig && window.questionnaireConfig.step9ArtificialPrice) || tableHonneurPrice) || 0) || 0;
        const thImg = getSummaryImageFromEl(document.getElementById('table-honneur-artificial'));
        items.push({ title: 'TABLE D\'HONNEUR ARTIFICIELLE', quantity: 1, unitPrice: price, image: thImg });
      }

      // Étape 10 - arche artificielle
      if (typeof archeChoice !== 'undefined' && archeChoice === 'artificial') {
        const price = parseFloat(((typeof archePrice !== 'undefined') ? archePrice : 0)) || 0;
        const archeImg =
          getSummaryImageFromEl((function() {
            const g = document.querySelector('.arche-color-gallery:not([hidden])');
            return g ? g.querySelector('.arche-color-image-swiper-container') || g : null;
          })()) ||
          getSummaryImageFromEl(document.getElementById('arche-artificial'));
        items.push({ title: 'ARCHE FLEURIE ARTIFICIELLE', quantity: 1, unitPrice: price, image: archeImg });
      }

      // Étape 11 - chaises artificielles
      if (typeof chairChoice !== 'undefined' && chairChoice === 'artificial') {
        const nbChairs = (typeof chairQuantity !== 'undefined') ? (parseInt(chairQuantity, 10) || 0) : 0;
        const unit = parseFloat(chairPrice || 0) || 0;
        if (nbChairs > 0) {
          const chairImg = getSummaryImageFromEl(document.getElementById('step11-artificial-option'));
          items.push({ title: 'BOUQUETS DE CHAISE ARTIFICIELS', quantity: nbChairs, unitPrice: unit, image: chairImg });
        }
      }

      // Étape 12 - accessoires stabilisés
      getAccessoriesItems().forEach(it => items.push(it));

      // Étape 13 - contenants & sacs cadeaux
      getContainersItems().forEach(it => items.push(it));

      // Étape 15 - matériels
      getMaterialsItems().forEach(it => items.push(it));

      // Étape 16 - bottes supplémentaires (hors pack DIY)
      getExtraBundlesForSupplements().forEach(it => items.push(it));

      // Étape 13 - sacs cadeaux
      getGiftBagItems().forEach(it => items.push(it));

      return items;
    }

    /* ----------- Pack DIY recommandé (S / M / L selon quantité de fleurs) ----------- */
    const PACK_STEMS_S = 186;
    const PACK_STEMS_M = 280;
    const PACK_PRICE_M_RATIO = 1242 / 796;
    const PACK_PRICE_L_RATIO = 1716 / 796;

    function getRecommendedPackInfo() {
      const freshItems = getFreshItems();
      const totalFlowers = freshItems.reduce(function(sum, it) {
        return sum + (parseInt(it.flowers, 10) || 0);
      }, 0);

      const universEl = document.querySelector('.univers-item.selected');
      const universTitle = universEl ? (universEl.getAttribute('data-univers-title') || '').trim() : '';
      const universPriceEl = universEl ? universEl.querySelector('.univers-item-price') : null;
      const basePrice = parsePriceFromText(universPriceEl ? universPriceEl.textContent : '');

      let packSize = 'S';
      let unitPrice = basePrice;
      if (totalFlowers > PACK_STEMS_M) {
        packSize = 'L';
        unitPrice = basePrice * PACK_PRICE_L_RATIO;
      } else if (totalFlowers > PACK_STEMS_S) {
        packSize = 'M';
        unitPrice = basePrice * PACK_PRICE_M_RATIO;
      }

      const packName = universTitle
        ? ('PACK DIY ' + packSize + ' — ' + universTitle)
        : (totalFlowers > 0 ? ('PACK DIY ' + packSize) : '-');

      const packImageEl = universEl ? universEl.querySelector('.univers-item-image img') : null;
      const image = (packImageEl && packImageEl.src) ? packImageEl.src : '';

      return {
        name: packName,
        size: packSize,
        unitPrice: Math.round(unitPrice * 100) / 100,
        image: image,
        quantity: 1,
        totalFlowers: totalFlowers
      };
    }

    /* ----------- Rendu HTML ----------- */
    const VAT_RATE = 0; // TVA désactivée (0%).

    function toTtcPrice(value) {
      const numeric = parseFloat(value) || 0;
      return Math.round((numeric * (1 + VAT_RATE)) * 100) / 100;
    }

    function renderFreshList() {
      const container = document.getElementById('summary-items-list-short');
      const seeAllLink = document.getElementById('summary-see-all-fresh-link');
      if (!container) return;

      const items = (getSummaryData() || {}).freshItems || [];
      const expanded = container.getAttribute('data-expanded') === 'true';
      const visible = expanded ? items : items.slice(0, FRESH_COLLAPSED_COUNT);

      if (items.length === 0) {
        container.innerHTML = '<div class="summary-empty-state">Aucun élément en fleurs fraîches sélectionné.</div>';
        if (seeAllLink) seeAllLink.style.display = 'none';
        return;
      }

      container.innerHTML = visible.map(item => {
        const imgSrc = escapeHtmlAttr(item.image || PLACEHOLDER_IMG);
        return ''
          + '<div class="summary-fresh-item">'
          +   '<div class="summary-fresh-item-image"><img src="' + imgSrc + '" alt="" loading="lazy"/></div>'
          +   '<div class="summary-fresh-item-name">' + escapeHtmlAttr(item.title) + '</div>'
          +   '<div class="summary-fresh-item-badge">+ ' + item.flowers + ' fleurs</div>'
          + '</div>';
      }).join('');

      if (seeAllLink) {
        if (items.length > FRESH_COLLAPSED_COUNT) {
          seeAllLink.style.display = '';
          seeAllLink.innerHTML = expanded ? 'Voir moins <span>▲</span>' : 'Voir tout <span>▼</span>';
        } else {
          seeAllLink.style.display = 'none';
        }
      }
    }

    function renderItemsTable(tbodyId, items, collapsedCount) {
      const tbody = document.getElementById(tbodyId);
      if (!tbody) return 0;

      if (items.length === 0) {
        tbody.innerHTML = '<tr class="summary-empty-row"><td colspan="5">Aucun élément</td></tr>';
        return 0;
      }

      const expanded = tbody.getAttribute('data-expanded') === 'true';
      const visible = expanded ? items : items.slice(0, collapsedCount);

      let totalAmount = 0;
      items.forEach(function(it) {
        const lineHt = (it.unitPrice || 0) * (it.quantity || 0);
        totalAmount += toTtcPrice(lineHt);
      });

      tbody.innerHTML = visible.map(it => {
        const imgSrc = escapeHtmlAttr(it.image || PLACEHOLDER_IMG);
        const lineHt = (it.unitPrice || 0) * (it.quantity || 0);
        const unitTtc = toTtcPrice(it.unitPrice || 0);
        const totalTtc = toTtcPrice(lineHt);
        const unitStr  = (it.unitPrice > 0) ? formatPrice(unitTtc) : '—';
        const totalStr = (it.unitPrice > 0) ? formatPrice(totalTtc) : '—';
        return ''
          + '<tr class="summary-item-row">'
          +   '<td class="summary-col-image"><img src="' + imgSrc + '" alt="" loading="lazy"/></td>'
          +   '<td class="summary-col-name">' + escapeHtmlAttr(it.title) + '</td>'
          +   '<td class="summary-col-qty">' + (it.quantity || 0) + '</td>'
          +   '<td class="summary-col-unit">' + unitStr + '</td>'
          +   '<td class="summary-col-total">' + totalStr + '</td>'
          + '</tr>';
      }).join('');

      return totalAmount;
    }

    function formatPrice(value) {
      const v = Math.round((value || 0) * 100) / 100;
      const s = (v % 1 === 0) ? String(v) : v.toFixed(2).replace('.', ',');
      return s + ' € TTC';
    }

    /* ----------- Données affichées (live DOM OU snapshot localStorage) ----------- */
    // Cache local pour mémoriser les items fresh/supp/pack quand on déplie/replie
    let summaryDataCache = null;

    function getSummaryData() {
      if (summaryDataCache) return summaryDataCache;

      const snap = loadSummarySnapshot();
      let data;

      // Si la page a rechargé après création de compte, les variables d'état JS sont perdues
      // → on utilise le snapshot. Sinon on lit le DOM live.
      const hasLiveState = (typeof selectedBouquets !== 'undefined' && selectedBouquets.length > 0)
        || (typeof tableHonneurChoice !== 'undefined' && tableHonneurChoice !== null)
        || (typeof archeChoice !== 'undefined' && archeChoice !== null)
        || (typeof chairChoice !== 'undefined' && chairChoice !== null)
        || (workshopParticipantsInput && workshopParticipantsInput.value)
        || document.querySelectorAll('.bouquet-item.selected, .element-item.selected, .decoration-item.selected').length > 0;

      if (snap && !hasLiveState) {
        data = {
          firstName: snap.customerFirstName || '',
          lastName: snap.customerLastName || '',
          email: snap.email || '',
          weddingDate: snap.weddingDate || '',
          postalCode: snap.postalCode || '',
          participants: Math.max(1, parseInt(snap.participants, 10) || 1),
          totalMinutes: snap.totalMinutes || 0,
          freshItems: Array.isArray(snap.freshItems) ? snap.freshItems : [],
          supplements: Array.isArray(snap.supplements) ? snap.supplements : [],
          pack: snap.pack || { name: '-', quantity: 1, unitPrice: 0, image: '' },
          source: 'snapshot'
        };
      } else {
        const participantsRaw = (workshopParticipantsInput && workshopParticipantsInput.value) || '0';
        data = {
          firstName: (document.getElementById('RegisterForm-FirstName') || {}).value || '',
          lastName:  (document.getElementById('RegisterForm-LastName')  || {}).value || '',
          email:     (document.getElementById('RegisterForm-email')     || {}).value || '',
          weddingDate: (document.getElementById('wedding-date') || {}).value || '',
          postalCode:  (document.getElementById('RegisterForm-PostalCode') || {}).value || '',
          participants: Math.max(1, parseInt(participantsRaw, 10) || 1),
          totalMinutes: computeTotalTimeMinutes(),
          freshItems: getFreshItems(),
          supplements: getSupplementsItems(),
          pack: getRecommendedPackInfo(),
          source: 'live'
        };
      }

      summaryDataCache = data;
      return data;
    }

    function invalidateSummaryCache() {
      summaryDataCache = null;
    }

    /* ----------- Orchestration principale ----------- */
    function populateSummary() {
      invalidateSummaryCache();
      const data = getSummaryData();

      // Nom personnalisé
      const nameEl = document.getElementById('summary-customer-name');
      if (nameEl) {
        const fn = (data.firstName || '').trim();
        nameEl.textContent = (fn ? fn.toUpperCase() : (nameEl.textContent || 'CLIENT')).replace(/,$/, '') + ',';
      }

      // Participants & durée
      const partEl = document.getElementById('summary-participants-count');
      if (partEl) partEl.textContent = data.participants;

      const durationMinutes = Math.round((data.totalMinutes || 0) / Math.max(1, data.participants));
      const durationEl = document.getElementById('summary-creation-duration');
      if (durationEl) durationEl.textContent = formatDuration(durationMinutes);

      // Quantité totale de fleurs
      const totalFlowers = data.freshItems.reduce(function(sum, it) { return sum + (parseInt(it.flowers, 10) || 0); }, 0);
      const totalFlowersEl = document.getElementById('summary-total-flowers');
      if (totalFlowersEl) totalFlowersEl.textContent = totalFlowers;

      // Pack DIY recommandé (affichage en-tête)
      const pack = data.pack;
      const recPackEl = document.getElementById('summary-recommended-pack');
      if (recPackEl) recPackEl.textContent = (pack && pack.size) ? pack.size : '-';

      // Liste "Pour rappel" (fresh only)
      renderFreshList();

      // Tableau "Kit de fleurs fraîche" (1 ligne : le pack recommandé)
      const freshTableItems = (pack && pack.name && pack.name !== '-')
        ? [{ title: pack.name, quantity: pack.quantity, unitPrice: pack.unitPrice, image: pack.image }]
        : [];
      const kitTotal = renderItemsTable('summary-table-fresh-body', freshTableItems, freshTableItems.length);

      // Tableau "Suppléments"
      const suppTbody = document.getElementById('summary-table-supplements-body');
      const suppSeeAll = document.getElementById('summary-see-all-supplements-link');
      const suppTotal = renderItemsTable('summary-table-supplements-body', data.supplements, SUPP_COLLAPSED_COUNT);
      if (suppSeeAll) {
        if (data.supplements.length > SUPP_COLLAPSED_COUNT) {
          suppSeeAll.style.display = '';
          const expanded = suppTbody && suppTbody.getAttribute('data-expanded') === 'true';
          suppSeeAll.innerHTML = expanded ? 'Voir moins <span>▲</span>' : 'Voir tout <span>▼</span>';
        } else {
          suppSeeAll.style.display = 'none';
        }
      }

      // Budget total = kit + suppléments
      const totalBudgetEl = document.getElementById('summary-total-budget');
      if (totalBudgetEl) totalBudgetEl.textContent = formatPrice(kitTotal + suppTotal);

      updateCartButtonState();
    }

    // Exposer pour le hook dans showStep
    window.populateSummary = populateSummary;

    /* ----------- Voir tout / Voir moins ----------- */
    safeAddEventListener(getElement('summary-see-all-fresh-link'), 'click', function(e) {
      e.preventDefault();
      const container = document.getElementById('summary-items-list-short');
      if (!container) return;
      container.setAttribute('data-expanded', container.getAttribute('data-expanded') === 'true' ? 'false' : 'true');
      renderFreshList();
    });

    safeAddEventListener(getElement('summary-see-all-supplements-link'), 'click', function(e) {
      e.preventDefault();
      const tbody = document.getElementById('summary-table-supplements-body');
      if (!tbody) return;
      tbody.setAttribute('data-expanded', tbody.getAttribute('data-expanded') === 'true' ? 'false' : 'true');
      populateSummary();
    });

    /* ----------- Modale "Comment ce temps est-il calculé ?" ----------- */
    const timeHelpModal = document.getElementById('time-help-modal');
    function openTimeHelpModal() {
      if (!timeHelpModal) return;
      timeHelpModal.classList.add('active');
      timeHelpModal.setAttribute('aria-hidden', 'false');
      document.body.style.overflow = 'hidden';
    }
    function closeTimeHelpModal() {
      if (!timeHelpModal) return;
      timeHelpModal.classList.remove('active');
      timeHelpModal.setAttribute('aria-hidden', 'true');
      document.body.style.overflow = '';
    }
    safeAddEventListener(getElement('summary-time-help-link'), 'click', function(e) {
      e.preventDefault();
      openTimeHelpModal();
    });
    safeAddEventListener(getElement('time-help-modal-close'), 'click', closeTimeHelpModal);
    if (timeHelpModal) {
      const overlay = timeHelpModal.querySelector('.modal-overlay');
      safeAddEventListener(overlay, 'click', closeTimeHelpModal);
    }
    document.addEventListener('keydown', function(e) {
      if (e.key === 'Escape' && timeHelpModal && timeHelpModal.classList.contains('active')) {
        closeTimeHelpModal();
      }
    });

    /* ----------- Génération PDF du devis ----------- */
    const PDF_INLINE_STYLES = ''
      + '#pdf-export-content,#pdf-export-content .pdf-page{background:#fff;color:#000;font-family:Arial,Helvetica,sans-serif;}'
      + '#pdf-export-content{width:794px;padding:36px 32px 36px 44px;box-sizing:border-box;}'
      + '#pdf-export-content .pdf-page{padding:4px 2px;box-sizing:border-box;}'
      + '#pdf-export-content .pdf-header{display:flex;align-items:center;gap:20px;padding-bottom:15px;border-bottom:2px solid #8B1538;margin-bottom:20px;}'
      + '#pdf-export-content .pdf-logo{height:60px;width:auto;object-fit:contain;}'
      + '#pdf-export-content .pdf-title{font-size:22px;font-weight:700;color:#8B1538;text-transform:uppercase;}'
      + '#pdf-export-content .pdf-section{margin-bottom:20px;}'
      + '#pdf-export-content .pdf-section h2{font-size:14px;font-weight:700;color:#8B1538;text-transform:uppercase;margin:0 0 10px;padding-bottom:5px;border-bottom:1px solid #e5d6dc;}'
      + '#pdf-export-content .pdf-info-table{width:100%;border-collapse:collapse;font-size:13px;}'
      + '#pdf-export-content .pdf-info-table td{padding:6px 12px 6px 4px;vertical-align:top;}'
      + '#pdf-export-content .pdf-info-table td:first-child{font-weight:600;width:35%;color:#555;padding-left:0;}'
      + '#pdf-export-content .pdf-summary-box{background:#FFFBF5;border-radius:6px;padding:16px 18px 16px 20px;font-size:13px;}'
      + '#pdf-export-content .pdf-summary-box div{margin-bottom:6px;}'
      + '#pdf-export-content .pdf-items-table{width:100%;border-collapse:collapse;font-size:12px;}'
      + '#pdf-export-content .pdf-items-table th,#pdf-export-content .pdf-items-table td{padding:8px 10px;border-bottom:1px solid #eee;}'
      + '#pdf-export-content .pdf-items-table th:first-child,#pdf-export-content .pdf-items-table td:first-child{padding-left:14px;text-align:left;}'
      + '#pdf-export-content .pdf-items-table th{background:#8B1538;color:#fff;font-weight:600;text-transform:uppercase;font-size:11px;}'
      + '#pdf-export-content .pdf-items-table th:not(:first-child),#pdf-export-content .pdf-items-table td:not(:first-child){text-align:center;width:80px;}'
      + '#pdf-export-content .pdf-items-table .pdf-col-image{width:52px;text-align:center;padding-left:10px;}'
      + '#pdf-export-content .pdf-items-table .pdf-col-name{text-align:left;width:auto;}'
      + '#pdf-export-content .pdf-items-table .pdf-col-num{text-align:center;width:78px;}'
      + '#pdf-export-content .pdf-item-image{width:42px;height:42px;object-fit:cover;border-radius:4px;display:block;margin:0 auto;background:#f7f7f7;}'
      + '#pdf-export-content .pdf-total-box{background:#8B1538;color:#fff;border-radius:8px;padding:18px 20px;text-align:center;margin-top:10px;}'
      + '#pdf-export-content .pdf-total-label{font-size:13px;font-weight:600;text-transform:uppercase;margin-bottom:5px;}'
      + '#pdf-export-content .pdf-total-value{font-size:32px;font-weight:700;line-height:1;margin-bottom:5px;}'
      + '#pdf-export-content .pdf-total-sub{font-size:11px;text-transform:uppercase;}'
      + '#pdf-export-content .pdf-footer{margin-top:25px;padding-top:12px;border-top:1px solid #eee;font-size:10px;color:#888;text-align:center;}';

    function loadScriptOnce(src, globalCheck) {
      return new Promise(function(resolve, reject) {
        if (globalCheck && globalCheck()) {
          resolve();
          return;
        }
        if (document.querySelector('script[data-q-pdf-src="' + src + '"]')) {
          const wait = function() {
            if (globalCheck && globalCheck()) resolve();
            else setTimeout(wait, 50);
          };
          wait();
          return;
        }
        const script = document.createElement('script');
        script.src = src;
        script.setAttribute('data-q-pdf-src', src);
        script.onload = function() { resolve(); };
        script.onerror = function() { reject(new Error('Script PDF: ' + src)); };
        document.head.appendChild(script);
      });
    }

    function loadPdfLibraries() {
      return Promise.all([
        loadScriptOnce(
          'https://cdnjs.cloudflare.com/ajax/libs/html2canvas/1.4.1/html2canvas.min.js',
          function() { return typeof window.html2canvas === 'function'; }
        ),
        loadScriptOnce(
          'https://cdnjs.cloudflare.com/ajax/libs/jspdf/2.5.1/jspdf.umd.min.js',
          function() { return !!(window.jspdf && window.jspdf.jsPDF); }
        )
      ]);
    }

    function getJsPdfConstructor() {
      if (window.jspdf && window.jspdf.jsPDF) {
        return window.jspdf.jsPDF;
      }
      if (window.jsPDF) {
        return window.jsPDF;
      }
      return null;
    }

    function escapeHtmlText(value) {
      return escapeHtmlAttr(value);
    }

    function renderPdfImageCell(imageUrl, altText) {
      const src = String(imageUrl || '').trim();
      if (!src) {
        return '<td class="pdf-col-image"></td>';
      }
      return '<td class="pdf-col-image"><img class="pdf-item-image" src="' + escapeHtmlAttr(src) + '" alt="' + escapeHtmlAttr(altText || '') + '" crossorigin="anonymous"/></td>';
    }

    function waitForPdfImages(container, timeoutMs) {
      const limit = timeoutMs || 5000;
      const imgs = container ? container.querySelectorAll('img') : [];
      return Promise.all(Array.from(imgs).map(function(img) {
        if (img.complete && img.naturalWidth > 0) {
          return Promise.resolve();
        }
        return new Promise(function(resolve) {
          const done = function() { resolve(); };
          img.addEventListener('load', done, { once: true });
          img.addEventListener('error', done, { once: true });
          setTimeout(done, limit);
        });
      }));
    }

    function mountPdfContainerForCapture(container) {
      const savedParent = container.parentNode;
      const savedNext = container.nextSibling;
      document.body.appendChild(container);
      container.classList.add('pdf-export-capturing');
      container.setAttribute('aria-hidden', 'false');
      container.style.display = 'block';
      container.style.visibility = 'visible';
      container.style.opacity = '1';
      container.style.position = 'fixed';
      container.style.left = '0';
      container.style.top = '0';
      container.style.width = '794px';
      container.style.zIndex = '2147483646';
      return function restorePdfContainer() {
        container.classList.remove('pdf-export-capturing');
        container.setAttribute('aria-hidden', 'true');
        container.removeAttribute('style');
        if (savedParent) {
          savedParent.insertBefore(container, savedNext);
        }
      };
    }

    async function generateQuotePdfFile(rootEl, filename) {
      const html2canvasFn = window.html2canvas;
      const JsPDF = getJsPdfConstructor();
      if (!html2canvasFn || !JsPDF) {
        throw new Error('Bibliothèques PDF non chargées');
      }

      const target = rootEl;
      const captureWidth = Math.max(target.scrollWidth, target.offsetWidth, 794);
      const captureHeight = Math.max(target.scrollHeight, target.offsetHeight, 1);

      const canvas = await html2canvasFn(target, {
        scale: 2,
        useCORS: true,
        allowTaint: true,
        backgroundColor: '#ffffff',
        logging: false,
        width: captureWidth,
        height: captureHeight,
        windowWidth: captureWidth,
        windowHeight: captureHeight,
        scrollX: 0,
        scrollY: 0,
        onclone: function(clonedDoc) {
          const clonedRoot = clonedDoc.getElementById('pdf-export-content');
          if (clonedRoot) {
            clonedRoot.style.visibility = 'visible';
            clonedRoot.style.opacity = '1';
            clonedRoot.style.display = 'block';
            clonedRoot.style.position = 'static';
            clonedRoot.style.left = 'auto';
            clonedRoot.style.top = 'auto';
            clonedRoot.style.width = '794px';
            clonedRoot.style.padding = '36px 32px 36px 44px';
            clonedRoot.style.boxSizing = 'border-box';
            clonedRoot.style.background = '#ffffff';
            clonedRoot.style.color = '#000000';
          }
          const clonedPage = clonedDoc.querySelector('.pdf-page');
          if (clonedPage) {
            clonedPage.style.display = 'block';
            clonedPage.style.background = '#ffffff';
            clonedPage.style.padding = '4px 2px';
          }
        }
      });

      if (!canvas.width || !canvas.height) {
        throw new Error('Capture PDF vide (canvas 0×0)');
      }

      const pdf = new JsPDF({ unit: 'mm', format: 'a4', orientation: 'portrait' });
      const pageWidth = pdf.internal.pageSize.getWidth();
      const pageHeight = pdf.internal.pageSize.getHeight();
      const marginMm = 12;
      const printableWidth = pageWidth - marginMm * 2;
      const printableHeight = pageHeight - marginMm * 2;
      const imgWidth = printableWidth;
      const imgHeight = (canvas.height * imgWidth) / canvas.width;
      const imgData = canvas.toDataURL('image/jpeg', 0.92);
      let heightLeft = imgHeight;
      let position = marginMm;

      pdf.addImage(imgData, 'JPEG', marginMm, position, imgWidth, imgHeight);
      heightLeft -= printableHeight;

      while (heightLeft > 0) {
        position = marginMm - (imgHeight - heightLeft);
        pdf.addPage();
        pdf.addImage(imgData, 'JPEG', marginMm, position, imgWidth, imgHeight);
        heightLeft -= printableHeight;
      }

      pdf.save(filename);
    }

    function buildPdfContent() {
      const container = document.getElementById('pdf-export-content');
      if (!container) return null;
      container.innerHTML = '';

      const cfg = window.questionnaireConfig || {};
      const data = getSummaryData();
      const firstName   = data.firstName;
      const lastName    = data.lastName;
      const email       = data.email;
      const weddingDate = data.weddingDate;
      const postalCode  = data.postalCode;

      const totalFlowersEl = document.getElementById('summary-total-flowers');
      const durationEl = document.getElementById('summary-creation-duration');
      const partCountEl = document.getElementById('summary-participants-count');
      const totalBudgetEl = document.getElementById('summary-total-budget');

      const freshItems = data.freshItems;
      const supplements = data.supplements;
      const pack = data.pack;

      let html = '';
      html += '<div class="pdf-page">';

      // En-tête
      html += '<div class="pdf-header">';
      if (cfg.pdfLogo) {
        html += '<img class="pdf-logo" src="' + escapeHtmlAttr(cfg.pdfLogo) + '" alt="Logo" crossorigin="anonymous"/>';
      }
      html += '<div class="pdf-title">DEVIS FLORAL — Mariage</div>';
      html += '</div>';

      // Infos client
      html += '<div class="pdf-section">';
      html += '<h2>Informations client</h2>';
      html += '<table class="pdf-info-table">';
      if (firstName || lastName) {
        html += '<tr><td>Nom :</td><td>' + escapeHtmlText((firstName + ' ' + lastName).trim()) + '</td></tr>';
      }
      if (email) html += '<tr><td>Email :</td><td>' + escapeHtmlText(email) + '</td></tr>';
      if (weddingDate) html += '<tr><td>Date du mariage :</td><td>' + escapeHtmlText(weddingDate) + '</td></tr>';
      if (postalCode) html += '<tr><td>Code postal :</td><td>' + escapeHtmlText(postalCode) + '</td></tr>';
      html += '</table>';
      html += '</div>';

      // Résumé clé
      html += '<div class="pdf-section pdf-summary-box">';
      html += '<div><strong>Quantité totale de fleurs :</strong> ' + ((totalFlowersEl && totalFlowersEl.textContent) || '0') + '</div>';
      html += '<div><strong>Pack recommandé :</strong> ' + (pack && pack.name ? pack.name : '-') + '</div>';
      html += '<div><strong>Durée de création :</strong> ' + ((durationEl && durationEl.textContent) || '—') + ' pour ' + ((partCountEl && partCountEl.textContent) || '0') + ' personnes</div>';
      html += '</div>';

      // Pour rappel (fleurs fraîches)
      if (freshItems.length > 0) {
        html += '<div class="pdf-section">';
        html += '<h2>Éléments en fleurs fraîches</h2>';
        html += '<table class="pdf-items-table"><thead><tr><th class="pdf-col-image"></th><th class="pdf-col-name">Élément</th><th class="pdf-col-num">Fleurs</th></tr></thead><tbody>';
        freshItems.forEach(function(it) {
          html += '<tr>'
            + renderPdfImageCell(it.image, it.title)
            + '<td class="pdf-col-name">' + escapeHtmlText(it.title) + '</td>'
            + '<td class="pdf-col-num">+ ' + it.flowers + ' fleurs</td>'
            + '</tr>';
        });
        html += '</tbody></table>';
        html += '</div>';
      }

      // Kit de fleurs fraîche
      html += '<div class="pdf-section">';
      html += '<h2>Kit de fleurs fraîche</h2>';
      html += '<table class="pdf-items-table"><thead><tr><th class="pdf-col-image"></th><th class="pdf-col-name">Désignation</th><th class="pdf-col-num">Qt</th><th class="pdf-col-num">Prix unit</th><th class="pdf-col-num">Prix total</th></tr></thead><tbody>';
      if (pack && pack.name && pack.name !== '-') {
        const unitStr = pack.unitPrice > 0 ? formatPrice(toTtcPrice(pack.unitPrice)) : '—';
        const totStr  = pack.unitPrice > 0 ? formatPrice(toTtcPrice(pack.unitPrice * pack.quantity)) : '—';
        html += '<tr>'
          + renderPdfImageCell(pack.image, pack.name)
          + '<td class="pdf-col-name">' + escapeHtmlText(pack.name) + '</td>'
          + '<td class="pdf-col-num">' + pack.quantity + '</td>'
          + '<td class="pdf-col-num">' + unitStr + '</td>'
          + '<td class="pdf-col-num">' + totStr + '</td>'
          + '</tr>';
      } else {
        html += '<tr><td colspan="5">—</td></tr>';
      }
      html += '</tbody></table>';
      html += '</div>';

      // Suppléments
      if (supplements.length > 0) {
        html += '<div class="pdf-section">';
        html += '<h2>Suppléments</h2>';
        html += '<table class="pdf-items-table"><thead><tr><th class="pdf-col-image"></th><th class="pdf-col-name">Désignation</th><th class="pdf-col-num">Qt</th><th class="pdf-col-num">Prix unit</th><th class="pdf-col-num">Prix total</th></tr></thead><tbody>';
        supplements.forEach(function(it) {
          const total = (it.unitPrice || 0) * (it.quantity || 0);
          const unitTtc = toTtcPrice(it.unitPrice || 0);
          const totalTtc = toTtcPrice(total);
          html += '<tr>'
            + renderPdfImageCell(it.image, it.title)
            + '<td class="pdf-col-name">' + escapeHtmlText(it.title) + '</td>'
            + '<td class="pdf-col-num">' + (it.quantity || 0) + '</td>'
            + '<td class="pdf-col-num">' + (it.unitPrice > 0 ? formatPrice(unitTtc) : '—') + '</td>'
            + '<td class="pdf-col-num">' + (it.unitPrice > 0 ? formatPrice(totalTtc) : '—') + '</td>'
            + '</tr>';
        });
        html += '</tbody></table>';
        html += '</div>';
      }

      // Budget total
      html += '<div class="pdf-section pdf-total-box">';
      html += '<div class="pdf-total-label">BUDGET TOTAL DU MARIAGE (TTC)</div>';
      html += '<div class="pdf-total-value">' + ((totalBudgetEl && totalBudgetEl.textContent) || '0 € TTC') + '</div>';
      html += '<div class="pdf-total-sub">Kit DIY + Suppléments (TTC)</div>';
      html += '</div>';

      // Footer
      if (cfg.pdfFooterText) {
        html += '<div class="pdf-footer">' + String(cfg.pdfFooterText).replace(/\n/g, '<br/>') + '</div>';
      }

      html += '</div>';

      container.innerHTML = '<style>' + PDF_INLINE_STYLES + '</style>' + html;
      return container;
    }

    async function handleDownloadQuote() {
      const btn = document.getElementById('download-quote-btn');
      if (!btn) return;
      const originalText = btn.textContent;
      btn.disabled = true;
      btn.textContent = 'Génération du PDF...';
      let restorePdfContainer = null;
      try {
        if (typeof populateSummary === 'function') {
          populateSummary();
        }
        await loadPdfLibraries();
        const content = buildPdfContent();
        if (!content) throw new Error('Contenu PDF introuvable');
        if (!content.textContent || !content.textContent.trim()) {
          throw new Error('Le contenu du devis est vide');
        }

        restorePdfContainer = mountPdfContainerForCapture(content);
        await waitForPdfImages(content, 5000);
        await new Promise(function(resolve) {
          setTimeout(function() {
            requestAnimationFrame(function() {
              requestAnimationFrame(resolve);
            });
          }, 150);
        });

        const cfg = window.questionnaireConfig || {};
        const data = getSummaryData();
        const firstName = data.firstName;
        const weddingDate = data.weddingDate;
        const filenameParts = [cfg.pdfFilenamePrefix || 'Devis-FlorEasy'];
        if (firstName) filenameParts.push(firstName.replace(/\s+/g, '-'));
        if (weddingDate) filenameParts.push(weddingDate);
        const filename = filenameParts.join('-') + '.pdf';

        await generateQuotePdfFile(content, filename);
      } catch (err) {
        console.error('Erreur génération PDF:', err);
        alert('Une erreur est survenue lors de la génération du PDF. Veuillez réessayer.');
      } finally {
        if (restorePdfContainer) {
          restorePdfContainer();
        }
        btn.disabled = false;
        btn.textContent = originalText;
      }
    }

    safeAddEventListener(getElement('download-quote-btn'), 'click', handleDownloadQuote);

    /* ----------- Validation du form étape 17 (informations client) ----------- */
    function getQuestionnaireCustomerConfig() {
      return (window.questionnaireConfig && window.questionnaireConfig.customer) || {};
    }

    function isQuestionnaireCustomerLoggedIn() {
      return getQuestionnaireCustomerConfig().loggedIn === true;
    }

    function hydrateLoggedInCustomerFields() {
      const customer = getQuestionnaireCustomerConfig();
      const fieldMap = {
        'RegisterForm-FirstName': customer.firstName,
        'RegisterForm-LastName': customer.lastName,
        'RegisterForm-email': customer.email
      };

      Object.keys(fieldMap).forEach(function(id) {
        const input = document.getElementById(id);
        const value = fieldMap[id];
        if (input && value) {
          if (!input.value) {
            input.value = value;
          }
          input.readOnly = true;
          input.classList.add('readonly-field');
        }
      });
    }

    function isValidAccountEmail(value) {
      const email = (value || '').trim();
      return /^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(email);
    }

    function getAccountFieldWrapper(input) {
      return input ? input.closest('.form-field') : null;
    }

    function setAccountFieldError(input, message) {
      const wrapper = getAccountFieldWrapper(input);
      if (!wrapper) {
        return;
      }
      let hint = wrapper.querySelector('.form-field-error');
      if (message) {
        wrapper.classList.add('form-field-invalid');
        if (!hint) {
          hint = document.createElement('p');
          hint.className = 'form-field-error';
          hint.setAttribute('role', 'alert');
          wrapper.appendChild(hint);
        }
        hint.textContent = message;
        hint.hidden = false;
      } else {
        wrapper.classList.remove('form-field-invalid');
        if (hint) {
          hint.hidden = true;
          hint.textContent = '';
        }
      }
    }

    function validateCreateAccountForm() {
      const submitBtn = document.getElementById('create-account-btn');
      const summaryEl = document.getElementById('account-form-validation-summary');
      if (!submitBtn) {
        return false;
      }

      const lastName = document.getElementById('RegisterForm-LastName');
      const firstName = document.getElementById('RegisterForm-FirstName');
      const email = document.getElementById('RegisterForm-email');
      const weddingDate = document.getElementById('RegisterForm-WeddingDate');
      const postalCode = document.getElementById('RegisterForm-PostalCode');

      const issues = [];
      let isValid = true;

      if (!lastName || !lastName.value.trim()) {
        isValid = false;
        setAccountFieldError(lastName, 'Indiquez votre nom.');
        issues.push('nom');
      } else {
        setAccountFieldError(lastName, '');
      }

      if (!firstName || !firstName.value.trim()) {
        isValid = false;
        setAccountFieldError(firstName, 'Indiquez votre prénom.');
        issues.push('prénom');
      } else {
        setAccountFieldError(firstName, '');
      }

      if (!email || !email.value.trim()) {
        isValid = false;
        setAccountFieldError(email, 'Indiquez votre adresse e-mail.');
        issues.push('e-mail');
      } else if (!isValidAccountEmail(email.value)) {
        isValid = false;
        setAccountFieldError(email, 'Adresse e-mail invalide (ex. prenom@exemple.fr).');
        issues.push('e-mail valide');
      } else {
        setAccountFieldError(email, '');
      }

      if (weddingDate) {
        const weddingDateValue = weddingDate.value.trim();
        if (!weddingDateValue) {
          isValid = false;
          setAccountFieldError(weddingDate, 'Indiquez la date de votre mariage.');
          issues.push('date de mariage');
        } else if (!weddingDate.readOnly) {
          const mainDateInput = document.getElementById('wedding-date');
          const minDate = (mainDateInput && mainDateInput.getAttribute('min')) || getMinimumWeddingDate();
          if (!isWeddingDateWithinAllowedRange(weddingDateValue, minDate)) {
            isValid = false;
            setAccountFieldError(weddingDate, 'La date doit être au moins un mois après aujourd’hui.');
            issues.push('date de mariage valide');
          } else {
            setAccountFieldError(weddingDate, '');
          }
        } else {
          setAccountFieldError(weddingDate, '');
        }
      }

      if (postalCode) {
        const postalValue = postalCode.value.trim();
        if (!postalValue) {
          isValid = false;
          setAccountFieldError(postalCode, 'Indiquez votre code postal (5 chiffres).');
          issues.push('code postal');
        } else if (!/^[0-9]{5}$/.test(postalValue)) {
          isValid = false;
          setAccountFieldError(
            postalCode,
            'Code postal invalide : saisissez 5 chiffres (ex. 75001).'
          );
          issues.push('code postal à 5 chiffres');
        } else {
          setAccountFieldError(postalCode, '');
        }
      }

      if (summaryEl) {
        if (!isValid && issues.length) {
          summaryEl.hidden = false;
          summaryEl.textContent =
            'Pour activer le bouton, corrigez : ' + issues.join(', ') + '.';
        } else {
          summaryEl.hidden = true;
          summaryEl.textContent = '';
        }
      }

      setValidationButtonState(submitBtn, !isValid);
      return isValid;
    }

    function isCrossOriginUrl(url) {
      if (!url || url.indexOf('javascript:') === 0) {
        return false;
      }
      try {
        return new URL(url, window.location.href).origin !== window.location.origin;
      } catch (err) {
        return false;
      }
    }

    function getAccountRegisterUrl(form) {
      if (!form) {
        return '';
      }
      const saved = form.getAttribute('data-register-action');
      if (saved && saved.indexOf('javascript:') !== 0) {
        return saved;
      }
      const action = form.getAttribute('action') || '';
      if (action && action.indexOf('javascript:') !== 0) {
        return action;
      }
      return '/account';
    }

    function submitAccountInBackground() {
      const form = document.getElementById('questionnaire-create-account-form');
      const actionUrl = getAccountRegisterUrl(form);
      if (!form || !actionUrl) {
        return;
      }

      if (isCrossOriginUrl(actionUrl)) {
        let iframe = document.getElementById('questionnaire-account-submit-frame');
        if (!iframe) {
          iframe = document.createElement('iframe');
          iframe.id = 'questionnaire-account-submit-frame';
          iframe.name = 'questionnaire-account-submit-frame';
          iframe.setAttribute('title', 'Création de compte');
          iframe.hidden = true;
          iframe.style.cssText = 'position:absolute;width:0;height:0;border:0;visibility:hidden';
          document.body.appendChild(iframe);
        }
        const prevAction = form.getAttribute('action');
        const prevTarget = form.getAttribute('target');
        form.setAttribute('action', actionUrl);
        form.setAttribute('target', iframe.name);
        try {
          HTMLFormElement.prototype.submit.call(form);
        } catch (err) {
          console.warn('[Questionnaire] Création de compte en arrière-plan:', err);
        } finally {
          setTimeout(function() {
            form.setAttribute('action', prevAction || 'javascript:void(0)');
            if (prevTarget) {
              form.setAttribute('target', prevTarget);
            } else {
              form.removeAttribute('target');
            }
          }, 0);
        }
        return;
      }

      fetch(actionUrl, {
        method: (form.method || 'POST').toUpperCase(),
        body: new FormData(form),
        credentials: 'same-origin',
        redirect: 'manual'
      }).catch(function(err) {
        console.warn('[Questionnaire] Création de compte en arrière-plan:', err);
      });
    }

    function goToSummaryFromAccountStep() {
      try {
        saveSummarySnapshot();
      } catch (err) {
        console.error('saveSummarySnapshot:', err);
      }
      if (typeof showStep === 'function') {
        showStep(18);
      } else if (typeof window.showStep === 'function') {
        window.showStep(18);
      }
      window.scrollTo({ top: 0, behavior: 'smooth' });
    }

    window.__questionnaireGoToSummary = function() {
      if (!validateCreateAccountForm()) {
        return;
      }
      goToSummaryFromAccountStep();
    };

    const accountForm = document.getElementById('questionnaire-create-account-form');
    if (accountForm) {
      hydrateLoggedInCustomerFields();
      const registerAction = accountForm.getAttribute('action');
      if (registerAction && registerAction.indexOf('javascript:') !== 0) {
        accountForm.setAttribute('data-register-action', registerAction);
      } else if (!accountForm.getAttribute('data-register-action')) {
        accountForm.setAttribute('data-register-action', '/account');
      }
      accountForm.setAttribute('action', 'javascript:void(0)');
      accountForm.querySelectorAll('input').forEach(function(input) {
        input.addEventListener('input', validateCreateAccountForm);
        input.addEventListener('change', validateCreateAccountForm);
        input.addEventListener('keydown', function(e) {
          if (e.key === 'Enter') {
            e.preventDefault();
            window.__questionnaireGoToSummary();
          }
        });
      });

      validateCreateAccountForm();
    }

    /* ----------- Boutons d'action ----------- */
    safeAddEventListener(getElement('restart-questionnaire-btn'), 'click', function() {
      clearSummarySnapshot();
      showStep(1);
      window.location.reload();
    });

    function parseVariantId(value) {
      const v = String(value || '').replace(/\s/g, '');
      return /^\d+$/.test(v) ? parseInt(v, 10) : 0;
    }

    function normalizeCartVariantRef(value) {
      if (value && typeof value === 'object') {
        if (value.id || value.handle) return value;
        return '';
      }
      const ref = String(value || '').trim();
      if (!ref || ref === 'ID_VARIANTE_A_REMPLIR') return '';
      return ref;
    }

    const cartVariantHandleCache = new Map();

    function normalizeProductHandle(value) {
      return String(value || '')
        .trim()
        .replace(/^handle:/i, '')
        .replace(/^\/products\//i, '')
        .replace(/^https?:\/\/[^/]+\/products\//i, '')
        .replace(/\.js$/i, '')
        .split(/[?#]/)[0]
        .trim();
    }

    async function resolveCartVariantRef(ref) {
      if (ref && typeof ref === 'object') {
        if (ref.id) return parseVariantId(ref.id);
        const handle = normalizeProductHandle(ref.handle || '');
        if (!handle) return 0;
        const cacheKey = handle + '|' + String(ref.option1 || '') + '|' + String(ref.option2 || '') + '|' + String(ref.option3 || '');
        if (cartVariantHandleCache.has(cacheKey)) {
          return cartVariantHandleCache.get(cacheKey);
        }

        try {
          const response = await fetch('/products/' + encodeURIComponent(handle) + '.js', { headers: { 'Accept': 'application/json' } });
          if (!response.ok) throw new Error('Produit introuvable: ' + handle);
          const product = await response.json();
          const variants = Array.isArray(product.variants) ? product.variants : [];
          const variant = variants.find(function(v) {
            if (!v) return false;
            if (ref.option1 && String(v.option1 || '') !== String(ref.option1)) return false;
            if (ref.option2 && String(v.option2 || '') !== String(ref.option2)) return false;
            if (ref.option3 && String(v.option3 || '') !== String(ref.option3)) return false;
            return true;
          }) || variants.find(function(v) { return v && v.available; }) || variants[0];
          const id = variant && parseVariantId(variant.id);
          cartVariantHandleCache.set(cacheKey, id || 0);
          return id || 0;
        } catch (err) {
          console.warn('[Questionnaire] Variante introuvable pour le mapping:', ref, err);
          cartVariantHandleCache.set(cacheKey, 0);
          return 0;
        }
      }

      const numericId = parseVariantId(ref);
      if (numericId) return numericId;

      const handle = normalizeProductHandle(ref);
      if (!handle) return 0;
      if (cartVariantHandleCache.has(handle)) {
        return cartVariantHandleCache.get(handle);
      }

      const productUrl = '/products/' + encodeURIComponent(handle) + '.js';
      try {
        const response = await fetch(productUrl, { headers: { 'Accept': 'application/json' } });
        if (!response.ok) throw new Error('Produit introuvable: ' + handle);
        const product = await response.json();
        const variants = Array.isArray(product.variants) ? product.variants : [];
        const variant = variants.find(function(v) { return v && v.available; }) || variants[0];
        const id = variant && parseVariantId(variant.id);
        cartVariantHandleCache.set(handle, id || 0);
        return id || 0;
      } catch (err) {
        console.warn('[Questionnaire] Variante introuvable pour le handle:', handle, err);
        cartVariantHandleCache.set(handle, 0);
        return 0;
      }
    }

    async function resolveQuestionnaireCartItems(items) {
      const resolvedMap = new Map();
      for (const item of items) {
        const id = await resolveCartVariantRef(item.id);
        if (!id) continue;
        const existing = resolvedMap.get(id);
        if (existing) {
          existing.quantity += item.quantity;
        } else {
          resolvedMap.set(id, {
            id: id,
            quantity: item.quantity,
            properties: item.properties
          });
        }
      }
      return Array.from(resolvedMap.values());
    }

    function normalizeCartLookupKey(value) {
      return String(value || '')
        .toLowerCase()
        .normalize('NFD')
        .replace(/[\u0300-\u036f]/g, '')
        .replace(/\s+/g, ' ')
        .trim();
    }

    function lookupCartMap(map, label, blockId) {
      if (!map || typeof map !== 'object') return '';
      if (blockId && map[blockId] != null && map[blockId] !== '') {
        return map[blockId];
      }
      const key = normalizeCartLookupKey(label);
      if (!key) return '';
      const keys = Object.keys(map);
      for (let i = 0; i < keys.length; i++) {
        if (normalizeCartLookupKey(keys[i]) === key) return map[keys[i]];
      }
      return '';
    }

    function lookupUniversPackVariants(cv, universEl) {
      if (!universEl || !cv || !cv.univers) return null;
      const blockId = universEl.getAttribute('data-univers-id');
      const title = universEl.getAttribute('data-univers-title') || '';
      let entry = (blockId && cv.univers[blockId]) ? cv.univers[blockId] : null;
      if (!entry) {
        const matched = lookupCartMap(cv.univers, title, blockId);
        entry = (matched && typeof matched === 'object') ? matched : null;
      }
      return entry;
    }

    function getLineItemProperties() {
      const data = getSummaryData();
      const props = { Source: 'Questionnaire mariage' };
      if (data.weddingDate) props['Date du mariage'] = data.weddingDate;
      const name = ((data.firstName || '') + ' ' + (data.lastName || '')).trim();
      if (name) props.Client = name;
      return props;
    }

    function buildQuestionnaireCartItems() {
      const cfg = window.questionnaireConfig || {};
      const cv = cfg.cartVariants || {};
      const lineProps = getLineItemProperties();
      const itemsMap = new Map();

      function addItem(variantId, quantity) {
        const id = normalizeCartVariantRef(variantId);
        const qty = Math.max(0, parseInt(quantity, 10) || 0);
        if (!id || qty <= 0) return;
        const key = (id && typeof id === 'object') ? JSON.stringify(id) : id;
        const existing = itemsMap.get(key);
        if (existing) {
          existing.quantity += qty;
        } else {
          itemsMap.set(key, { id: id, quantity: qty, properties: Object.assign({}, lineProps) });
        }
      }

      function variantFromColorSelect(selectEl, colorMap, fallback) {
        if (!selectEl || !selectEl.value) return fallback;
        return lookupCartMap(colorMap, selectEl.value, '') || fallback;
      }

      // Pack DIY (univers × taille S/M/L)
      const pack = getRecommendedPackInfo();
      const universEl = document.querySelector('.univers-item.selected');
      const sizes = lookupUniversPackVariants(cv, universEl);
      if (sizes) {
        const packKey = (pack && pack.size) ? String(pack.size).toLowerCase() : 's';
        const variantId = sizes[packKey] || sizes.s;
        addItem(variantId, 1);
      }

      // Matériels
      document.querySelectorAll('.material-item').forEach(function(card) {
        const materialId = card.getAttribute('data-material-id');
        const qInput = card.querySelector('.quantity-input[data-material-id]');
        const qty = parseInt(qInput && qInput.value, 10) || 0;
        if (qty <= 0) return;
        const titleEl = card.querySelector('.material-item-title');
        const title = titleEl ? titleEl.textContent.trim() : '';
        addItem(lookupCartMap(cv.materials, title, materialId), qty);
      });

      // Contenants
      document.querySelectorAll('.container-item').forEach(function(el) {
        const containerId = el.getAttribute('data-container-id');
        const qtyInput = el.querySelector('#container-quantity-' + containerId);
        const qty = parseInt(qtyInput && qtyInput.value, 10) || 0;
        if (qty <= 0) return;
        const labelEl = el.querySelector('.container-item-label');
        const title = labelEl ? labelEl.textContent.trim() : '';
        addItem(lookupCartMap(cv.containers, title, containerId), qty);
      });

      // Sacs cadeaux
      document.querySelectorAll('.gift-bag-item').forEach(function(el) {
        const bagId = el.getAttribute('data-gift-bag-id');
        const qtyInput = el.querySelector('#gift-bag-quantity-' + bagId);
        const qty = parseInt(qtyInput && qtyInput.value, 10) || 0;
        if (qty <= 0) return;
        const labelEl = el.querySelector('.gift-bag-item-label');
        const title = labelEl ? labelEl.textContent.trim() : '';
        addItem(lookupCartMap(cv.giftBags, title, bagId), qty);
      });

      // Table d'honneur artificielle
      if (typeof tableHonneurChoice !== 'undefined' && tableHonneurChoice === 'artificial') {
        const select = document.getElementById('table-honneur-color');
        addItem(variantFromColorSelect(select, cv.tableHonneurColors, cv.step9Artificial), 1);
      }

      // Arche artificielle
      if (typeof archeChoice !== 'undefined' && archeChoice === 'artificial') {
        const select = document.getElementById('arche-color');
        addItem(variantFromColorSelect(select, cv.archeColors, cv.step10Artificial), 1);
      }

      // Bouquets de chaise artificiels
      if (typeof chairChoice !== 'undefined' && chairChoice === 'artificial') {
        const nbChairs = (typeof chairQuantity !== 'undefined') ? (parseInt(chairQuantity, 10) || 0) : 0;
        if (nbChairs > 0) {
          const select = document.getElementById('chair-color');
          addItem(variantFromColorSelect(select, cv.chairColors, cv.step11Artificial), nbChairs);
        }
      }

      // Accessoires stabilisés
      document.querySelectorAll('.step12-accessories-option.selected').forEach(function(el) {
        const accessoryId = el.getAttribute('data-accessory-id');
        const qtyInput = el.querySelector('#accessory-quantity-' + accessoryId)
          || el.querySelector('.quantity-input[data-accessory-id="' + accessoryId + '"]');
        const qty = parseInt(qtyInput && qtyInput.value, 10) || 0;
        if (qty <= 0) return;
        const titleEl = el.querySelector('.table-honneur-title');
        const accessoryTitle = titleEl ? titleEl.textContent.trim() : '';
        const colorSelect = el.querySelector('.accessories-color-select');
        const colorName = colorSelect ? colorSelect.value : '';
        const mapKey = accessoryTitle && colorName
          ? (accessoryTitle + '|' + colorName)
          : colorName;
        const vid = lookupCartMap(cv.accessoryColors, mapKey, accessoryId)
          || (colorSelect ? variantFromColorSelect(colorSelect, cv.accessoryColors, '') : '');
        addItem(vid, qty);
      });

      // Bottes supplémentaires (étape 16)
      document.querySelectorAll('.flowers-variety-item').forEach(function(card) {
        const varietyId = card.getAttribute('data-variety-id');
        const qtyEl = card.querySelector('.flower-variety-bundles-value');
        const qty = parseInt(qtyEl && qtyEl.textContent, 10) || 0;
        if (qty <= 0) return;
        const nameEl = card.querySelector('.flower-variety-name');
        const name = nameEl ? nameEl.textContent.trim() : '';
        addItem(lookupCartMap(cv.flowers, name, varietyId), qty);
      });

      return Array.from(itemsMap.values());
    }

    function updateCartButtonState() {
      const btn = document.getElementById('add-to-cart-btn');
      if (!btn) return;
      const items = buildQuestionnaireCartItems();
      const hasItems = items.length > 0;
      btn.disabled = !hasItems;
      btn.setAttribute('aria-disabled', hasItems ? 'false' : 'true');
    }

    async function handleAddQuestionnaireToCart() {
      const btn = document.getElementById('add-to-cart-btn');
      if (!btn || btn.disabled) return;

      const itemsToResolve = buildQuestionnaireCartItems();
      if (!itemsToResolve.length) {
        alert('Aucun produit ne peut être ajouté au panier : complétez le champ « Panier — mapping variantes (JSON) » dans les réglages de la section Questionnaire (étape 18).');
        return;
      }

      const routesObj = (typeof window.routes !== 'undefined' && window.routes) ? window.routes : {};
      const cartUrl = routesObj.cart_add_url || '/cart/add.js';
      const cartBubble = document.querySelector('cart-dropdown-bubble');
      const originalText = btn.textContent;

      btn.classList.add('loading');
      btn.disabled = true;
      btn.setAttribute('aria-disabled', 'true');
      btn.textContent = 'Ajout au panier...';

      try {
        const items = await resolveQuestionnaireCartItems(itemsToResolve);
        if (!items.length) {
          alert('Aucun produit ne peut être ajouté au panier : les handles/variantes configurés sont introuvables dans Shopify.');
          return;
        }

        const bodyObj = { items: items };
        if (cartBubble && typeof cartBubble.getSectionsToRender === 'function') {
          try {
            bodyObj.sections = cartBubble.getSectionsToRender().map(function(s) { return s.id; });
            bodyObj.sections_url = window.location.pathname;
          } catch (e) { /* ignore */ }
        }

        const response = await fetch(cartUrl, {
          method: 'POST',
          headers: {
            'Content-Type': 'application/json',
            'Accept': 'application/javascript',
            'X-Requested-With': 'XMLHttpRequest'
          },
          body: JSON.stringify(bodyObj)
        });
        const data = await response.json();

        if (data.status) {
          const msg = data.description || data.message || 'Impossible d\'ajouter au panier.';
          if (cartBubble && typeof cartBubble.renderError === 'function') {
            cartBubble.renderError(msg);
          } else {
            alert(msg);
          }
          return;
        }

        clearSummarySnapshot();

        if (cartBubble && typeof cartBubble.renderContents === 'function') {
          if (items.length === 1) data.quantityItem = items[0].quantity;
          cartBubble.renderContents(data);
        }

        if (window.cartAjax && typeof openCartModal === 'function') {
          openCartModal();
        } else {
          window.location.href = routesObj.cart_url || '/cart';
        }
      } catch (err) {
        console.error('Erreur ajout panier questionnaire:', err);
        alert('Une erreur est survenue lors de l\'ajout au panier. Veuillez réessayer.');
      } finally {
        btn.classList.remove('loading');
        btn.textContent = originalText;
        updateCartButtonState();
      }
    }

    safeAddEventListener(getElement('add-to-cart-btn'), 'click', function(e) {
      e.preventDefault();
      handleAddQuestionnaireToCart();
    });
    safeAddEventListener(document, 'questionnaire:cartVariantsLoaded', updateCartButtonState);
  });
